export const skills = [
	{
		"id" : 1171,
		"name" : "Axios"
	},
	{
		"id" : 1172,
		"name" : "Material-UI"
	},
	{
		"id" : 1173,
		"name" : "NgRx"
	},
	{
		"id" : 1174,
		"name" : "AppRun"
	},
	{
		"id" : 1175,
		"name" : "SSR"
	},
	{
		"id" : 1176,
		"name" : "Angular Universal"
	},
	{
		"id" : 1177,
		"name" : "Styled Components"
	},
	{
		"id" : 1178,
		"name" : "Storybook"
	},
	{
		"id" : 1179,
		"name" : "TypeORM"
	},
	{
		"id" : 1180,
		"name" : "Rollup"
	},
	{
		"id" : 1181,
		"name" : "WebGPU"
	},
	{
		"id" : 1183,
		"name" : "CSS animations"
	},
	{
		"id" : 1285,
		"name" : "SAML"
	},
	{
		"id" : 1187,
		"name" : "Angular 2"
	},
	{
		"id" : 1188,
		"name" : "AngularFire"
	},
	{
		"id" : 1189,
		"name" : "Angular CLI"
	},
	{
		"id" : 1190,
		"name" : "Ant Design"
	},
	{
		"id" : 1191,
		"name" : "Atom"
	},
	{
		"id" : 1192,
		"name" : "Aurelia"
	},
	{
		"id" : 1193,
		"name" : "Babel"
	},
	{
		"id" : 1194,
		"name" : "BabylonJS"
	},
	{
		"id" : 1195,
		"name" : "Backbone.js"
	},
	{
		"id" : 1196,
		"name" : "BEM"
	},
	{
		"id" : 1197,
		"name" : "Blaze"
	},
	{
		"id" : 1199,
		"name" : "Bourbon"
	},
	{
		"id" : 1200,
		"name" : "Bower"
	},
	{
		"id" : 1201,
		"name" : "Brackets"
	},
	{
		"id" : 1202,
		"name" : "Broccoli"
	},
	{
		"id" : 1203,
		"name" : "Browserify"
	},
	{
		"id" : 1204,
		"name" : "Brunch"
	},
	{
		"id" : 1205,
		"name" : "CanvasJS"
	},
	{
		"id" : 1206,
		"name" : "Chart.js"
	},
	{
		"id" : 1207,
		"name" : "ClojureScript"
	},
	{
		"id" : 1208,
		"name" : "Compass"
	},
	{
		"id" : 1209,
		"name" : "Core.js"
	},
	{
		"id" : 1210,
		"name" : "CSS Modules"
	},
	{
		"id" : 1211,
		"name" : "CSS Preprocessor"
	},
	{
		"id" : 1212,
		"name" : "CSS-related"
	},
	{
		"id" : 1213,
		"name" : "Cypress"
	},
	{
		"id" : 1214,
		"name" : "DHTML"
	},
	{
		"id" : 1215,
		"name" : "Dojo"
	},
	{
		"id" : 1216,
		"name" : "DOM"
	},
	{
		"id" : 1217,
		"name" : "Dust.js"
	},
	{
		"id" : 1218,
		"name" : "ECMAScript"
	},
	{
		"id" : 1604,
		"name" : "BeeWare"
	},
	{
		"id" : 1220,
		"name" : "Ember.js"
	},
	{
		"id" : 1221,
		"name" : "ESLint"
	},
	{
		"id" : 1495,
		"name" : "JPA"
	},
	{
		"id" : 1223,
		"name" : "Flexbox"
	},
	{
		"id" : 1224,
		"name" : "Flux"
	},
	{
		"id" : 1225,
		"name" : "Foundation"
	},
	{
		"id" : 1226,
		"name" : "Front-end"
	},
	{
		"id" : 1227,
		"name" : "GraphQL"
	},
	{
		"id" : 1228,
		"name" : "Grunt"
	},
	{
		"id" : 1229,
		"name" : "GSAP"
	},
	{
		"id" : 1230,
		"name" : "Gulp"
	},
	{
		"id" : 1232,
		"name" : "Handlebars.js"
	},
	{
		"id" : 1233,
		"name" : "Highcharts"
	},
	{
		"id" : 1234,
		"name" : "HTML4"
	},
	{
		"id" : 1236,
		"name" : "Zurb"
	},
	{
		"id" : 1237,
		"name" : "Bootstap"
	},
	{
		"id" : 1238,
		"name" : "Canvas"
	},
	{
		"id" : 1239,
		"name" : "WebGL"
	},
	{
		"id" : 1241,
		"name" : "Hyper-V"
	},
	{
		"id" : 1242,
		"name" : "Immutable.js"
	},
	{
		"id" : 1243,
		"name" : "Infragistics"
	},
	{
		"id" : 1244,
		"name" : "Isomorphic apps"
	},
	{
		"id" : 1245,
		"name" : "JavaScript frameworks"
	},
	{
		"id" : 4516,
		"name" : "Shopify"
	},
	{
		"id" : 1247,
		"name" : "Backbone"
	},
	{
		"id" : 1248,
		"name" : "Knockout.js"
	},
	{
		"id" : 1249,
		"name" : "D3.js"
	},
	{
		"id" : 1251,
		"name" : "Mercury.js"
	},
	{
		"id" : 1252,
		"name" : "​WebRx"
	},
	{
		"id" : 1254,
		"name" : "JFace"
	},
	{
		"id" : 1256,
		"name" : "jQuery UI"
	},
	{
		"id" : 1257,
		"name" : "JSS"
	},
	{
		"id" : 1258,
		"name" : "JSX"
	},
	{
		"id" : 1259,
		"name" : "Kendo"
	},
	{
		"id" : 1260,
		"name" : "Knockout"
	},
	{
		"id" : 1261,
		"name" : "Leaflet"
	},
	{
		"id" : 1263,
		"name" : "Marionette"
	},
	{
		"id" : 1264,
		"name" : "Masonry"
	},
	{
		"id" : 1265,
		"name" : "Mercury"
	},
	{
		"id" : 1266,
		"name" : "MobX"
	},
	{
		"id" : 1267,
		"name" : "Modernizr"
	},
	{
		"id" : 1268,
		"name" : "Mustache"
	},
	{
		"id" : 1269,
		"name" : "Nunjucks"
	},
	{
		"id" : 1270,
		"name" : "NVD3"
	},
	{
		"id" : 1271,
		"name" : "OOCSS"
	},
	{
		"id" : 1272,
		"name" : "PaperJS"
	},
	{
		"id" : 1273,
		"name" : "PixiJS"
	},
	{
		"id" : 1274,
		"name" : "Polymer"
	},
	{
		"id" : 1275,
		"name" : "PostCSS"
	},
	{
		"id" : 1276,
		"name" : "PrimeNG"
	},
	{
		"id" : 1277,
		"name" : "Prototype"
	},
	{
		"id" : 1279,
		"name" : "Redux"
	},
	{
		"id" : 1281,
		"name" : "Relay"
	},
	{
		"id" : 1282,
		"name" : "Rematch"
	},
	{
		"id" : 1283,
		"name" : "RequireJS"
	},
	{
		"id" : 1284,
		"name" : "RxJS"
	},
	{
		"id" : 1287,
		"name" : "SCSS"
	},
	{
		"id" : 1288,
		"name" : "Skeleton"
	},
	{
		"id" : 1289,
		"name" : "Socket.IO"
	},
	{
		"id" : 1290,
		"name" : "Spine JS"
	},
	{
		"id" : 1292,
		"name" : "Sublime Text"
	},
	{
		"id" : 1293,
		"name" : "Three.js"
	},
	{
		"id" : 1294,
		"name" : "Thunk"
	},
	{
		"id" : 1295,
		"name" : "Turret"
	},
	{
		"id" : 1297,
		"name" : "Underscore.js"
	},
	{
		"id" : 1298,
		"name" : "Vanilla JS"
	},
	{
		"id" : 1299,
		"name" : "Vue"
	},
	{
		"id" : 1300,
		"name" : "Vuex"
	},
	{
		"id" : 1301,
		"name" : "WebdriverIO"
	},
	{
		"id" : 1302,
		"name" : "WebKit"
	},
	{
		"id" : 1303,
		"name" : "webpack"
	},
	{
		"id" : 1304,
		"name" : "WebRx"
	},
	{
		"id" : 4517,
		"name" : "Blue Prism"
	},
	{
		"id" : 1305,
		"name" : "WebSphere"
	},
	{
		"id" : 1306,
		"name" : "WebStorm"
	},
	{
		"id" : 1307,
		"name" : "WinForms"
	},
	{
		"id" : 1310,
		"name" : "YAML"
	},
	{
		"id" : 1340,
		"name" : "APC"
	},
	{
		"id" : 1308,
		"name" : "WSDL"
	},
	{
		"id" : 1198,
		"name" : "Bootstrap"
	},
	{
		"id" : 1321,
		"name" : "asm.js"
	},
	{
		"id" : 1286,
		"name" : "Sass"
	},
	{
		"id" : 1280,
		"name" : "redux-saga"
	},
	{
		"id" : 1309,
		"name" : "XHTML"
	},
	{
		"id" : 1312,
		"name" : "C# (.NET)"
	},
	{
		"id" : 1240,
		"name" : "HTMLPad"
	},
	{
		"id" : 1231,
		"name" : "Haml"
	},
	{
		"id" : 1253,
		"name" : "Vue.js​"
	},
	{
		"id" : 1182,
		"name" : "Svelte"
	},
	{
		"id" : 3520,
		"name" : "SAP-PP"
	},
	{
		"id" : 1185,
		"name" : "AMP"
	},
	{
		"id" : 1550,
		"name" : "ASP.NET"
	},
	{
		"id" : 1728,
		"name" : "Assembly language"
	},
	{
		"id" : 1603,
		"name" : "asyncio"
	},
	{
		"id" : 1341,
		"name" : "Bitrix Framework"
	},
	{
		"id" : 1342,
		"name" : "Blackfire"
	},
	{
		"id" : 1686,
		"name" : "BlueEyes"
	},
	{
		"id" : 1605,
		"name" : "Bokeh"
	},
	{
		"id" : 1644,
		"name" : "Boost"
	},
	{
		"id" : 1326,
		"name" : "Hapi"
	},
	{
		"id" : 1606,
		"name" : "Bottle"
	},
	{
		"id" : 1394,
		"name" : "Brakeman"
	},
	{
		"id" : 1708,
		"name" : "Buffalo"
	},
	{
		"id" : 1395,
		"name" : "Bundler"
	},
	{
		"id" : 1430,
		"name" : "Burp Suite"
	},
	{
		"id" : 1333,
		"name" : "Oracle JET"
	},
	{
		"id" : 1334,
		"name" : "Restify"
	},
	{
		"id" : 3521,
		"name" : "SAP-MM"
	},
	{
		"id" : 1413,
		"name" : "Capistrano"
	},
	{
		"id" : 1396,
		"name" : "Capybara"
	},
	{
		"id" : 1338,
		"name" : "PHP CodeSniffer"
	},
	{
		"id" : 1687,
		"name" : "Cats"
	},
	{
		"id" : 1729,
		"name" : "CCL"
	},
	{
		"id" : 1433,
		"name" : "CDI"
	},
	{
		"id" : 1688,
		"name" : "Chaos"
	},
	{
		"id" : 1560,
		"name" : "Chart FX"
	},
	{
		"id" : 1608,
		"name" : "CherryPy"
	},
	{
		"id" : 1651,
		"name" : "Clang"
	},
	{
		"id" : 1348,
		"name" : "Guzzle"
	},
	{
		"id" : 1349,
		"name" : "HHVM"
	},
	{
		"id" : 1432,
		"name" : "ClearTK"
	},
	{
		"id" : 1652,
		"name" : "CLion"
	},
	{
		"id" : 1718,
		"name" : "Clojure"
	},
	{
		"id" : 1561,
		"name" : "CLR"
	},
	{
		"id" : 1343,
		"name" : "CMS"
	},
	{
		"id" : 1730,
		"name" : "COBOL"
	},
	{
		"id" : 1344,
		"name" : "Codeception"
	},
	{
		"id" : 1366,
		"name" : "CodeIgniter"
	},
	{
		"id" : 1731,
		"name" : "CoffeeScript"
	},
	{
		"id" : 1689,
		"name" : "Colossus"
	},
	{
		"id" : 1372,
		"name" : "Composer"
	},
	{
		"id" : 1363,
		"name" : "PHP frameworks"
	},
	{
		"id" : 3522,
		"name" : "SAP-SD"
	},
	{
		"id" : 1653,
		"name" : "Cppcheck"
	},
	{
		"id" : 1367,
		"name" : "PHP keywords"
	},
	{
		"id" : 1368,
		"name" : "Twig (templating)"
	},
	{
		"id" : 1369,
		"name" : "PHPUnit (testing)"
	},
	{
		"id" : 1371,
		"name" : "PHPStorm (IDE)"
	},
	{
		"id" : 1654,
		"name" : "CppDB"
	},
	{
		"id" : 1373,
		"name" : "PHP-FIG"
	},
	{
		"id" : 1374,
		"name" : "PHP-FPM"
	},
	{
		"id" : 1375,
		"name" : "phpDocumentor"
	},
	{
		"id" : 1376,
		"name" : "PHPSpec"
	},
	{
		"id" : 1377,
		"name" : "PhpStorm"
	},
	{
		"id" : 1609,
		"name" : "CPython"
	},
	{
		"id" : 1397,
		"name" : "Crystal"
	},
	{
		"id" : 1473,
		"name" : "Cucumber"
	},
	{
		"id" : 1679,
		"name" : "CUDA"
	},
	{
		"id" : 1322,
		"name" : "Cycle.js"
	},
	{
		"id" : 1732,
		"name" : "Cypher"
	},
	{
		"id" : 1733,
		"name" : "Dart"
	},
	{
		"id" : 1610,
		"name" : "Dask"
	},
	{
		"id" : 1734,
		"name" : "Delphi"
	},
	{
		"id" : 1320,
		"name" : "Deno"
	},
	{
		"id" : 1323,
		"name" : "Derby"
	},
	{
		"id" : 1345,
		"name" : "Doctrine"
	},
	{
		"id" : 1613,
		"name" : "Docutils"
	},
	{
		"id" : 1393,
		"name" : "Active Record"
	},
	{
		"id" : 1434,
		"name" : "Dropwizard"
	},
	{
		"id" : 1346,
		"name" : "Drupal"
	},
	{
		"id" : 1339,
		"name" : "Drush"
	},
	{
		"id" : 1435,
		"name" : "DWR"
	},
	{
		"id" : 1471,
		"name" : "EasyMock"
	},
	{
		"id" : 1709,
		"name" : "Echo"
	},
	{
		"id" : 1436,
		"name" : "EclipseLink"
	},
	{
		"id" : 1437,
		"name" : "Ehcache"
	},
	{
		"id" : 1262,
		"name" : "LESS"
	},
	{
		"id" : 1419,
		"name" : "Core Java"
	},
	{
		"id" : 1315,
		"name" : "Functional Programming (FP)"
	},
	{
		"id" : 1611,
		"name" : "Django"
	},
	{
		"id" : 1409,
		"name" : "RubyGems"
	},
	{
		"id" : 1410,
		"name" : "Ruby Arrays"
	},
	{
		"id" : 1411,
		"name" : "Ruby deployment"
	},
	{
		"id" : 1370,
		"name" : "Doctrine (ORM)"
	},
	{
		"id" : 1250,
		"name" : "Sencha"
	},
	{
		"id" : 1414,
		"name" : "Ruby frameworks"
	},
	{
		"id" : 1747,
		"name" : "Accelerate framework"
	},
	{
		"id" : 1748,
		"name" : "AFNetworking"
	},
	{
		"id" : 1749,
		"name" : "Alamofire"
	},
	{
		"id" : 1750,
		"name" : "APNs"
	},
	{
		"id" : 1425,
		"name" : "ADF"
	},
	{
		"id" : 1454,
		"name" : "Ant"
	},
	{
		"id" : 1429,
		"name" : "Apollo"
	},
	{
		"id" : 1553,
		"name" : "Autofac"
	},
	{
		"id" : 1554,
		"name" : "AutoMapper"
	},
	{
		"id" : 1465,
		"name" : "EJB"
	},
	{
		"id" : 1422,
		"name" : "JBDC"
	},
	{
		"id" : 1423,
		"name" : "Java Profiler"
	},
	{
		"id" : 1424,
		"name" : "ActiveMQ"
	},
	{
		"id" : 1426,
		"name" : "Apache Ant"
	},
	{
		"id" : 1427,
		"name" : "Apache Camel"
	},
	{
		"id" : 1428,
		"name" : "Apache MINA"
	},
	{
		"id" : 1719,
		"name" : "Elixir"
	},
	{
		"id" : 1431,
		"name" : "Cactus "
	},
	{
		"id" : 1720,
		"name" : "Elm"
	},
	{
		"id" : 1562,
		"name" : "F#"
	},
	{
		"id" : 1438,
		"name" : "Facelets"
	},
	{
		"id" : 1400,
		"name" : "FactoryBot"
	},
	{
		"id" : 1337,
		"name" : "FeathersJS"
	},
	{
		"id" : 1690,
		"name" : "Finatra"
	},
	{
		"id" : 1691,
		"name" : "Finch"
	},
	{
		"id" : 1325,
		"name" : "Flow"
	},
	{
		"id" : 1439,
		"name" : "FreeMarker"
	},
	{
		"id" : 1347,
		"name" : "Gearman"
	},
	{
		"id" : 1440,
		"name" : "GemFire"
	},
	{
		"id" : 1710,
		"name" : "Gin"
	},
	{
		"id" : 1444,
		"name" : "Guava"
	},
	{
		"id" : 1445,
		"name" : "GWT"
	},
	{
		"id" : 1457,
		"name" : "GlassFish"
	},
	{
		"id" : 1655,
		"name" : "GLSL"
	},
	{
		"id" : 1712,
		"name" : "GoLand"
	},
	{
		"id" : 1441,
		"name" : "Google Guice"
	},
	{
		"id" : 1713,
		"name" : "Gorilla"
	},
	{
		"id" : 1656,
		"name" : "gperf"
	},
	{
		"id" : 1453,
		"name" : "Java build tools"
	},
	{
		"id" : 1455,
		"name" : "Gradle"
	},
	{
		"id" : 1456,
		"name" : "Java deployment"
	},
	{
		"id" : 1442,
		"name" : "Grails"
	},
	{
		"id" : 1458,
		"name" : "Java EE"
	},
	{
		"id" : 1459,
		"name" : "Java EE frameworks"
	},
	{
		"id" : 1401,
		"name" : "Grape"
	},
	{
		"id" : 1443,
		"name" : "Groovy"
	},
	{
		"id" : 1446,
		"name" : "Hybris"
	},
	{
		"id" : 1545,
		"name" : "IdentityServer"
	},
	{
		"id" : 1723,
		"name" : "Idris"
	},
	{
		"id" : 4081,
		"name" : "IIS Server"
	},
	{
		"id" : 1460,
		"name" : "Servlets"
	},
	{
		"id" : 1447,
		"name" : "IntelliJ IDEA"
	},
	{
		"id" : 1462,
		"name" : "Java ME"
	},
	{
		"id" : 1463,
		"name" : "Java ORM frameworks"
	},
	{
		"id" : 1714,
		"name" : "Iris"
	},
	{
		"id" : 1466,
		"name" : "Java SE"
	},
	{
		"id" : 1467,
		"name" : "Java SE frameworks"
	},
	{
		"id" : 1468,
		"name" : "Java testing tools"
	},
	{
		"id" : 1474,
		"name" : "JavaCC"
	},
	{
		"id" : 1475,
		"name" : "JavaFX"
	},
	{
		"id" : 1476,
		"name" : "JAXB"
	},
	{
		"id" : 1477,
		"name" : "JAX-RS"
	},
	{
		"id" : 1478,
		"name" : "JAX-WS"
	},
	{
		"id" : 1479,
		"name" : "JBoss"
	},
	{
		"id" : 1482,
		"name" : "JDeferred"
	},
	{
		"id" : 1483,
		"name" : "JDeveloper"
	},
	{
		"id" : 1448,
		"name" : "JAAS"
	},
	{
		"id" : 1449,
		"name" : "Jackson"
	},
	{
		"id" : 1450,
		"name" : "JADE"
	},
	{
		"id" : 1461,
		"name" : "JAF"
	},
	{
		"id" : 1451,
		"name" : "JasperReports"
	},
	{
		"id" : 1489,
		"name" : "JMC"
	},
	{
		"id" : 1490,
		"name" : "JMM"
	},
	{
		"id" : 1491,
		"name" : "JMock"
	},
	{
		"id" : 1492,
		"name" : "JMS"
	},
	{
		"id" : 1493,
		"name" : "JMX"
	},
	{
		"id" : 1494,
		"name" : "JNI"
	},
	{
		"id" : 3611,
		"name" : "Java8"
	},
	{
		"id" : 1484,
		"name" : "JDK"
	},
	{
		"id" : 1402,
		"name" : "Jekyll"
	},
	{
		"id" : 1485,
		"name" : "Jersey"
	},
	{
		"id" : 1486,
		"name" : "Jetty"
	},
	{
		"id" : 1487,
		"name" : "JFlex"
	},
	{
		"id" : 1488,
		"name" : "JFR"
	},
	{
		"id" : 1614,
		"name" : "Jinja2"
	},
	{
		"id" : 1350,
		"name" : "Joomla"
	},
	{
		"id" : 1496,
		"name" : "JPQL"
	},
	{
		"id" : 1497,
		"name" : "JRE"
	},
	{
		"id" : 1418,
		"name" : "JRuby"
	},
	{
		"id" : 4083,
		"name" : "JSOM"
	},
	{
		"id" : 1499,
		"name" : "JSoup"
	},
	{
		"id" : 1502,
		"name" : "JUnit"
	},
	{
		"id" : 1503,
		"name" : "JVM"
	},
	{
		"id" : 1563,
		"name" : "Kentico"
	},
	{
		"id" : 1504,
		"name" : "KeyStore"
	},
	{
		"id" : 1626,
		"name" : "Kivy"
	},
	{
		"id" : 1327,
		"name" : "Koa"
	},
	{
		"id" : 1351,
		"name" : "Kohana"
	},
	{
		"id" : 1681,
		"name" : "Kore"
	},
	{
		"id" : 1519,
		"name" : "RESTEasy"
	},
	{
		"id" : 1506,
		"name" : "Lambda"
	},
	{
		"id" : 1352,
		"name" : "LAMP"
	},
	{
		"id" : 1507,
		"name" : "Launch4j"
	},
	{
		"id" : 1481,
		"name" : "JDBC"
	},
	{
		"id" : 1356,
		"name" : "Memcached"
	},
	{
		"id" : 1526,
		"name" : "Spring Boot"
	},
	{
		"id" : 1527,
		"name" : "Spring Integration"
	},
	{
		"id" : 3577,
		"name" : "GIT"
	},
	{
		"id" : 1529,
		"name" : "Spring WebFlux"
	},
	{
		"id" : 1525,
		"name" : "Spring"
	},
	{
		"id" : 1505,
		"name" : "Kotlin"
	},
	{
		"id" : 1532,
		"name" : "Struts 2"
	},
	{
		"id" : 1498,
		"name" : "JSF"
	},
	{
		"id" : 1548,
		"name" : ".NET"
	},
	{
		"id" : 4518,
		"name" : "UiPath"
	},
	{
		"id" : 1642,
		"name" : "ACE"
	},
	{
		"id" : 3620,
		"name" : "Apache"
	},
	{
		"id" : 1555,
		"name" : "C#"
	},
	{
		"id" : 3584,
		"name" : "Kafka"
	},
	{
		"id" : 4142,
		"name" : "Neural Networks"
	},
	{
		"id" : 3523,
		"name" : "SAP-HR"
	},
	{
		"id" : 3524,
		"name" : "SAP-CRM"
	},
	{
		"id" : 1544,
		"name" : "ASP.NET Web Forms"
	},
	{
		"id" : 3525,
		"name" : "SAP-ABAP"
	},
	{
		"id" : 1546,
		"name" : "ASP.NET Web API"
	},
	{
		"id" : 1547,
		"name" : "ASP.NET AJAX\/Atlas"
	},
	{
		"id" : 3526,
		"name" : "SAP-XI"
	},
	{
		"id" : 3527,
		"name" : "SAP-Net Viewer"
	},
	{
		"id" : 1551,
		"name" : "ASP.NET Core"
	},
	{
		"id" : 1552,
		"name" : "ASP.NET MVC"
	},
	{
		"id" : 3528,
		"name" : "SAP-BASIS"
	},
	{
		"id" : 3529,
		"name" : "SAP-BIW"
	},
	{
		"id" : 3530,
		"name" : "SAP-GRC Consultant"
	},
	{
		"id" : 1557,
		"name" : ".NET 1.0"
	},
	{
		"id" : 1558,
		"name" : ".NET 4.5"
	},
	{
		"id" : 1559,
		"name" : "C# testing tools"
	},
	{
		"id" : 3531,
		"name" : "Business Objects Report Designer"
	},
	{
		"id" : 3532,
		"name" : "SAP-HANA"
	},
	{
		"id" : 3533,
		"name" : "SAP-Security Administrator"
	},
	{
		"id" : 4519,
		"name" : "UI Automation"
	},
	{
		"id" : 1993,
		"name" : "Linux"
	},
	{
		"id" : 3565,
		"name" : "Networking"
	},
	{
		"id" : 3616,
		"name" : "Web Architecture"
	},
	{
		"id" : 3618,
		"name" : "NPM"
	},
	{
		"id" : 3619,
		"name" : "Varnish"
	},
	{
		"id" : 3622,
		"name" : "Scrum"
	},
	{
		"id" : 3623,
		"name" : "Hibernate and JPA"
	},
	{
		"id" : 1572,
		"name" : ".NET Core"
	},
	{
		"id" : 3632,
		"name" : "RoR Stack"
	},
	{
		"id" : 3634,
		"name" : "WEBrick Server"
	},
	{
		"id" : 3635,
		"name" : "MS VB Script"
	},
	{
		"id" : 3636,
		"name" : "J2EE"
	},
	{
		"id" : 3638,
		"name" : "Vue.js"
	},
	{
		"id" : 1549,
		"name" : "Accord.NET Framework"
	},
	{
		"id" : 1586,
		"name" : "Roslyn (.NET Compiler Platform)"
	},
	{
		"id" : 1580,
		"name" : "Linq2SQL"
	},
	{
		"id" : 1615,
		"name" : "Jupyter (IPython)"
	},
	{
		"id" : 1751,
		"name" : "AppCode"
	},
	{
		"id" : 1752,
		"name" : "Auto Layout"
	},
	{
		"id" : 1753,
		"name" : "ARC"
	},
	{
		"id" : 1754,
		"name" : "ARKit"
	},
	{
		"id" : 1755,
		"name" : "AVFoundation"
	},
	{
		"id" : 1756,
		"name" : "Bond"
	},
	{
		"id" : 1757,
		"name" : "Carthage"
	},
	{
		"id" : 1758,
		"name" : "Clean Architecture (VIPER)"
	},
	{
		"id" : 1759,
		"name" : "Cocoa"
	},
	{
		"id" : 1760,
		"name" : "Cocoa Touch"
	},
	{
		"id" : 1761,
		"name" : "CocoaPods"
	},
	{
		"id" : 1763,
		"name" : "Core Bluetooth"
	},
	{
		"id" : 1764,
		"name" : "Core Data"
	},
	{
		"id" : 1765,
		"name" : "Core Graphics"
	},
	{
		"id" : 3547,
		"name" : "Cryptography"
	},
	{
		"id" : 3550,
		"name" : "Ethereum"
	},
	{
		"id" : 1602,
		"name" : "Django REST framework"
	},
	{
		"id" : 3551,
		"name" : "Blockchain Architecture"
	},
	{
		"id" : 1480,
		"name" : "jBPM"
	},
	{
		"id" : 1766,
		"name" : "Core Location"
	},
	{
		"id" : 1767,
		"name" : "CoreFoundation"
	},
	{
		"id" : 1768,
		"name" : "CoreImage"
	},
	{
		"id" : 1612,
		"name" : "Django Channels"
	},
	{
		"id" : 1625,
		"name" : "Python frameworks"
	},
	{
		"id" : 1769,
		"name" : "EventKit"
	},
	{
		"id" : 1780,
		"name" : "iOS SDK"
	},
	{
		"id" : 1781,
		"name" : "iOS tools"
	},
	{
		"id" : 1782,
		"name" : "MapKit"
	},
	{
		"id" : 1783,
		"name" : "Memory Graph Debugger"
	},
	{
		"id" : 4179,
		"name" : "Keras Framework"
	},
	{
		"id" : 1638,
		"name" : "Web2py"
	},
	{
		"id" : 4180,
		"name" : "Wamp"
	},
	{
		"id" : 4182,
		"name" : "Tensorflow Framework"
	},
	{
		"id" : 4185,
		"name" : "Computer Vision"
	},
	{
		"id" : 1784,
		"name" : "MessageUI"
	},
	{
		"id" : 1785,
		"name" : "Metal"
	},
	{
		"id" : 1645,
		"name" : "C++ 11"
	},
	{
		"id" : 1647,
		"name" : "C++ 14"
	},
	{
		"id" : 1648,
		"name" : "C++ 17"
	},
	{
		"id" : 1649,
		"name" : "C++ frameworks"
	},
	{
		"id" : 1786,
		"name" : "Moya framework"
	},
	{
		"id" : 1787,
		"name" : "Multitasking"
	},
	{
		"id" : 3671,
		"name" : "LWC"
	},
	{
		"id" : 1788,
		"name" : "Nimble"
	},
	{
		"id" : 1789,
		"name" : "NSOperation"
	},
	{
		"id" : 1791,
		"name" : "POP"
	},
	{
		"id" : 1792,
		"name" : "Property Lists"
	},
	{
		"id" : 1793,
		"name" : "Quick"
	},
	{
		"id" : 1794,
		"name" : "QuickBlox"
	},
	{
		"id" : 1795,
		"name" : "Reactive code"
	},
	{
		"id" : 1796,
		"name" : "ReactiveCocoa"
	},
	{
		"id" : 1798,
		"name" : "Realm"
	},
	{
		"id" : 1799,
		"name" : "RxSwift"
	},
	{
		"id" : 1800,
		"name" : "Stack Views"
	},
	{
		"id" : 1801,
		"name" : "StoreKit"
	},
	{
		"id" : 1727,
		"name" : "Ada"
	},
	{
		"id" : 1683,
		"name" : "Akka"
	},
	{
		"id" : 1677,
		"name" : "ANSI C"
	},
	{
		"id" : 1680,
		"name" : "Libmicrohttpd"
	},
	{
		"id" : 1657,
		"name" : "GStreamer"
	},
	{
		"id" : 1693,
		"name" : "Lift"
	},
	{
		"id" : 1564,
		"name" : "LINQ"
	},
	{
		"id" : 1508,
		"name" : "Log4j"
	},
	{
		"id" : 1565,
		"name" : "Log4net"
	},
	{
		"id" : 1658,
		"name" : "Loki"
	},
	{
		"id" : 1737,
		"name" : "Lua"
	},
	{
		"id" : 1664,
		"name" : "PwC (contract programming)"
	},
	{
		"id" : 1509,
		"name" : "Lucene"
	},
	{
		"id" : 1353,
		"name" : "Lumen"
	},
	{
		"id" : 1354,
		"name" : "Magento"
	},
	{
		"id" : 1355,
		"name" : "MAMP"
	},
	{
		"id" : 1738,
		"name" : "Maple"
	},
	{
		"id" : 1328,
		"name" : "MEAN"
	},
	{
		"id" : 1744,
		"name" : "Swinject"
	},
	{
		"id" : 1511,
		"name" : "MeshCMS"
	},
	{
		"id" : 1329,
		"name" : "Meteor"
	},
	{
		"id" : 1659,
		"name" : "MFC"
	},
	{
		"id" : 1421,
		"name" : "Micronaut"
	},
	{
		"id" : 3612,
		"name" : "Microservices"
	},
	{
		"id" : 1403,
		"name" : "Minitest"
	},
	{
		"id" : 1357,
		"name" : "Mockery"
	},
	{
		"id" : 1472,
		"name" : "Mockito"
	},
	{
		"id" : 1684,
		"name" : "Akka HTTP"
	},
	{
		"id" : 1685,
		"name" : "Apache Kafka"
	},
	{
		"id" : 1358,
		"name" : "MODX"
	},
	{
		"id" : 1682,
		"name" : "Monix"
	},
	{
		"id" : 1566,
		"name" : "Mono"
	},
	{
		"id" : 1567,
		"name" : "Moq"
	},
	{
		"id" : 1568,
		"name" : "MsBuild"
	},
	{
		"id" : 1569,
		"name" : "MS Dynamics 365"
	},
	{
		"id" : 1692,
		"name" : "http4s"
	},
	{
		"id" : 4085,
		"name" : "MS Office 365"
	},
	{
		"id" : 1694,
		"name" : "Lift 3.0-RC1"
	},
	{
		"id" : 1570,
		"name" : "MStest"
	},
	{
		"id" : 1696,
		"name" : "Play 2.5.0"
	},
	{
		"id" : 1697,
		"name" : "sbt"
	},
	{
		"id" : 1698,
		"name" : "SBT 0.13.12"
	},
	{
		"id" : 1359,
		"name" : "MySQLi"
	},
	{
		"id" : 1700,
		"name" : "Scala frameworks"
	},
	{
		"id" : 1701,
		"name" : "Scalatra"
	},
	{
		"id" : 1702,
		"name" : "Scalaz"
	},
	{
		"id" : 1571,
		"name" : "Nancy"
	},
	{
		"id" : 1317,
		"name" : "NestJS"
	},
	{
		"id" : 1745,
		"name" : "GHUnit"
	},
	{
		"id" : 1512,
		"name" : "Netty"
	},
	{
		"id" : 1330,
		"name" : "Next"
	},
	{
		"id" : 1573,
		"name" : "Ninject"
	},
	{
		"id" : 4087,
		"name" : "Nintex Forms"
	},
	{
		"id" : 1574,
		"name" : "NuGet"
	},
	{
		"id" : 1319,
		"name" : "NW.js"
	},
	{
		"id" : 1513,
		"name" : "OC4J"
	},
	{
		"id" : 1724,
		"name" : "OCaml"
	},
	{
		"id" : 1716,
		"name" : "Absinthe"
	},
	{
		"id" : 1360,
		"name" : "OpenCart"
	},
	{
		"id" : 1660,
		"name" : "OpenCL"
	},
	{
		"id" : 1661,
		"name" : "OpenGL Mathematics"
	},
	{
		"id" : 1662,
		"name" : "OpenInventor"
	},
	{
		"id" : 1722,
		"name" : "Haskell"
	},
	{
		"id" : 1332,
		"name" : "OpenLayers"
	},
	{
		"id" : 1510,
		"name" : "Maven"
	},
	{
		"id" : 1577,
		"name" : "ORM frameworks"
	},
	{
		"id" : 1726,
		"name" : "ActionScript"
	},
	{
		"id" : 1514,
		"name" : "OSGi"
	},
	{
		"id" : 1582,
		"name" : "OWIN"
	},
	{
		"id" : 1417,
		"name" : "Padrino"
	},
	{
		"id" : 1412,
		"name" : "Passenger"
	},
	{
		"id" : 1361,
		"name" : "Phalcon"
	},
	{
		"id" : 1746,
		"name" : "3D Touch"
	},
	{
		"id" : 1735,
		"name" : "Hack"
	},
	{
		"id" : 1736,
		"name" : "Haxe"
	},
	{
		"id" : 2094,
		"name" : "Sanity testing"
	},
	{
		"id" : 2095,
		"name" : "Security testing"
	},
	{
		"id" : 2100,
		"name" : "Smoke Testing"
	},
	{
		"id" : 1578,
		"name" : "NHibernate"
	},
	{
		"id" : 1575,
		"name" : "NUnit"
	},
	{
		"id" : 1616,
		"name" : "matplotlib"
	},
	{
		"id" : 1576,
		"name" : "Octopus"
	},
	{
		"id" : 1739,
		"name" : "Perl"
	},
	{
		"id" : 4464,
		"name" : "DevSecOps"
	},
	{
		"id" : 4465,
		"name" : "OAuth"
	},
	{
		"id" : 4466,
		"name" : "OIDC"
	},
	{
		"id" : 4467,
		"name" : "MFA"
	},
	{
		"id" : 4468,
		"name" : "JIT"
	},
	{
		"id" : 4469,
		"name" : "RBAC"
	},
	{
		"id" : 4470,
		"name" : "Ping"
	},
	{
		"id" : 4471,
		"name" : "SIEM"
	},
	{
		"id" : 4156,
		"name" : "R"
	},
	{
		"id" : 4479,
		"name" : "SQL Analytics"
	},
	{
		"id" : 4480,
		"name" : "Data Lake Analytics"
	},
	{
		"id" : 4483,
		"name" : "Waterfall"
	},
	{
		"id" : 4484,
		"name" : "Iterative"
	},
	{
		"id" : 4485,
		"name" : "TOGAF"
	},
	{
		"id" : 4486,
		"name" : "Pivotal"
	},
	{
		"id" : 1762,
		"name" : "Core Animation"
	},
	{
		"id" : 4487,
		"name" : "CISSIP"
	},
	{
		"id" : 4488,
		"name" : "Zachman"
	},
	{
		"id" : 4489,
		"name" : "ITIL"
	},
	{
		"id" : 4490,
		"name" : "Cisco"
	},
	{
		"id" : 4491,
		"name" : "(ISC)2"
	},
	{
		"id" : 4520,
		"name" : "Machine Learning"
	},
	{
		"id" : 4521,
		"name" : "Artificial Intelligence"
	},
	{
		"id" : 1775,
		"name" : "In APP purchase"
	},
	{
		"id" : 1404,
		"name" : "Phoenix"
	},
	{
		"id" : 4492,
		"name" : "CEH"
	},
	{
		"id" : 4493,
		"name" : "SAFe"
	},
	{
		"id" : 4494,
		"name" : "PMI"
	},
	{
		"id" : 4495,
		"name" : "Activity Diagram"
	},
	{
		"id" : 4496,
		"name" : "Class Diagram"
	},
	{
		"id" : 4497,
		"name" : "Solutions Architecture Consultation"
	},
	{
		"id" : 4498,
		"name" : "Sequence Diagram"
	},
	{
		"id" : 4499,
		"name" : "Apache Tomcat"
	},
	{
		"id" : 4500,
		"name" : "Cloud Computing"
	},
	{
		"id" : 4501,
		"name" : "Elasticsearch"
	},
	{
		"id" : 4502,
		"name" : "Microsoft IIS"
	},
	{
		"id" : 4503,
		"name" : "Online Transaction Processing (OLTP)"
	},
	{
		"id" : 4504,
		"name" : "RESTful"
	},
	{
		"id" : 4505,
		"name" : "UML"
	},
	{
		"id" : 4506,
		"name" : "Web Servers"
	},
	{
		"id" : 4507,
		"name" : "State Diagram"
	},
	{
		"id" : 1797,
		"name" : "ReactiveKit"
	},
	{
		"id" : 4513,
		"name" : "Power Apps"
	},
	{
		"id" : 4514,
		"name" : "Power Virtual Agents"
	},
	{
		"id" : 4515,
		"name" : "Power Automate"
	},
	{
		"id" : 1929,
		"name" : "Neo4j"
	},
	{
		"id" : 1170,
		"name" : "JavaScript"
	},
	{
		"id" : 1960,
		"name" : "SQL Server"
	},
	{
		"id" : 3585,
		"name" : "Cosmos"
	},
	{
		"id" : 3647,
		"name" : "SAP"
	},
	{
		"id" : 1836,
		"name" : "greenDAO"
	},
	{
		"id" : 4522,
		"name" : "Azure Data Factory (ADF)"
	},
	{
		"id" : 4523,
		"name" : "Sitecore Framework"
	},
	{
		"id" : 1815,
		"name" : "Android keywords"
	},
	{
		"id" : 1843,
		"name" : "Reactive pattern"
	},
	{
		"id" : 1860,
		"name" : "Cross-platform Mobile (mostly JavaScript)"
	},
	{
		"id" : 1867,
		"name" : "Ionic"
	},
	{
		"id" : 1878,
		"name" : "Xamarin Studio"
	},
	{
		"id" : 1879,
		"name" : "Xamarin.Forms"
	},
	{
		"id" : 1880,
		"name" : "Mobile applications"
	},
	{
		"id" : 1770,
		"name" : "Fabric"
	},
	{
		"id" : 1771,
		"name" : "FastLane"
	},
	{
		"id" : 1772,
		"name" : "Flurry"
	},
	{
		"id" : 1774,
		"name" : "HockeyApp"
	},
	{
		"id" : 1777,
		"name" : "iOS 10 Speech Recognition API"
	},
	{
		"id" : 1779,
		"name" : "iOS programming languages"
	},
	{
		"id" : 1883,
		"name" : "ClickHouse"
	},
	{
		"id" : 1884,
		"name" : "ScyllaDB"
	},
	{
		"id" : 1969,
		"name" : "SaaS"
	},
	{
		"id" : 1970,
		"name" : "IaaS"
	},
	{
		"id" : 1971,
		"name" : "PaaS"
	},
	{
		"id" : 1995,
		"name" : "Hadoop"
	},
	{
		"id" : 1968,
		"name" : "Cloud Database Engineer"
	},
	{
		"id" : 1974,
		"name" : "Data Analysis"
	},
	{
		"id" : 1980,
		"name" : "Authorizations"
	},
	{
		"id" : 1981,
		"name" : "Protocols"
	},
	{
		"id" : 1983,
		"name" : "Google Cloud Associate"
	},
	{
		"id" : 1984,
		"name" : "Solution Architect"
	},
	{
		"id" : 1985,
		"name" : "HP Expert One Cloud"
	},
	{
		"id" : 1986,
		"name" : "EMC Cloud Architect"
	},
	{
		"id" : 1987,
		"name" : "VMware Cloud "
	},
	{
		"id" : 1583,
		"name" : "P\/Invoke"
	},
	{
		"id" : 1997,
		"name" : "GCP"
	},
	{
		"id" : 2007,
		"name" : "Containers"
	},
	{
		"id" : 1601,
		"name" : "Pipenv"
	},
	{
		"id" : 1695,
		"name" : "Play"
	},
	{
		"id" : 2010,
		"name" : "Virtualization"
	},
	{
		"id" : 2013,
		"name" : "Cloud Security"
	},
	{
		"id" : 2014,
		"name" : "Cloud Recovery"
	},
	{
		"id" : 4524,
		"name" : "dynaCache"
	},
	{
		"id" : 1907,
		"name" : "Database"
	},
	{
		"id" : 1996,
		"name" : "Microsoft Azure"
	},
	{
		"id" : 1940,
		"name" : "PostGIS"
	},
	{
		"id" : 4525,
		"name" : "IBM Websphere Commerce"
	},
	{
		"id" : 1802,
		"name" : "Storyboard"
	},
	{
		"id" : 1804,
		"name" : "SwiftyJSON"
	},
	{
		"id" : 1805,
		"name" : "TestFlight"
	},
	{
		"id" : 1806,
		"name" : "tvOS"
	},
	{
		"id" : 1807,
		"name" : "Typhoon"
	},
	{
		"id" : 1808,
		"name" : "UIKit"
	},
	{
		"id" : 1810,
		"name" : "XCTest"
	},
	{
		"id" : 1811,
		"name" : "WatchKit"
	},
	{
		"id" : 1812,
		"name" : "watchOS"
	},
	{
		"id" : 4526,
		"name" : "Websphere Commerce"
	},
	{
		"id" : 4527,
		"name" : "HCL Commerce"
	},
	{
		"id" : 1663,
		"name" : "POCO"
	},
	{
		"id" : 1515,
		"name" : "PowerMock"
	},
	{
		"id" : 1813,
		"name" : "Android Jetpack"
	},
	{
		"id" : 1816,
		"name" : "ActionBarSherlock"
	},
	{
		"id" : 1817,
		"name" : "adb"
	},
	{
		"id" : 1516,
		"name" : "PrimeFaces"
	},
	{
		"id" : 1818,
		"name" : "ADT"
	},
	{
		"id" : 1819,
		"name" : "AndEngine"
	},
	{
		"id" : 1517,
		"name" : "ProGuard"
	},
	{
		"id" : 1820,
		"name" : "Android Auto"
	},
	{
		"id" : 1821,
		"name" : "Android IDE"
	},
	{
		"id" : 1822,
		"name" : "Android N"
	},
	{
		"id" : 1823,
		"name" : "Android NDK"
	},
	{
		"id" : 1824,
		"name" : "Android SDK"
	},
	{
		"id" : 1378,
		"name" : "PSR"
	},
	{
		"id" : 1825,
		"name" : "Android Studio"
	},
	{
		"id" : 1826,
		"name" : "Android TV"
	},
	{
		"id" : 1827,
		"name" : "Android Wear"
	},
	{
		"id" : 1828,
		"name" : "AppCompat"
	},
	{
		"id" : 1829,
		"name" : "ButterKnife"
	},
	{
		"id" : 1830,
		"name" : "Conductor"
	},
	{
		"id" : 1976,
		"name" : "ERP"
	},
	{
		"id" : 1831,
		"name" : "Dagger"
	},
	{
		"id" : 1316,
		"name" : "Puppeteer"
	},
	{
		"id" : 1832,
		"name" : "DBFlow"
	},
	{
		"id" : 2004,
		"name" : "Web Services"
	},
	{
		"id" : 4178,
		"name" : "Speech Recognition"
	},
	{
		"id" : 1617,
		"name" : "PyBrain"
	},
	{
		"id" : 1833,
		"name" : "Espresso"
	},
	{
		"id" : 4181,
		"name" : "Calculus"
	},
	{
		"id" : 1834,
		"name" : "Evernote"
	},
	{
		"id" : 2019,
		"name" : "Ab Initio"
	},
	{
		"id" : 2021,
		"name" : "Appium"
	},
	{
		"id" : 2022,
		"name" : "Arquillian"
	},
	{
		"id" : 2023,
		"name" : "AutoIt"
	},
	{
		"id" : 2025,
		"name" : "Baseline testing"
	},
	{
		"id" : 1835,
		"name" : "Fresco"
	},
	{
		"id" : 1556,
		"name" : "C# frameworks"
	},
	{
		"id" : 2003,
		"name" : "API"
	},
	{
		"id" : 1905,
		"name" : "Data Architecture"
	},
	{
		"id" : 1920,
		"name" : "Google Compute Engine"
	},
	{
		"id" : 1776,
		"name" : "iOS"
	},
	{
		"id" : 1814,
		"name" : "Android"
	},
	{
		"id" : 2017,
		"name" : "Scenario testing"
	},
	{
		"id" : 2018,
		"name" : "A\/B testing"
	},
	{
		"id" : 1837,
		"name" : "gtest"
	},
	{
		"id" : 1973,
		"name" : "ROI"
	},
	{
		"id" : 1975,
		"name" : "Data Mining"
	},
	{
		"id" : 1977,
		"name" : "Risk Analytics"
	},
	{
		"id" : 1979,
		"name" : "Encryptions"
	},
	{
		"id" : 1998,
		"name" : "Open Stack"
	},
	{
		"id" : 2002,
		"name" : "UDDI"
	},
	{
		"id" : 2006,
		"name" : "AWS DevOps"
	},
	{
		"id" : 2011,
		"name" : "EC2"
	},
	{
		"id" : 2012,
		"name" : "Lambdas"
	},
	{
		"id" : 1838,
		"name" : "LeakCanary"
	},
	{
		"id" : 1839,
		"name" : "Logcat"
	},
	{
		"id" : 1946,
		"name" : "Redis"
	},
	{
		"id" : 2026,
		"name" : "Bazel"
	},
	{
		"id" : 2027,
		"name" : "Behat"
	},
	{
		"id" : 2028,
		"name" : "Black-box testing"
	},
	{
		"id" : 2029,
		"name" : "BlazeMete"
	},
	{
		"id" : 2030,
		"name" : "Calabash"
	},
	{
		"id" : 2031,
		"name" : "CasperJS"
	},
	{
		"id" : 2032,
		"name" : "Chai"
	},
	{
		"id" : 2033,
		"name" : "Charles"
	},
	{
		"id" : 2034,
		"name" : "Codacy"
	},
	{
		"id" : 2035,
		"name" : "Controller"
	},
	{
		"id" : 2036,
		"name" : "Cross-browser testing"
	},
	{
		"id" : 1607,
		"name" : "Buildbot"
	},
	{
		"id" : 2015,
		"name" : "Gherkin"
	},
	{
		"id" : 2016,
		"name" : "BlazeMeter"
	},
	{
		"id" : 1978,
		"name" : "Network Security skills"
	},
	{
		"id" : 3930,
		"name" : "Spark"
	},
	{
		"id" : 4528,
		"name" : "Product Management"
	},
	{
		"id" : 1618,
		"name" : "PyCharm"
	},
	{
		"id" : 4529,
		"name" : "Product Owner"
	},
	{
		"id" : 1619,
		"name" : "PyGTK"
	},
	{
		"id" : 2048,
		"name" : "Gatling"
	},
	{
		"id" : 2050,
		"name" : "HP Performance Center"
	},
	{
		"id" : 2051,
		"name" : "HP Quality Center"
	},
	{
		"id" : 2067,
		"name" : "Microsoft Test Manager"
	},
	{
		"id" : 2088,
		"name" : "QuickCheck"
	},
	{
		"id" : 2089,
		"name" : "QUnit"
	},
	{
		"id" : 2092,
		"name" : "ReportNG"
	},
	{
		"id" : 2093,
		"name" : "Robolectric"
	},
	{
		"id" : 4530,
		"name" : "Product Manager"
	},
	{
		"id" : 2114,
		"name" : "UFT (Unified Functional Testing)"
	},
	{
		"id" : 2097,
		"name" : "Siege"
	},
	{
		"id" : 1840,
		"name" : "Mortar"
	},
	{
		"id" : 1841,
		"name" : "Mosby"
	},
	{
		"id" : 1959,
		"name" : "SQL Server AlwaysOn"
	},
	{
		"id" : 2072,
		"name" : "NeoLoad"
	},
	{
		"id" : 2098,
		"name" : "Sinon"
	},
	{
		"id" : 2099,
		"name" : "SoapUI"
	},
	{
		"id" : 1842,
		"name" : "Picasso"
	},
	{
		"id" : 2101,
		"name" : "SpiraTest"
	},
	{
		"id" : 2102,
		"name" : "Spock"
	},
	{
		"id" : 2103,
		"name" : "Static analysis"
	},
	{
		"id" : 2104,
		"name" : "STLC"
	},
	{
		"id" : 2105,
		"name" : "Stress testing"
	},
	{
		"id" : 2106,
		"name" : "Sumo Logic"
	},
	{
		"id" : 2107,
		"name" : "Surefire"
	},
	{
		"id" : 2108,
		"name" : "Telerik Test Studio"
	},
	{
		"id" : 2109,
		"name" : "Test case"
	},
	{
		"id" : 2110,
		"name" : "TestLink"
	},
	{
		"id" : 1844,
		"name" : "RecyclerView"
	},
	{
		"id" : 1845,
		"name" : "RoboSpice"
	},
	{
		"id" : 1846,
		"name" : "Robotium"
	},
	{
		"id" : 2116,
		"name" : "WAPT"
	},
	{
		"id" : 2117,
		"name" : "WatiN"
	},
	{
		"id" : 2118,
		"name" : "WebDriver"
	},
	{
		"id" : 1847,
		"name" : "Room library"
	},
	{
		"id" : 1848,
		"name" : "RxAndroid"
	},
	{
		"id" : 1849,
		"name" : "RxJava"
	},
	{
		"id" : 1850,
		"name" : "SpongyCastle"
	},
	{
		"id" : 2124,
		"name" : "System Testing"
	},
	{
		"id" : 2125,
		"name" : "Test strategy"
	},
	{
		"id" : 1851,
		"name" : "Support Library"
	},
	{
		"id" : 2127,
		"name" : "QA engineering"
	},
	{
		"id" : 2128,
		"name" : "Bug tracking"
	},
	{
		"id" : 2129,
		"name" : "Test Planning"
	},
	{
		"id" : 1852,
		"name" : "Volley"
	},
	{
		"id" : 2090,
		"name" : "Ranorex"
	},
	{
		"id" : 1291,
		"name" : "Stylus"
	},
	{
		"id" : 2068,
		"name" : "Mocha"
	},
	{
		"id" : 2055,
		"name" : "Jasmine"
	},
	{
		"id" : 1853,
		"name" : "UI Automator"
	},
	{
		"id" : 1854,
		"name" : "BLoC Pattern"
	},
	{
		"id" : 2020,
		"name" : "Ad-Hoc Distribution (Mobile)"
	},
	{
		"id" : 2024,
		"name" : "Automation Testing"
	},
	{
		"id" : 2038,
		"name" : "DbUnit"
	},
	{
		"id" : 2039,
		"name" : "Defect tracking"
	},
	{
		"id" : 2040,
		"name" : "Dynamic analysis"
	},
	{
		"id" : 2041,
		"name" : "E2E Testing"
	},
	{
		"id" : 2043,
		"name" : "Endurance Testing"
	},
	{
		"id" : 2044,
		"name" : "Enzyme"
	},
	{
		"id" : 2045,
		"name" : "FitNesse"
	},
	{
		"id" : 1855,
		"name" : "Native Mobile App"
	},
	{
		"id" : 2047,
		"name" : "Galen Framework"
	},
	{
		"id" : 2052,
		"name" : "IBM RPT"
	},
	{
		"id" : 2054,
		"name" : "Iperf"
	},
	{
		"id" : 2056,
		"name" : "JavaScript testing tools"
	},
	{
		"id" : 2057,
		"name" : "JBehave"
	},
	{
		"id" : 2058,
		"name" : "Jest"
	},
	{
		"id" : 2059,
		"name" : "JMeter"
	},
	{
		"id" : 2060,
		"name" : "Jtest"
	},
	{
		"id" : 2061,
		"name" : "Kali Linux"
	},
	{
		"id" : 2062,
		"name" : "Karma"
	},
	{
		"id" : 2063,
		"name" : "Load testing"
	},
	{
		"id" : 2064,
		"name" : "LoadRunner"
	},
	{
		"id" : 2065,
		"name" : "LoadUI"
	},
	{
		"id" : 2066,
		"name" : "Manual testing"
	},
	{
		"id" : 2073,
		"name" : "Nightwatch.js"
	},
	{
		"id" : 2074,
		"name" : "Nodeunit"
	},
	{
		"id" : 2075,
		"name" : "Nose"
	},
	{
		"id" : 2076,
		"name" : "Okapi Framework"
	},
	{
		"id" : 2049,
		"name" : "Gray-box testing"
	},
	{
		"id" : 2070,
		"name" : "Monkey testing"
	},
	{
		"id" : 2071,
		"name" : "Negative testing"
	},
	{
		"id" : 2091,
		"name" : "Regression testing"
	},
	{
		"id" : 1856,
		"name" : "Mobile Application Development"
	},
	{
		"id" : 2079,
		"name" : "Testing"
	},
	{
		"id" : 2080,
		"name" : "PhantomJS"
	},
	{
		"id" : 2081,
		"name" : "PHPUnit"
	},
	{
		"id" : 2082,
		"name" : "Protractor"
	},
	{
		"id" : 2083,
		"name" : "Pytest"
	},
	{
		"id" : 2084,
		"name" : "QC"
	},
	{
		"id" : 2085,
		"name" : "qTest"
	},
	{
		"id" : 2086,
		"name" : "QTP"
	},
	{
		"id" : 2087,
		"name" : "Quality Assurance (QA)"
	},
	{
		"id" : 3534,
		"name" : "Retrofit"
	},
	{
		"id" : 3535,
		"name" : "WebEngage"
	},
	{
		"id" : 3536,
		"name" : "Angular4"
	},
	{
		"id" : 3537,
		"name" : "Mule ESB"
	},
	{
		"id" : 3538,
		"name" : "RAML"
	},
	{
		"id" : 3539,
		"name" : "DWL"
	},
	{
		"id" : 3540,
		"name" : "REST API"
	},
	{
		"id" : 3541,
		"name" : "POSTMAN"
	},
	{
		"id" : 3542,
		"name" : "Anypoint studio V4"
	},
	{
		"id" : 3543,
		"name" : "Angular 6.0"
	},
	{
		"id" : 3544,
		"name" : "Angular material"
	},
	{
		"id" : 3545,
		"name" : "Silverlight 4\/5"
	},
	{
		"id" : 3546,
		"name" : "Reactive Extensions"
	},
	{
		"id" : 1857,
		"name" : "Apache Flex"
	},
	{
		"id" : 1650,
		"name" : "CAFFE"
	},
	{
		"id" : 1364,
		"name" : "CakePHP"
	},
	{
		"id" : 1620,
		"name" : "Pylons"
	},
	{
		"id" : 1621,
		"name" : "Pyparsing"
	},
	{
		"id" : 3554,
		"name" : "Qt Widgets module"
	},
	{
		"id" : 1622,
		"name" : "Pyramid"
	},
	{
		"id" : 1623,
		"name" : "Pyston"
	},
	{
		"id" : 1665,
		"name" : "QtQtCreator"
	},
	{
		"id" : 1405,
		"name" : "Rake"
	},
	{
		"id" : 1666,
		"name" : "RapidJSON"
	},
	{
		"id" : 1584,
		"name" : "Razor"
	},
	{
		"id" : 1420,
		"name" : "Reactor"
	},
	{
		"id" : 1585,
		"name" : "ReSharper"
	},
	{
		"id" : 1518,
		"name" : "Resin"
	},
	{
		"id" : 1392,
		"name" : "Resque"
	},
	{
		"id" : 3566,
		"name" : "Research"
	},
	{
		"id" : 3519,
		"name" : "SAP-FICO"
	},
	{
		"id" : 1715,
		"name" : "Revel"
	},
	{
		"id" : 1520,
		"name" : "RichFaces"
	},
	{
		"id" : 1521,
		"name" : "RoboGuice"
	},
	{
		"id" : 1740,
		"name" : "RPG"
	},
	{
		"id" : 1406,
		"name" : "RSpec"
	},
	{
		"id" : 1335,
		"name" : "Sails"
	},
	{
		"id" : 3575,
		"name" : "Restful Web Services"
	},
	{
		"id" : 3576,
		"name" : "Springboot"
	},
	{
		"id" : 1858,
		"name" : "Bitrise"
	},
	{
		"id" : 1703,
		"name" : "Scalding"
	},
	{
		"id" : 1627,
		"name" : "Scapy"
	},
	{
		"id" : 1634,
		"name" : "SciPy"
	},
	{
		"id" : 1628,
		"name" : "Scrapy"
	},
	{
		"id" : 1629,
		"name" : "Seaborn"
	},
	{
		"id" : 1522,
		"name" : "Seam"
	},
	{
		"id" : 1336,
		"name" : "Seneca"
	},
	{
		"id" : 1587,
		"name" : "ServiceStack"
	},
	{
		"id" : 1523,
		"name" : "Servlet"
	},
	{
		"id" : 4454,
		"name" : "SFCC"
	},
	{
		"id" : 4455,
		"name" : "SFRA"
	},
	{
		"id" : 1704,
		"name" : "Shapeless"
	},
	{
		"id" : 3945,
		"name" : "SharePoint"
	},
	{
		"id" : 1588,
		"name" : "SignalR"
	},
	{
		"id" : 3593,
		"name" : "Blockchain Protocols"
	},
	{
		"id" : 1379,
		"name" : "Silex"
	},
	{
		"id" : 1380,
		"name" : "SilverStripe"
	},
	{
		"id" : 1416,
		"name" : "Sinatra"
	},
	{
		"id" : 1589,
		"name" : "Sitecore CMS"
	},
	{
		"id" : 4456,
		"name" : "Slack"
	},
	{
		"id" : 1524,
		"name" : "SLF4J"
	},
	{
		"id" : 1705,
		"name" : "Slick"
	},
	{
		"id" : 1381,
		"name" : "Slim"
	},
	{
		"id" : 1382,
		"name" : "Smarty"
	},
	{
		"id" : 1668,
		"name" : "Socket programming"
	},
	{
		"id" : 3604,
		"name" : "Blockchain Implementation"
	},
	{
		"id" : 1590,
		"name" : "SpecFlow"
	},
	{
		"id" : 1706,
		"name" : "Spray"
	},
	{
		"id" : 1859,
		"name" : "Cordova"
	},
	{
		"id" : 3591,
		"name" : "DeFi"
	},
	{
		"id" : 3609,
		"name" : "Spring Planning"
	},
	{
		"id" : 2112,
		"name" : "Tosca"
	},
	{
		"id" : 1861,
		"name" : "Cross-Platform Mobile Development"
	},
	{
		"id" : 2078,
		"name" : "Performance testing"
	},
	{
		"id" : 3613,
		"name" : "Magento 2"
	},
	{
		"id" : 1862,
		"name" : "Dojo Mobile"
	},
	{
		"id" : 3615,
		"name" : "HTTP"
	},
	{
		"id" : 1863,
		"name" : "Firebase"
	},
	{
		"id" : 1865,
		"name" : "Glide"
	},
	{
		"id" : 3621,
		"name" : "Java Servlets"
	},
	{
		"id" : 1699,
		"name" : "Scala"
	},
	{
		"id" : 3614,
		"name" : "Github"
	},
	{
		"id" : 1632,
		"name" : "SQLAlchemy"
	},
	{
		"id" : 1866,
		"name" : "Hybrid app"
	},
	{
		"id" : 3633,
		"name" : "Ruby On Rails"
	},
	{
		"id" : 1868,
		"name" : "Ionic Creator"
	},
	{
		"id" : 1869,
		"name" : "jQuery Mobile"
	},
	{
		"id" : 1870,
		"name" : "Lottie"
	},
	{
		"id" : 3637,
		"name" : "CSS3"
	},
	{
		"id" : 1871,
		"name" : "Marmalade"
	},
	{
		"id" : 3624,
		"name" : "VCS"
	},
	{
		"id" : 3639,
		"name" : "Apex"
	},
	{
		"id" : 3685,
		"name" : "Chef"
	},
	{
		"id" : 3686,
		"name" : "Puppet"
	},
	{
		"id" : 3626,
		"name" : "JUnit5"
	},
	{
		"id" : 3688,
		"name" : "Terraform"
	},
	{
		"id" : 3627,
		"name" : "S3 Server"
	},
	{
		"id" : 3628,
		"name" : "NGINX Server"
	},
	{
		"id" : 3689,
		"name" : "Ansible"
	},
	{
		"id" : 3629,
		"name" : "LAMP Stack"
	},
	{
		"id" : 3708,
		"name" : "Bash"
	},
	{
		"id" : 3656,
		"name" : "Force.com Migration Tool"
	},
	{
		"id" : 3661,
		"name" : "Apex Data Loader"
	},
	{
		"id" : 3630,
		"name" : "MEAN Stack"
	},
	{
		"id" : 3631,
		"name" : "Express"
	},
	{
		"id" : 1872,
		"name" : "MLKit"
	},
	{
		"id" : 3676,
		"name" : "SwiftUI"
	},
	{
		"id" : 3680,
		"name" : "Autolayout"
	},
	{
		"id" : 1873,
		"name" : "PhoneGap"
	},
	{
		"id" : 3683,
		"name" : "CI\/CD"
	},
	{
		"id" : 3684,
		"name" : "Containerization"
	},
	{
		"id" : 3687,
		"name" : "Cloudformation"
	},
	{
		"id" : 3690,
		"name" : "S3"
	},
	{
		"id" : 3691,
		"name" : "EB"
	},
	{
		"id" : 3692,
		"name" : "Elastic Container Services"
	},
	{
		"id" : 3693,
		"name" : "Elastic Container Registry"
	},
	{
		"id" : 3694,
		"name" : "Apache Cloud"
	},
	{
		"id" : 3695,
		"name" : "Confluence"
	},
	{
		"id" : 3696,
		"name" : "Gitlab"
	},
	{
		"id" : 3697,
		"name" : "TestComplete"
	},
	{
		"id" : 3698,
		"name" : "TestingWhiz"
	},
	{
		"id" : 3699,
		"name" : "Nagios"
	},
	{
		"id" : 3700,
		"name" : "Zabbix"
	},
	{
		"id" : 3701,
		"name" : "Splunk"
	},
	{
		"id" : 3702,
		"name" : "Vagrant"
	},
	{
		"id" : 3703,
		"name" : "Cloud tools"
	},
	{
		"id" : 3704,
		"name" : "IAAS tools"
	},
	{
		"id" : 3705,
		"name" : "PAAS tools"
	},
	{
		"id" : 3706,
		"name" : "Serverless Tools"
	},
	{
		"id" : 3707,
		"name" : "Scripting"
	},
	{
		"id" : 3709,
		"name" : "BitBucket"
	},
	{
		"id" : 3710,
		"name" : "VSTS"
	},
	{
		"id" : 3711,
		"name" : "Mesos"
	},
	{
		"id" : 3712,
		"name" : "Swarm"
	},
	{
		"id" : 3713,
		"name" : "Octopus Deploy"
	},
	{
		"id" : 3714,
		"name" : "TeamCity"
	},
	{
		"id" : 3715,
		"name" : "Shell"
	},
	{
		"id" : 3716,
		"name" : "IBM CLoud"
	},
	{
		"id" : 3717,
		"name" : "APM"
	},
	{
		"id" : 3718,
		"name" : "New Relic"
	},
	{
		"id" : 3719,
		"name" : "AppDynamics"
	},
	{
		"id" : 3720,
		"name" : "Dynatrace"
	},
	{
		"id" : 3721,
		"name" : "Amazon CloudWatch"
	},
	{
		"id" : 3722,
		"name" : "AWS X-Ray"
	},
	{
		"id" : 3723,
		"name" : "Amazon SNS"
	},
	{
		"id" : 3724,
		"name" : "Amazon Elasticsearch Service"
	},
	{
		"id" : 3725,
		"name" : "Kibana"
	},
	{
		"id" : 3726,
		"name" : "syslog"
	},
	{
		"id" : 3727,
		"name" : "Logrotate"
	},
	{
		"id" : 3728,
		"name" : "Logstash"
	},
	{
		"id" : 3729,
		"name" : "Filebeat"
	},
	{
		"id" : 3730,
		"name" : "Prometheus"
	},
	{
		"id" : 3731,
		"name" : "Grafana"
	},
	{
		"id" : 3732,
		"name" : "IaC Tools"
	},
	{
		"id" : 3733,
		"name" : "Cloud Formation"
	},
	{
		"id" : 3734,
		"name" : "Pulumi"
	},
	{
		"id" : 3735,
		"name" : "AWS CDK"
	},
	{
		"id" : 3736,
		"name" : "SaltStack"
	},
	{
		"id" : 3737,
		"name" : "Powershell DSC"
	},
	{
		"id" : 3738,
		"name" : "Docker Engine"
	},
	{
		"id" : 3739,
		"name" : "Docker Swarm"
	},
	{
		"id" : 1874,
		"name" : "React Native"
	},
	{
		"id" : 1876,
		"name" : "Titanium"
	},
	{
		"id" : 1877,
		"name" : "Xamarin"
	},
	{
		"id" : 3641,
		"name" : "Lightning Component Framework"
	},
	{
		"id" : 3642,
		"name" : "CRM Software Package"
	},
	{
		"id" : 3644,
		"name" : "InterAction"
	},
	{
		"id" : 4342,
		"name" : "SWOT"
	},
	{
		"id" : 3740,
		"name" : "Systemd-nspawn"
	},
	{
		"id" : 3741,
		"name" : "LXC"
	},
	{
		"id" : 3742,
		"name" : "Ubuntu"
	},
	{
		"id" : 3743,
		"name" : "CentOS"
	},
	{
		"id" : 3744,
		"name" : "Amazon Linux"
	},
	{
		"id" : 3745,
		"name" : "ReHat Enterprise linux"
	},
	{
		"id" : 3746,
		"name" : "Windows"
	},
	{
		"id" : 3747,
		"name" : "Nginx"
	},
	{
		"id" : 3748,
		"name" : "AWS DynamoDB"
	},
	{
		"id" : 3749,
		"name" : "GNU utilities"
	},
	{
		"id" : 3750,
		"name" : "Cron"
	},
	{
		"id" : 3751,
		"name" : "AWS Lambda"
	},
	{
		"id" : 3752,
		"name" : "CVS"
	},
	{
		"id" : 3753,
		"name" : "Travis Circle CI"
	},
	{
		"id" : 3754,
		"name" : "Stash"
	},
	{
		"id" : 3755,
		"name" : "ELK Stack"
	},
	{
		"id" : 3756,
		"name" : "ITCAM"
	},
	{
		"id" : 4077,
		"name" : "Client Side Object Model"
	},
	{
		"id" : 4078,
		"name" : "CSOM"
	},
	{
		"id" : 1579,
		"name" : "Entity Framework"
	},
	{
		"id" : 1398,
		"name" : "ERB"
	},
	{
		"id" : 1721,
		"name" : "Erlang"
	},
	{
		"id" : 1399,
		"name" : "EventMachine"
	},
	{
		"id" : 1717,
		"name" : "ExUnit"
	},
	{
		"id" : 1591,
		"name" : "SSRS"
	},
	{
		"id" : 1630,
		"name" : "StatsModels"
	},
	{
		"id" : 1318,
		"name" : "Stencil.js"
	},
	{
		"id" : 1669,
		"name" : "STL"
	},
	{
		"id" : 1531,
		"name" : "Struts"
	},
	{
		"id" : 1530,
		"name" : "STS"
	},
	{
		"id" : 1592,
		"name" : "StyleCop"
	},
	{
		"id" : 4136,
		"name" : "SVN"
	},
	{
		"id" : 1533,
		"name" : "Swing"
	},
	{
		"id" : 1383,
		"name" : "Symfony"
	},
	{
		"id" : 1631,
		"name" : "SymPy"
	},
	{
		"id" : 1593,
		"name" : "Telerik DevCraft"
	},
	{
		"id" : 1670,
		"name" : "Template metaprogramming"
	},
	{
		"id" : 1469,
		"name" : "TestNG"
	},
	{
		"id" : 1633,
		"name" : "Theano"
	},
	{
		"id" : 1534,
		"name" : "Thymeleaf"
	},
	{
		"id" : 1384,
		"name" : "Tideways"
	},
	{
		"id" : 1535,
		"name" : "Tomcat"
	},
	{
		"id" : 1536,
		"name" : "TomEE"
	},
	{
		"id" : 1635,
		"name" : "Tornado"
	},
	{
		"id" : 1641,
		"name" : "TortoiseSVN"
	},
	{
		"id" : 1385,
		"name" : "Twig"
	},
	{
		"id" : 1636,
		"name" : "Twisted"
	},
	{
		"id" : 1386,
		"name" : "TYPO3"
	},
	{
		"id" : 1537,
		"name" : "UIMA"
	},
	{
		"id" : 1594,
		"name" : "Unsafe Code"
	},
	{
		"id" : 1538,
		"name" : "Vaadin"
	},
	{
		"id" : 1671,
		"name" : "Valgrind"
	},
	{
		"id" : 1672,
		"name" : "VBA"
	},
	{
		"id" : 1595,
		"name" : "VB.Net"
	},
	{
		"id" : 1741,
		"name" : "VBScript"
	},
	{
		"id" : 1742,
		"name" : "Verilog"
	},
	{
		"id" : 1637,
		"name" : "Virtualenv"
	},
	{
		"id" : 1596,
		"name" : "Visual C#"
	},
	{
		"id" : 1673,
		"name" : "Visual C++"
	},
	{
		"id" : 4109,
		"name" : "Tableau"
	},
	{
		"id" : 4097,
		"name" : "Visual Web part"
	},
	{
		"id" : 1725,
		"name" : "WADL"
	},
	{
		"id" : 1598,
		"name" : "WCF"
	},
	{
		"id" : 1539,
		"name" : "WebLogic"
	},
	{
		"id" : 1597,
		"name" : "WebMatrix"
	},
	{
		"id" : 1639,
		"name" : "web.py"
	},
	{
		"id" : 1540,
		"name" : "Wicket"
	},
	{
		"id" : 4072,
		"name" : "Administration"
	},
	{
		"id" : 4073,
		"name" : "Ado DotNet"
	},
	{
		"id" : 4074,
		"name" : "APPS"
	},
	{
		"id" : 4075,
		"name" : "ASP DotNet"
	},
	{
		"id" : 4076,
		"name" : "C Sharp"
	},
	{
		"id" : 4079,
		"name" : "Designer workflow"
	},
	{
		"id" : 4080,
		"name" : "ECMA Scripts"
	},
	{
		"id" : 1541,
		"name" : "WildFly"
	},
	{
		"id" : 4082,
		"name" : "Java Script"
	},
	{
		"id" : 1387,
		"name" : "WooCommerce"
	},
	{
		"id" : 4084,
		"name" : "MS Azure"
	},
	{
		"id" : 1388,
		"name" : "WordPress"
	},
	{
		"id" : 4086,
		"name" : "MS Visual Studio"
	},
	{
		"id" : 1599,
		"name" : "WPF"
	},
	{
		"id" : 4088,
		"name" : "PowerShell Script"
	},
	{
		"id" : 4089,
		"name" : "SharePoint 2013"
	},
	{
		"id" : 4090,
		"name" : "SharePoint Designer 2013"
	},
	{
		"id" : 4091,
		"name" : "SharePoint Framework"
	},
	{
		"id" : 4092,
		"name" : "SharePoint Online"
	},
	{
		"id" : 4093,
		"name" : "SharePoint Out of Box"
	},
	{
		"id" : 4094,
		"name" : "SPFx"
	},
	{
		"id" : 4095,
		"name" : "Timer Jobs"
	},
	{
		"id" : 4096,
		"name" : "Visual Studio Code"
	},
	{
		"id" : 4098,
		"name" : "Windows Server 2008 R2"
	},
	{
		"id" : 4099,
		"name" : "Windows XP"
	},
	{
		"id" : 4100,
		"name" : "Windows7"
	},
	{
		"id" : 4108,
		"name" : "ETL Talend"
	},
	{
		"id" : 4110,
		"name" : "VC++"
	},
	{
		"id" : 4111,
		"name" : "Net beans"
	},
	{
		"id" : 4112,
		"name" : "Network Simulator 2"
	},
	{
		"id" : 4130,
		"name" : "Java 8"
	},
	{
		"id" : 4131,
		"name" : "Java2ee"
	},
	{
		"id" : 4134,
		"name" : "Oracle ATG Commerce framework"
	},
	{
		"id" : 1809,
		"name" : "Xcode"
	},
	{
		"id" : 1790,
		"name" : "Objective-C"
	},
	{
		"id" : 1803,
		"name" : "Swift"
	},
	{
		"id" : 1773,
		"name" : "GCD"
	},
	{
		"id" : 4177,
		"name" : "MATLAB"
	},
	{
		"id" : 4135,
		"name" : "Hudson"
	},
	{
		"id" : 1500,
		"name" : "JSP"
	},
	{
		"id" : 1501,
		"name" : "JSTL"
	},
	{
		"id" : 4409,
		"name" : "VMWare"
	},
	{
		"id" : 3924,
		"name" : "DNS"
	},
	{
		"id" : 3925,
		"name" : "IoT"
	},
	{
		"id" : 3675,
		"name" : "Interface Builder"
	},
	{
		"id" : 3677,
		"name" : "Intunes"
	},
	{
		"id" : 3678,
		"name" : "CI Tools"
	},
	{
		"id" : 3679,
		"name" : "Bamboo"
	},
	{
		"id" : 3681,
		"name" : "MVVM"
	},
	{
		"id" : 4107,
		"name" : "Excel"
	},
	{
		"id" : 4113,
		"name" : "PMP Certification"
	},
	{
		"id" : 3926,
		"name" : "Firewalls and Security"
	},
	{
		"id" : 2113,
		"name" : "UAT"
	},
	{
		"id" : 2119,
		"name" : "White-box testing"
	},
	{
		"id" : 2120,
		"name" : "Xamarin.UITest"
	},
	{
		"id" : 2121,
		"name" : "XCUITest"
	},
	{
		"id" : 2122,
		"name" : "Zombie"
	},
	{
		"id" : 2123,
		"name" : "Website testing"
	},
	{
		"id" : 2126,
		"name" : "Mobile application testing"
	},
	{
		"id" : 2096,
		"name" : "Selenium"
	},
	{
		"id" : 2046,
		"name" : "Functional testing"
	},
	{
		"id" : 2053,
		"name" : "Integration testing"
	},
	{
		"id" : 2077,
		"name" : "Penetration testing"
	},
	{
		"id" : 3927,
		"name" : "Customer Relations"
	},
	{
		"id" : 4399,
		"name" : "OSPF"
	},
	{
		"id" : 4400,
		"name" : "Redhat"
	},
	{
		"id" : 4401,
		"name" : "RHEL"
	},
	{
		"id" : 4403,
		"name" : "Serverless Computing"
	},
	{
		"id" : 4404,
		"name" : "SolarWinds"
	},
	{
		"id" : 4405,
		"name" : "SUSE"
	},
	{
		"id" : 4407,
		"name" : "VDI"
	},
	{
		"id" : 4412,
		"name" : "VPC"
	},
	{
		"id" : 4413,
		"name" : "VSphere"
	},
	{
		"id" : 4414,
		"name" : "WAF"
	},
	{
		"id" : 4458,
		"name" : "Collibra"
	},
	{
		"id" : 4101,
		"name" : "MSSQL"
	},
	{
		"id" : 4102,
		"name" : "Power BI Desktop"
	},
	{
		"id" : 4103,
		"name" : "Power BI Service"
	},
	{
		"id" : 4104,
		"name" : "Postman API"
	},
	{
		"id" : 4105,
		"name" : "Python Scripts"
	},
	{
		"id" : 4106,
		"name" : "Share point"
	},
	{
		"id" : 3943,
		"name" : "MVP"
	},
	{
		"id" : 4114,
		"name" : "Salesforce"
	},
	{
		"id" : 3931,
		"name" : "ML Flow"
	},
	{
		"id" : 3928,
		"name" : "SD-branch Architecture"
	},
	{
		"id" : 4138,
		"name" : "Natural Language Processing"
	},
	{
		"id" : 3934,
		"name" : "Object Storage"
	},
	{
		"id" : 4139,
		"name" : "Clustering Algorithm"
	},
	{
		"id" : 3942,
		"name" : "Statistical Analysis"
	},
	{
		"id" : 4115,
		"name" : "Microsoft Office"
	},
	{
		"id" : 4132,
		"name" : "Spring Batch"
	},
	{
		"id" : 4133,
		"name" : "Spring Data"
	},
	{
		"id" : 4137,
		"name" : "Oracle Endeca"
	},
	{
		"id" : 4116,
		"name" : "Microsoft Project"
	},
	{
		"id" : 4117,
		"name" : "Project Scheduling"
	},
	{
		"id" : 4118,
		"name" : "Strategic Planning"
	},
	{
		"id" : 4119,
		"name" : "Subject Matter Expertise"
	},
	{
		"id" : 4120,
		"name" : "Project Lifecycle Management"
	},
	{
		"id" : 1948,
		"name" : "Relational DB"
	},
	{
		"id" : 4121,
		"name" : "Agile Software"
	},
	{
		"id" : 1888,
		"name" : "Database administration"
	},
	{
		"id" : 1889,
		"name" : "Apache Druid"
	},
	{
		"id" : 2001,
		"name" : "SOAP"
	},
	{
		"id" : 2115,
		"name" : "Unit testing"
	},
	{
		"id" : 1255,
		"name" : "jQuery"
	},
	{
		"id" : 3625,
		"name" : "Oracle"
	},
	{
		"id" : 3640,
		"name" : "Visualforce"
	},
	{
		"id" : 3648,
		"name" : "SOQL"
	},
	{
		"id" : 3649,
		"name" : "SOSL"
	},
	{
		"id" : 3664,
		"name" : "SoupUI"
	},
	{
		"id" : 3668,
		"name" : "Ember"
	},
	{
		"id" : 3672,
		"name" : "Aura"
	},
	{
		"id" : 1890,
		"name" : "Aerospike"
	},
	{
		"id" : 1891,
		"name" : "AllegroGraph"
	},
	{
		"id" : 1892,
		"name" : "CrateDB"
	},
	{
		"id" : 1906,
		"name" : "Data Pipeline"
	},
	{
		"id" : 4122,
		"name" : "Scrum Management"
	},
	{
		"id" : 4123,
		"name" : "Meeting Facilitation"
	},
	{
		"id" : 4124,
		"name" : "Financial Modelling"
	},
	{
		"id" : 4125,
		"name" : "Kanban"
	},
	{
		"id" : 4126,
		"name" : "Forecasting"
	},
	{
		"id" : 4127,
		"name" : "Lean Thinking"
	},
	{
		"id" : 4128,
		"name" : "Performance Tracking"
	},
	{
		"id" : 4129,
		"name" : "Budgeting"
	},
	{
		"id" : 4196,
		"name" : "Microcontrollers"
	},
	{
		"id" : 4197,
		"name" : "MCUs"
	},
	{
		"id" : 4198,
		"name" : "Microprocessors"
	},
	{
		"id" : 4187,
		"name" : "Artificial Neural Networks"
	},
	{
		"id" : 4199,
		"name" : "Linux Operating System"
	},
	{
		"id" : 4200,
		"name" : "Software Optimizations Skills"
	},
	{
		"id" : 4201,
		"name" : "Real-time Operating Systems or RTOS"
	},
	{
		"id" : 4202,
		"name" : "Device Drivers"
	},
	{
		"id" : 4203,
		"name" : "Assembly Programming Language"
	},
	{
		"id" : 4140,
		"name" : "Regression Algorithm"
	},
	{
		"id" : 4141,
		"name" : "Classification Algorithm"
	},
	{
		"id" : 4143,
		"name" : "Data Modeling"
	},
	{
		"id" : 4144,
		"name" : "Data Evaluation"
	},
	{
		"id" : 4145,
		"name" : "Naïve Bayes Classifier"
	},
	{
		"id" : 4146,
		"name" : "K Means Clustering"
	},
	{
		"id" : 4147,
		"name" : "Support Vector Machine"
	},
	{
		"id" : 4148,
		"name" : "Apriori Algorithm"
	},
	{
		"id" : 4149,
		"name" : "Linear Regression"
	},
	{
		"id" : 4150,
		"name" : "Logistic Regression"
	},
	{
		"id" : 4151,
		"name" : "Decision Trees"
	},
	{
		"id" : 4152,
		"name" : "Random Forests"
	},
	{
		"id" : 4153,
		"name" : "Supervised Machine Learning Algorithm"
	},
	{
		"id" : 4154,
		"name" : "Unsupervised Machine Learning Algorithm"
	},
	{
		"id" : 4217,
		"name" : "Microprocessor Technology"
	},
	{
		"id" : 4155,
		"name" : "Reinforcement Machine Learning Algorithm"
	},
	{
		"id" : 4157,
		"name" : "Scikit-learn"
	},
	{
		"id" : 4158,
		"name" : "TensorFlow"
	},
	{
		"id" : 4159,
		"name" : "Applied Mathematics"
	},
	{
		"id" : 4160,
		"name" : "Linear Algebra"
	},
	{
		"id" : 4161,
		"name" : "Probability"
	},
	{
		"id" : 4162,
		"name" : "Statistics"
	},
	{
		"id" : 4163,
		"name" : "Multivariate Calculus"
	},
	{
		"id" : 4164,
		"name" : "Poisson Distribution"
	},
	{
		"id" : 4165,
		"name" : "Normal Distribution"
	},
	{
		"id" : 4166,
		"name" : "Binomial Distribution"
	},
	{
		"id" : 4167,
		"name" : "Physics Concepts"
	},
	{
		"id" : 4230,
		"name" : "C Debugger"
	},
	{
		"id" : 4168,
		"name" : "Feedforward NN"
	},
	{
		"id" : 4169,
		"name" : "Recurrent NN"
	},
	{
		"id" : 4170,
		"name" : "Convolutional NN"
	},
	{
		"id" : 4171,
		"name" : "Modular NN"
	},
	{
		"id" : 4172,
		"name" : "Radial Basis Function NN"
	},
	{
		"id" : 4173,
		"name" : "Software Development Life Cycle"
	},
	{
		"id" : 4174,
		"name" : "Optimisation Algorithm"
	},
	{
		"id" : 4175,
		"name" : "Sorting Algorithm"
	},
	{
		"id" : 4176,
		"name" : "Searching Algorithm"
	},
	{
		"id" : 4193,
		"name" : "Restricted Boltzmann Machines(RBM)"
	},
	{
		"id" : 3939,
		"name" : "Numpy"
	},
	{
		"id" : 3940,
		"name" : "Pandas"
	},
	{
		"id" : 3944,
		"name" : "Power BI"
	},
	{
		"id" : 4204,
		"name" : "Hardware Test Equipments"
	},
	{
		"id" : 4205,
		"name" : "Oscilloscope"
	},
	{
		"id" : 4206,
		"name" : "Logic Analyzer"
	},
	{
		"id" : 4207,
		"name" : "I2C"
	},
	{
		"id" : 4208,
		"name" : "Serial Peripheral Interface or SPI"
	},
	{
		"id" : 4209,
		"name" : "USB"
	},
	{
		"id" : 3929,
		"name" : "ETL"
	},
	{
		"id" : 4210,
		"name" : "General-Purpose Input-Output or GPIOs"
	},
	{
		"id" : 3932,
		"name" : "Seldon"
	},
	{
		"id" : 3933,
		"name" : "Kubeflow"
	},
	{
		"id" : 4211,
		"name" : "Controller Area Network or CAN bus"
	},
	{
		"id" : 3936,
		"name" : "Tornodo"
	},
	{
		"id" : 3937,
		"name" : "Datawarehousing"
	},
	{
		"id" : 3938,
		"name" : "Hive"
	},
	{
		"id" : 3941,
		"name" : "Matplotilib"
	},
	{
		"id" : 4212,
		"name" : "Recommended Standard 232 - RS232"
	},
	{
		"id" : 4213,
		"name" : "One-Wire"
	},
	{
		"id" : 4214,
		"name" : "Recommended Standard 485 - RS485"
	},
	{
		"id" : 4216,
		"name" : "RISC-V Instruction Set Architecture"
	},
	{
		"id" : 4218,
		"name" : "GNU Project Debugger"
	},
	{
		"id" : 4219,
		"name" : "Multiprocessor Design"
	},
	{
		"id" : 4220,
		"name" : "Multi-Subsystem Issues"
	},
	{
		"id" : 4221,
		"name" : "Open-Source Software"
	},
	{
		"id" : 4222,
		"name" : "Unified Modeling Language"
	},
	{
		"id" : 4223,
		"name" : "Wireless Connectivity"
	},
	{
		"id" : 4224,
		"name" : "Wi-Fi"
	},
	{
		"id" : 4225,
		"name" : "Bluetooth Low Energy or BLE"
	},
	{
		"id" : 4294,
		"name" : "Point of Sale"
	},
	{
		"id" : 4295,
		"name" : "Mobile POS"
	},
	{
		"id" : 4296,
		"name" : "Warehouse Management System"
	},
	{
		"id" : 4297,
		"name" : "Order Management System"
	},
	{
		"id" : 4298,
		"name" : "Stock Management SCO"
	},
	{
		"id" : 4299,
		"name" : "APTOS ONE"
	},
	{
		"id" : 4300,
		"name" : "APTOS CRM Systems"
	},
	{
		"id" : 4301,
		"name" : "Handheld Systems"
	},
	{
		"id" : 4302,
		"name" : "Retail"
	},
	{
		"id" : 4303,
		"name" : "Payment System"
	},
	{
		"id" : 4304,
		"name" : "Email Receipt"
	},
	{
		"id" : 4305,
		"name" : "Tax"
	},
	{
		"id" : 4306,
		"name" : "SIM"
	},
	{
		"id" : 4307,
		"name" : "STOCK"
	},
	{
		"id" : 4308,
		"name" : "Peripheral Devices"
	},
	{
		"id" : 4309,
		"name" : "Sales Audit Servers"
	},
	{
		"id" : 4310,
		"name" : "Interface Files"
	},
	{
		"id" : 4311,
		"name" : "EOD"
	},
	{
		"id" : 4312,
		"name" : "Till Operations"
	},
	{
		"id" : 4313,
		"name" : "Manager Operations"
	},
	{
		"id" : 4314,
		"name" : "HHT"
	},
	{
		"id" : 4315,
		"name" : "Unity 3D"
	},
	{
		"id" : 4316,
		"name" : "Unreal Engine"
	},
	{
		"id" : 4317,
		"name" : "Blender"
	},
	{
		"id" : 4318,
		"name" : "Maya"
	},
	{
		"id" : 4319,
		"name" : "3DsMax"
	},
	{
		"id" : 4320,
		"name" : "3D Modeling Software"
	},
	{
		"id" : 4321,
		"name" : "Image Editing"
	},
	{
		"id" : 4322,
		"name" : "Photoshop"
	},
	{
		"id" : 4323,
		"name" : "GIMP"
	},
	{
		"id" : 4324,
		"name" : "App Store"
	},
	{
		"id" : 4325,
		"name" : "Play Store"
	},
	{
		"id" : 4226,
		"name" : "AI"
	},
	{
		"id" : 4227,
		"name" : "3D Design"
	},
	{
		"id" : 4228,
		"name" : "Graphical User Interfaces or GUI"
	},
	{
		"id" : 4229,
		"name" : "Embedded C"
	},
	{
		"id" : 4231,
		"name" : "Kernel Programming"
	},
	{
		"id" : 4232,
		"name" : "Electronic Circuit Board Design"
	},
	{
		"id" : 4233,
		"name" : "Arduino"
	},
	{
		"id" : 4234,
		"name" : "Raspberry PI"
	},
	{
		"id" : 4235,
		"name" : "AVR Microcontrolllers"
	},
	{
		"id" : 4236,
		"name" : "ARM Microcontrolllers"
	},
	{
		"id" : 4237,
		"name" : "UART"
	},
	{
		"id" : 4238,
		"name" : "Zigbee"
	},
	{
		"id" : 4239,
		"name" : "Eagle CAD"
	},
	{
		"id" : 4240,
		"name" : "Simulators"
	},
	{
		"id" : 4241,
		"name" : "Proteus"
	},
	{
		"id" : 4242,
		"name" : "Baremetal Coding"
	},
	{
		"id" : 1952,
		"name" : "RocksDB"
	},
	{
		"id" : 1953,
		"name" : "SAP MaxDB"
	},
	{
		"id" : 1954,
		"name" : "Snowflake"
	},
	{
		"id" : 1955,
		"name" : "Solr"
	},
	{
		"id" : 1956,
		"name" : "Spanner"
	},
	{
		"id" : 1957,
		"name" : "Sphinx"
	},
	{
		"id" : 1964,
		"name" : "T-SQL"
	},
	{
		"id" : 1965,
		"name" : "Teradata"
	},
	{
		"id" : 1966,
		"name" : "Toad"
	},
	{
		"id" : 4459,
		"name" : "Linux BSP"
	},
	{
		"id" : 1407,
		"name" : "RuboCop"
	},
	{
		"id" : 1667,
		"name" : "Rust"
	},
	{
		"id" : 4374,
		"name" : "AirFlow"
	},
	{
		"id" : 4378,
		"name" : "BigQuery"
	},
	{
		"id" : 4380,
		"name" : "CISCO Nexus"
	},
	{
		"id" : 4382,
		"name" : "Citrix"
	},
	{
		"id" : 4387,
		"name" : "CloudSQL"
	},
	{
		"id" : 4388,
		"name" : "CosmoDB"
	},
	{
		"id" : 4389,
		"name" : "Data Lakes"
	},
	{
		"id" : 4391,
		"name" : "Digital Ocean"
	},
	{
		"id" : 4392,
		"name" : "EIGRP"
	},
	{
		"id" : 4393,
		"name" : "EMC"
	},
	{
		"id" : 4394,
		"name" : "Glacier"
	},
	{
		"id" : 4395,
		"name" : "Hybrid Cloud"
	},
	{
		"id" : 4375,
		"name" : "Azure Blob"
	},
	{
		"id" : 4376,
		"name" : "Azure Queue"
	},
	{
		"id" : 4377,
		"name" : "Azure VM"
	},
	{
		"id" : 4379,
		"name" : "CGI"
	},
	{
		"id" : 4381,
		"name" : "CISSP "
	},
	{
		"id" : 4383,
		"name" : "CLI"
	},
	{
		"id" : 4384,
		"name" : "Cloud Composer"
	},
	{
		"id" : 4385,
		"name" : "Cloud Dataproc"
	},
	{
		"id" : 4386,
		"name" : "Cloud Scheduler"
	},
	{
		"id" : 4390,
		"name" : "DataFlow"
	},
	{
		"id" : 4398,
		"name" : "Network Security"
	},
	{
		"id" : 1184,
		"name" : "AJAX"
	},
	{
		"id" : 1235,
		"name" : "HTML5"
	},
	{
		"id" : 1886,
		"name" : "PipelineDB"
	},
	{
		"id" : 1911,
		"name" : "Dbf"
	},
	{
		"id" : 1912,
		"name" : "DynamoDB"
	},
	{
		"id" : 4457,
		"name" : "Cognos"
	},
	{
		"id" : 4406,
		"name" : "TCP-IP"
	},
	{
		"id" : 4461,
		"name" : "Business analysis"
	},
	{
		"id" : 4408,
		"name" : "Virtual Networks "
	},
	{
		"id" : 4462,
		"name" : "Google Cloud Rackspace"
	},
	{
		"id" : 4410,
		"name" : "VMware Cloud"
	},
	{
		"id" : 4411,
		"name" : "VMWare Horizon"
	},
	{
		"id" : 4463,
		"name" : "OpenStack"
	},
	{
		"id" : 4183,
		"name" : "PyTorch"
	},
	{
		"id" : 4184,
		"name" : "MXNet"
	},
	{
		"id" : 4415,
		"name" : "OLAP"
	},
	{
		"id" : 4416,
		"name" : "Power Pivot"
	},
	{
		"id" : 4417,
		"name" : "SSIS"
	},
	{
		"id" : 4418,
		"name" : "SSAS"
	},
	{
		"id" : 4419,
		"name" : "IIS"
	},
	{
		"id" : 4420,
		"name" : "Active Directory(AD)"
	},
	{
		"id" : 4421,
		"name" : "RDS"
	},
	{
		"id" : 4422,
		"name" : "Exchange Mail Server"
	},
	{
		"id" : 4423,
		"name" : "UX Research"
	},
	{
		"id" : 4424,
		"name" : "Visual Design"
	},
	{
		"id" : 4425,
		"name" : "User empathy"
	},
	{
		"id" : 4426,
		"name" : "Interaction Design"
	},
	{
		"id" : 4427,
		"name" : "Collaboration"
	},
	{
		"id" : 4428,
		"name" : "Information Architecture"
	},
	{
		"id" : 4429,
		"name" : "Wireframing"
	},
	{
		"id" : 4430,
		"name" : "UI Prototyping"
	},
	{
		"id" : 4431,
		"name" : "Branding"
	},
	{
		"id" : 4432,
		"name" : "Sketching"
	},
	{
		"id" : 4433,
		"name" : "Typography"
	},
	{
		"id" : 4434,
		"name" : "Responsive Designs"
	},
	{
		"id" : 4435,
		"name" : "Figma"
	},
	{
		"id" : 4436,
		"name" : "Sketch App"
	},
	{
		"id" : 4437,
		"name" : "Adobe XD"
	},
	{
		"id" : 4438,
		"name" : "Adobe Photoshop"
	},
	{
		"id" : 4439,
		"name" : "Adobe Illustrator"
	},
	{
		"id" : 4440,
		"name" : "Adobe Indesign"
	},
	{
		"id" : 4441,
		"name" : "Adobe AfterEffect"
	},
	{
		"id" : 4442,
		"name" : "InVision"
	},
	{
		"id" : 4443,
		"name" : "Marvel App"
	},
	{
		"id" : 4444,
		"name" : "Flinto"
	},
	{
		"id" : 4445,
		"name" : "Zeplin"
	},
	{
		"id" : 4446,
		"name" : "Sigma"
	},
	{
		"id" : 4447,
		"name" : "THEOplayer"
	},
	{
		"id" : 4448,
		"name" : "Azure Media Services"
	},
	{
		"id" : 4449,
		"name" : "Azure CDN"
	},
	{
		"id" : 4450,
		"name" : "DRM"
	},
	{
		"id" : 4451,
		"name" : "Software Testing"
	},
	{
		"id" : 1914,
		"name" : "Event Store"
	},
	{
		"id" : 1915,
		"name" : "Firebird"
	},
	{
		"id" : 4396,
		"name" : "Informatica"
	},
	{
		"id" : 4397,
		"name" : "LDAP"
	},
	{
		"id" : 4402,
		"name" : "SDK"
	},
	{
		"id" : 4186,
		"name" : "Deep Neural Networks"
	},
	{
		"id" : 4188,
		"name" : "Recurrent Neural Networks"
	},
	{
		"id" : 4189,
		"name" : "Convolutional Networks"
	},
	{
		"id" : 4190,
		"name" : "Autoencoders"
	},
	{
		"id" : 4191,
		"name" : "Robotic Process Automation"
	},
	{
		"id" : 4192,
		"name" : "Big Data Analytics"
	},
	{
		"id" : 4194,
		"name" : "ADAM Adagrad"
	},
	{
		"id" : 4195,
		"name" : "Momentum"
	},
	{
		"id" : 4354,
		"name" : "TargetProcess"
	},
	{
		"id" : 4355,
		"name" : "Planbox"
	},
	{
		"id" : 4356,
		"name" : "VersionOne"
	},
	{
		"id" : 4351,
		"name" : "Business Model Analysis"
	},
	{
		"id" : 4482,
		"name" : "SAFe Agile"
	},
	{
		"id" : 4508,
		"name" : "Avaya products"
	},
	{
		"id" : 4472,
		"name" : "Azure DevOps"
	},
	{
		"id" : 4473,
		"name" : "Salt"
	},
	{
		"id" : 4474,
		"name" : "PowerShell"
	},
	{
		"id" : 4475,
		"name" : "Azure SQL"
	},
	{
		"id" : 4476,
		"name" : "Azure Data Lake"
	},
	{
		"id" : 3935,
		"name" : "Flask"
	},
	{
		"id" : 4326,
		"name" : "Time Management"
	},
	{
		"id" : 4327,
		"name" : "Facilitation"
	},
	{
		"id" : 4328,
		"name" : "Problem Solving"
	},
	{
		"id" : 4329,
		"name" : "Analytical Thinking"
	},
	{
		"id" : 4330,
		"name" : "Stakeholder Analysis"
	},
	{
		"id" : 4331,
		"name" : "Leadership"
	},
	{
		"id" : 4332,
		"name" : "Management"
	},
	{
		"id" : 4333,
		"name" : "Requirements Engineering"
	},
	{
		"id" : 4334,
		"name" : "Costs Benefit Analysis"
	},
	{
		"id" : 4335,
		"name" : "Processes Modeling"
	},
	{
		"id" : 4336,
		"name" : "SAS"
	},
	{
		"id" : 4337,
		"name" : "SPSS"
	},
	{
		"id" : 4338,
		"name" : "STATA"
	},
	{
		"id" : 4339,
		"name" : "Data Visualization"
	},
	{
		"id" : 4340,
		"name" : "Blueprint"
	},
	{
		"id" : 4341,
		"name" : "MS Visio"
	},
	{
		"id" : 3682,
		"name" : "Google Cloud"
	},
	{
		"id" : 4343,
		"name" : "Trello"
	},
	{
		"id" : 4344,
		"name" : "BPM"
	},
	{
		"id" : 4345,
		"name" : "Data Munging"
	},
	{
		"id" : 4346,
		"name" : "Sage"
	},
	{
		"id" : 4347,
		"name" : "Mathematica"
	},
	{
		"id" : 4348,
		"name" : "MOST Analysis"
	},
	{
		"id" : 4349,
		"name" : "System Analysis"
	},
	{
		"id" : 4350,
		"name" : "PESTLE Analysis"
	},
	{
		"id" : 4352,
		"name" : "FogBugz"
	},
	{
		"id" : 4353,
		"name" : "Rally"
	},
	{
		"id" : 4509,
		"name" : "Avaya Aura"
	},
	{
		"id" : 4510,
		"name" : "SIP\/H.323 protocols"
	},
	{
		"id" : 4511,
		"name" : "ERS"
	},
	{
		"id" : 4512,
		"name" : "SR"
	},
	{
		"id" : 1916,
		"name" : "GraphDB"
	},
	{
		"id" : 1917,
		"name" : "HANA"
	},
	{
		"id" : 1918,
		"name" : "InfluxDB"
	},
	{
		"id" : 1919,
		"name" : "InterBase"
	},
	{
		"id" : 1921,
		"name" : "Liquibase"
	},
	{
		"id" : 1923,
		"name" : "MemSQL"
	},
	{
		"id" : 1925,
		"name" : "MS Access"
	},
	{
		"id" : 1928,
		"name" : "Navicat"
	},
	{
		"id" : 1935,
		"name" : "OTBI"
	},
	{
		"id" : 1936,
		"name" : "OrientDB"
	},
	{
		"id" : 3558,
		"name" : "Unix"
	},
	{
		"id" : 1947,
		"name" : "Redshift"
	},
	{
		"id" : 1949,
		"name" : "RethinkDB"
	},
	{
		"id" : 1950,
		"name" : "Riak"
	},
	{
		"id" : 1932,
		"name" : "Object-related mapping (ORM)"
	},
	{
		"id" : 1934,
		"name" : "ORD"
	},
	{
		"id" : 1943,
		"name" : "Primary Key"
	},
	{
		"id" : 1962,
		"name" : "Sqlmap"
	},
	{
		"id" : 1893,
		"name" : "DBMS"
	},
	{
		"id" : 1939,
		"name" : "PL\/SQL"
	},
	{
		"id" : 1999,
		"name" : "XML"
	},
	{
		"id" : 1903,
		"name" : "CRUD"
	},
	{
		"id" : 1904,
		"name" : "CSV"
	},
	{
		"id" : 1913,
		"name" : "EnterpriseDB"
	},
	{
		"id" : 4477,
		"name" : "HD Insights"
	},
	{
		"id" : 4478,
		"name" : "Azure Stream Analytics"
	},
	{
		"id" : 4481,
		"name" : "Azure ML"
	},
	{
		"id" : 1219,
		"name" : "Electron"
	},
	{
		"id" : 1222,
		"name" : "ExtJS"
	},
	{
		"id" : 1408,
		"name" : "Ruby"
	},
	{
		"id" : 1646,
		"name" : "C++"
	},
	{
		"id" : 3603,
		"name" : "MERN Stack"
	},
	{
		"id" : 3610,
		"name" : "Jenkins"
	},
	{
		"id" : 1296,
		"name" : "TypeScript"
	},
	{
		"id" : 3548,
		"name" : "Web Development"
	},
	{
		"id" : 3549,
		"name" : "Smart Contracts"
	},
	{
		"id" : 1168,
		"name" : "CSS"
	},
	{
		"id" : 3594,
		"name" : "Json"
	},
	{
		"id" : 3553,
		"name" : "P2P networks"
	},
	{
		"id" : 3555,
		"name" : "Hyperledger"
	},
	{
		"id" : 3556,
		"name" : "EOS"
	},
	{
		"id" : 3557,
		"name" : "SE\/SSE\/TL"
	},
	{
		"id" : 1169,
		"name" : "HTML"
	},
	{
		"id" : 3559,
		"name" : "Openshift"
	},
	{
		"id" : 3560,
		"name" : "Swaps"
	},
	{
		"id" : 3561,
		"name" : "Memory Management"
	},
	{
		"id" : 3562,
		"name" : "Transaction Management"
	},
	{
		"id" : 3563,
		"name" : "SIDE"
	},
	{
		"id" : 3564,
		"name" : "PDF"
	},
	{
		"id" : 3567,
		"name" : "Network Testing"
	},
	{
		"id" : 3568,
		"name" : "Mining"
	},
	{
		"id" : 3569,
		"name" : "Concept Design"
	},
	{
		"id" : 3570,
		"name" : "Usage"
	},
	{
		"id" : 3571,
		"name" : "Application Support"
	},
	{
		"id" : 3572,
		"name" : "Deployment"
	},
	{
		"id" : 3573,
		"name" : "Solidity"
	},
	{
		"id" : 3574,
		"name" : "Web3.js"
	},
	{
		"id" : 3578,
		"name" : "Advanced Java"
	},
	{
		"id" : 3580,
		"name" : "Manager Technology"
	},
	{
		"id" : 3581,
		"name" : "Sawtooth"
	},
	{
		"id" : 3582,
		"name" : "Cloud"
	},
	{
		"id" : 1365,
		"name" : "Laravel"
	},
	{
		"id" : 3586,
		"name" : "Codebases"
	},
	{
		"id" : 3587,
		"name" : "Tron"
	},
	{
		"id" : 3588,
		"name" : "Scalability"
	},
	{
		"id" : 3589,
		"name" : "Corda"
	},
	{
		"id" : 3595,
		"name" : "Design Patterns"
	},
	{
		"id" : 3592,
		"name" : "Decentralized Finance"
	},
	{
		"id" : 3590,
		"name" : "Truffle"
	},
	{
		"id" : 3605,
		"name" : "JIRA"
	},
	{
		"id" : 3596,
		"name" : "Fullstack"
	},
	{
		"id" : 1313,
		"name" : "C"
	},
	{
		"id" : 3598,
		"name" : "Front End"
	},
	{
		"id" : 3599,
		"name" : "Cryptocurrency"
	},
	{
		"id" : 3600,
		"name" : "SDLC"
	},
	{
		"id" : 3601,
		"name" : "Maintenance"
	},
	{
		"id" : 3602,
		"name" : "ZooKeeper"
	},
	{
		"id" : 3607,
		"name" : "QT"
	},
	{
		"id" : 3608,
		"name" : "Chain Code Lifecycle"
	},
	{
		"id" : 1881,
		"name" : "Spark SQL"
	},
	{
		"id" : 1711,
		"name" : "Go"
	},
	{
		"id" : 1885,
		"name" : "Key-Value Database"
	},
	{
		"id" : 1898,
		"name" : "Big Table"
	},
	{
		"id" : 1931,
		"name" : "NoSQL databases"
	},
	{
		"id" : 3617,
		"name" : "Rest"
	},
	{
		"id" : 3643,
		"name" : "Microsoft CRM"
	},
	{
		"id" : 3645,
		"name" : "SalesLogix"
	},
	{
		"id" : 3650,
		"name" : "Force.com IDE"
	},
	{
		"id" : 3652,
		"name" : "XP\/SCRUM"
	},
	{
		"id" : 1390,
		"name" : "Yii"
	},
	{
		"id" : 3597,
		"name" : "Bitcoin"
	},
	{
		"id" : 3653,
		"name" : "Eclipse IDE"
	},
	{
		"id" : 3654,
		"name" : "Talend Open Studio"
	},
	{
		"id" : 2008,
		"name" : "Docker"
	},
	{
		"id" : 3655,
		"name" : "O\/R Mapping"
	},
	{
		"id" : 3657,
		"name" : "SOA"
	},
	{
		"id" : 3658,
		"name" : "Metadata APIs"
	},
	{
		"id" : 1324,
		"name" : "Express.js"
	},
	{
		"id" : 1982,
		"name" : "AWS"
	},
	{
		"id" : 3659,
		"name" : "Data Migration"
	},
	{
		"id" : 1464,
		"name" : "Hibernate"
	},
	{
		"id" : 1528,
		"name" : "Spring MVC"
	},
	{
		"id" : 3660,
		"name" : "Marketo & Zuora"
	},
	{
		"id" : 2009,
		"name" : "Kubernetes"
	},
	{
		"id" : 3579,
		"name" : "Agile"
	},
	{
		"id" : 1930,
		"name" : "NoSQL"
	},
	{
		"id" : 3552,
		"name" : "Data Structures"
	},
	{
		"id" : 1899,
		"name" : "Cassandra"
	},
	{
		"id" : 3583,
		"name" : "Azure"
	},
	{
		"id" : 3662,
		"name" : "Workbench"
	},
	{
		"id" : 3663,
		"name" : "Mavensmate"
	},
	{
		"id" : 3665,
		"name" : "App Builder"
	},
	{
		"id" : 3666,
		"name" : "Platform Developer I"
	},
	{
		"id" : 3667,
		"name" : "Platform Developer II"
	},
	{
		"id" : 1581,
		"name" : "ADO.NET"
	},
	{
		"id" : 1643,
		"name" : "ASIO"
	},
	{
		"id" : 1707,
		"name" : "Beego"
	},
	{
		"id" : 3669,
		"name" : "Native"
	},
	{
		"id" : 3670,
		"name" : "SFDC"
	},
	{
		"id" : 3673,
		"name" : "Triggers"
	},
	{
		"id" : 3674,
		"name" : "QA"
	},
	{
		"id" : 1674,
		"name" : "Visual Studio"
	},
	{
		"id" : 1882,
		"name" : "JSONB"
	},
	{
		"id" : 1926,
		"name" : "MS SQL Server"
	},
	{
		"id" : 1944,
		"name" : "RDBMS"
	},
	{
		"id" : 1908,
		"name" : "Database Design"
	},
	{
		"id" : 1909,
		"name" : "Database development"
	},
	{
		"id" : 1910,
		"name" : "DB2"
	},
	{
		"id" : 1937,
		"name" : "Percona DB"
	},
	{
		"id" : 1967,
		"name" : "Voldemort"
	},
	{
		"id" : 1894,
		"name" : "Azure Cosmos DB"
	},
	{
		"id" : 1895,
		"name" : "ArangoDB"
	},
	{
		"id" : 1896,
		"name" : "AWR"
	},
	{
		"id" : 1897,
		"name" : "Berkeley DB"
	},
	{
		"id" : 1900,
		"name" : "CockroachDB"
	},
	{
		"id" : 1887,
		"name" : "RDMS"
	},
	{
		"id" : 1938,
		"name" : "PervasiveSQL"
	},
	{
		"id" : 1933,
		"name" : "Oracle Database"
	},
	{
		"id" : 1942,
		"name" : "Presto"
	},
	{
		"id" : 1945,
		"name" : "Database migration"
	},
	{
		"id" : 1941,
		"name" : "PostgreSQL"
	},
	{
		"id" : 1961,
		"name" : "SQLite"
	},
	{
		"id" : 1922,
		"name" : "MariaDB"
	},
	{
		"id" : 1901,
		"name" : "CouchBase"
	},
	{
		"id" : 1902,
		"name" : "CouchDB"
	},
	{
		"id" : 1924,
		"name" : "MongoDB"
	},
	{
		"id" : 1927,
		"name" : "MySQL"
	},
	{
		"id" : 1958,
		"name" : "SQL"
	},
	{
		"id" : 1640,
		"name" : "wxPython"
	},
	{
		"id" : 1675,
		"name" : "wxWidgets"
	},
	{
		"id" : 1389,
		"name" : "XDebug"
	},
	{
		"id" : 1743,
		"name" : "Xtend"
	},
	{
		"id" : 1600,
		"name" : "xUnit.net"
	},
	{
		"id" : 1391,
		"name" : "Zend Framework"
	},
	{
		"id" : 1676,
		"name" : "ZeroMQ"
	},
	{
		"id" : 1542,
		"name" : "ZK"
	},
	{
		"id" : 1543,
		"name" : "ZXing"
	},
	{
		"id" : 1331,
		"name" : "Node.js"
	},
	{
		"id" : 1278,
		"name" : "ReactJS"
	},
	{
		"id" : 3606,
		"name" : "AngularJS"
	},
	{
		"id" : 4531,
		"name" : "Other"
	},
	{
		"id" : 2501,
		"name" : "TSQL development"
	},
	{
		"id" : 1678,
		"name" : "C language"
	},
	{
		"id" : 1778,
		"name" : "iOS frameworks"
	},
	{
		"id" : 1951,
		"name" : "ETL (Extract, Transform and Load)"
	},
	{
		"id" : 2174,
		"name" : "Mongo DB"
	},
	{
		"id" : 2177,
		"name" : "Unix Command Line"
	},
	{
		"id" : 2178,
		"name" : "Agile Development"
	},
	{
		"id" : 2179,
		"name" : "Research Skills"
	},
	{
		"id" : 2404,
		"name" : "Oracle On-Demand"
	},
	{
		"id" : 2515,
		"name" : "Heroku"
	},
	{
		"id" : 2596,
		"name" : "goodd"
	},
	{
		"id" : 2622,
		"name" : "datagrip"
	},
	{
		"id" : 2000,
		"name" : "TM1"
	},
	{
		"id" : 2700,
		"name" : "Data Extraction"
	},
	{
		"id" : 2710,
		"name" : "ATG"
	},
	{
		"id" : 2711,
		"name" : "Oracle Commerce tech stack"
	},
	{
		"id" : 2712,
		"name" : "unity"
	},
	{
		"id" : 2409,
		"name" : "ETL Tools"
	},
	{
		"id" : 2159,
		"name" : "win32"
	},
	{
		"id" : 2715,
		"name" : "java 11"
	},
	{
		"id" : 2716,
		"name" : "HAL"
	},
	{
		"id" : 2717,
		"name" : "ROR"
	},
	{
		"id" : 2718,
		"name" : "Spring Cloud"
	},
	{
		"id": 4543,
		"name": "Project Management"
	},
	{
		"id": 4544,
		"name": "Delivery"
	},
	{
		"id": 4544,
		"name": "ITL"
	},
	{
		"id": 4546 ,
		"name": "Unity Developer"
	}
]

export const keySkills = [
{ "skillName": "React", "skillId": 1246 },
{ "skillName": "Rails/Ruby on Rails", "skillId": 1415 },
{ "skillName": "Python", "skillId": 1624 },
{ "skillName": "Angular", "skillId": 1186 }
]

export const projectSkills = [
	{
		"skillId" : 1246,
		"skillName" : "React"
	},
  	{
		"skillId" : 1415,
		"skillName" : "Rails/Ruby on Rails"
	},
	{
		"skillId" : 1624,
		"skillName" : "Python"
	},
	{
		"skillId" : 1186,
		"skillName" : "Angular"
	},
	{
		"skillId" : 1362,
		"skillName" : "PHP"
	},
	{
		"skillId" : 1864,
		"skillName" : "Flutter"
	},
	{
		"skillId" : 1314,
		"skillName" : "Golang"
	},
	{
		"skillId": 1505,
		"skillName": "Kotlin"
	},
	{
		"skillId" : 2005,
		"skillName" : "DevOps"
	},
	{
		"skillId" : 1452,
		"skillName" : "Java"
	},
	{
		"skillId" : 1990,
		"skillName" : ".Net"
	},
	{
		"skillId" : 1171,
		"skillName" : "Axios"
	},
	{
		"skillId" : 1172,
		"skillName" : "Material-UI"
	},
	{
		"skillId" : 1173,
		"skillName" : "NgRx"
	},
	{
		"skillId" : 1174,
		"skillName" : "AppRun"
	},
	{
		"skillId" : 1175,
		"skillName" : "SSR"
	},
	{
		"skillId" : 1176,
		"skillName" : "Angular Universal"
	},
	{
		"skillId" : 1177,
		"skillName" : "Styled Components"
	},
	{
		"skillId" : 1178,
		"skillName" : "Storybook"
	},
	{
		"skillId" : 1179,
		"skillName" : "TypeORM"
	},
	{
		"skillId" : 1180,
		"skillName" : "Rollup"
	},
	{
		"skillId" : 1181,
		"skillName" : "WebGPU"
	},
	{
		"skillId" : 1183,
		"skillName" : "CSS animations"
	},
	{
		"skillId" : 1285,
		"skillName" : "SAML"
	},
	{
		"skillId" : 1187,
		"skillName" : "Angular 2"
	},
	{
		"skillId" : 1188,
		"skillName" : "AngularFire"
	},
	{
		"skillId" : 1189,
		"skillName" : "Angular CLI"
	},
	{
		"skillId" : 1190,
		"skillName" : "Ant Design"
	},
	{
		"skillId" : 1191,
		"skillName" : "Atom"
	},
	{
		"skillId" : 1192,
		"skillName" : "Aurelia"
	},
	{
		"skillId" : 1193,
		"skillName" : "Babel"
	},
	{
		"skillId" : 1194,
		"skillName" : "BabylonJS"
	},
	{
		"skillId" : 1195,
		"skillName" : "Backbone.js"
	},
	{
		"skillId" : 1196,
		"skillName" : "BEM"
	},
	{
		"skillId" : 1197,
		"skillName" : "Blaze"
	},
	{
		"skillId" : 1199,
		"skillName" : "Bourbon"
	},
	{
		"skillId" : 1200,
		"skillName" : "Bower"
	},
	{
		"skillId" : 1201,
		"skillName" : "Brackets"
	},
	{
		"skillId" : 1202,
		"skillName" : "Broccoli"
	},
	{
		"skillId" : 1203,
		"skillName" : "Browserify"
	},
	{
		"skillId" : 1204,
		"skillName" : "Brunch"
	},
	{
		"skillId" : 1205,
		"skillName" : "CanvasJS"
	},
	{
		"skillId" : 1206,
		"skillName" : "Chart.js"
	},
	{
		"skillId" : 1207,
		"skillName" : "ClojureScript"
	},
	{
		"skillId" : 1208,
		"skillName" : "Compass"
	},
	{
		"skillId" : 1209,
		"skillName" : "Core.js"
	},
	{
		"skillId" : 1210,
		"skillName" : "CSS Modules"
	},
	{
		"skillId" : 1211,
		"skillName" : "CSS Preprocessor"
	},
	{
		"skillId" : 1212,
		"skillName" : "CSS-related"
	},
	{
		"skillId" : 1213,
		"skillName" : "Cypress"
	},
	{
		"skillId" : 1214,
		"skillName" : "DHTML"
	},
	{
		"skillId" : 1215,
		"skillName" : "Dojo"
	},
	{
		"skillId" : 1216,
		"skillName" : "DOM"
	},
	{
		"skillId" : 1217,
		"skillName" : "Dust.js"
	},
	{
		"skillId" : 1218,
		"skillName" : "ECMAScript"
	},
	{
		"skillId" : 1604,
		"skillName" : "BeeWare"
	},
	{
		"skillId" : 1220,
		"skillName" : "Ember.js"
	},
	{
		"skillId" : 1221,
		"skillName" : "ESLint"
	},
	{
		"skillId" : 1495,
		"skillName" : "JPA"
	},
	{
		"skillId" : 1223,
		"skillName" : "Flexbox"
	},
	{
		"skillId" : 1224,
		"skillName" : "Flux"
	},
	{
		"skillId" : 1225,
		"skillName" : "Foundation"
	},
	{
		"skillId" : 1226,
		"skillName" : "Front-end"
	},
	{
		"skillId" : 1227,
		"skillName" : "GraphQL"
	},
	{
		"skillId" : 1228,
		"skillName" : "Grunt"
	},
	{
		"skillId" : 1229,
		"skillName" : "GSAP"
	},
	{
		"skillId" : 1230,
		"skillName" : "Gulp"
	},
	{
		"skillId" : 1232,
		"skillName" : "Handlebars.js"
	},
	{
		"skillId" : 1233,
		"skillName" : "Highcharts"
	},
	{
		"skillId" : 1234,
		"skillName" : "HTML4"
	},
	{
		"skillId" : 1236,
		"skillName" : "Zurb"
	},
	{
		"skillId" : 1237,
		"skillName" : "Bootstap"
	},
	{
		"skillId" : 1238,
		"skillName" : "Canvas"
	},
	{
		"skillId" : 1239,
		"skillName" : "WebGL"
	},
	{
		"skillId" : 1241,
		"skillName" : "Hyper-V"
	},
	{
		"skillId" : 1242,
		"skillName" : "Immutable.js"
	},
	{
		"skillId" : 1243,
		"skillName" : "Infragistics"
	},
	{
		"skillId" : 1244,
		"skillName" : "Isomorphic apps"
	},
	{
		"skillId" : 1245,
		"skillName" : "JavaScript frameworks"
	},
	{
		"skillId" : 4516,
		"skillName" : "Shopify"
	},
	{
		"skillId" : 1247,
		"skillName" : "Backbone"
	},
	{
		"skillId" : 1248,
		"skillName" : "Knockout.js"
	},
	{
		"skillId" : 1249,
		"skillName" : "D3.js"
	},
	{
		"skillId" : 1251,
		"skillName" : "Mercury.js"
	},
	{
		"skillId" : 1252,
		"skillName" : "​WebRx"
	},
	{
		"skillId" : 1254,
		"skillName" : "JFace"
	},
	{
		"skillId" : 1256,
		"skillName" : "jQuery UI"
	},
	{
		"skillId" : 1257,
		"skillName" : "JSS"
	},
	{
		"skillId" : 1258,
		"skillName" : "JSX"
	},
	{
		"skillId" : 1259,
		"skillName" : "Kendo"
	},
	{
		"skillId" : 1260,
		"skillName" : "Knockout"
	},
	{
		"skillId" : 1261,
		"skillName" : "Leaflet"
	},
	{
		"skillId" : 1263,
		"skillName" : "Marionette"
	},
	{
		"skillId" : 1264,
		"skillName" : "Masonry"
	},
	{
		"skillId" : 1265,
		"skillName" : "Mercury"
	},
	{
		"skillId" : 1266,
		"skillName" : "MobX"
	},
	{
		"skillId" : 1267,
		"skillName" : "Modernizr"
	},
	{
		"skillId" : 1268,
		"skillName" : "Mustache"
	},
	{
		"skillId" : 1269,
		"skillName" : "Nunjucks"
	},
	{
		"skillId" : 1270,
		"skillName" : "NVD3"
	},
	{
		"skillId" : 1271,
		"skillName" : "OOCSS"
	},
	{
		"skillId" : 1272,
		"skillName" : "PaperJS"
	},
	{
		"skillId" : 1273,
		"skillName" : "PixiJS"
	},
	{
		"skillId" : 1274,
		"skillName" : "Polymer"
	},
	{
		"skillId" : 1275,
		"skillName" : "PostCSS"
	},
	{
		"skillId" : 1276,
		"skillName" : "PrimeNG"
	},
	{
		"skillId" : 1277,
		"skillName" : "Prototype"
	},
	{
		"skillId" : 1279,
		"skillName" : "Redux"
	},
	{
		"skillId" : 1281,
		"skillName" : "Relay"
	},
	{
		"skillId" : 1282,
		"skillName" : "Rematch"
	},
	{
		"skillId" : 1283,
		"skillName" : "RequireJS"
	},
	{
		"skillId" : 1284,
		"skillName" : "RxJS"
	},
	{
		"skillId" : 1287,
		"skillName" : "SCSS"
	},
	{
		"skillId" : 1288,
		"skillName" : "Skeleton"
	},
	{
		"skillId" : 1289,
		"skillName" : "Socket.IO"
	},
	{
		"skillId" : 1290,
		"skillName" : "Spine JS"
	},
	{
		"skillId" : 1292,
		"skillName" : "Sublime Text"
	},
	{
		"skillId" : 1293,
		"skillName" : "Three.js"
	},
	{
		"skillId" : 1294,
		"skillName" : "Thunk"
	},
	{
		"skillId" : 1295,
		"skillName" : "Turret"
	},
	{
		"skillId" : 1297,
		"skillName" : "Underscore.js"
	},
	{
		"skillId" : 1298,
		"skillName" : "Vanilla JS"
	},
	{
		"skillId" : 1299,
		"skillName" : "Vue"
	},
	{
		"skillId" : 1300,
		"skillName" : "Vuex"
	},
	{
		"skillId" : 1301,
		"skillName" : "WebdriverIO"
	},
	{
		"skillId" : 1302,
		"skillName" : "WebKit"
	},
	{
		"skillId" : 1303,
		"skillName" : "webpack"
	},
	{
		"skillId" : 1304,
		"skillName" : "WebRx"
	},
	{
		"skillId" : 4517,
		"skillName" : "Blue Prism"
	},
	{
		"skillId" : 1305,
		"skillName" : "WebSphere"
	},
	{
		"skillId" : 1306,
		"skillName" : "WebStorm"
	},
	{
		"skillId" : 1307,
		"skillName" : "WinForms"
	},
	{
		"skillId" : 1310,
		"skillName" : "YAML"
	},
	{
		"skillId" : 1340,
		"skillName" : "APC"
	},
	{
		"skillId" : 1308,
		"skillName" : "WSDL"
	},
	{
		"skillId" : 1198,
		"skillName" : "Bootstrap"
	},
	{
		"skillId" : 1321,
		"skillName" : "asm.js"
	},
	{
		"skillId" : 1286,
		"skillName" : "Sass"
	},
	{
		"skillId" : 1280,
		"skillName" : "redux-saga"
	},
	{
		"skillId" : 1309,
		"skillName" : "XHTML"
	},
	{
		"skillId" : 1312,
		"skillName" : "C# (.NET)"
	},
	{
		"skillId" : 1240,
		"skillName" : "HTMLPad"
	},
	{
		"skillId" : 1231,
		"skillName" : "Haml"
	},
	{
		"skillId" : 1253,
		"skillName" : "Vue.js​"
	},
	{
		"skillId" : 1182,
		"skillName" : "Svelte"
	},
	{
		"skillId" : 3520,
		"skillName" : "SAP-PP"
	},
	{
		"skillId" : 1185,
		"skillName" : "AMP"
	},
	{
		"skillId" : 1550,
		"skillName" : "ASP.NET"
	},
	{
		"skillId" : 1728,
		"skillName" : "Assembly language"
	},
	{
		"skillId" : 1603,
		"skillName" : "asyncio"
	},
	{
		"skillId" : 1341,
		"skillName" : "Bitrix Framework"
	},
	{
		"skillId" : 1342,
		"skillName" : "Blackfire"
	},
	{
		"skillId" : 1686,
		"skillName" : "BlueEyes"
	},
	{
		"skillId" : 1605,
		"skillName" : "Bokeh"
	},
	{
		"skillId" : 1644,
		"skillName" : "Boost"
	},
	{
		"skillId" : 1326,
		"skillName" : "Hapi"
	},
	{
		"skillId" : 1606,
		"skillName" : "Bottle"
	},
	{
		"skillId" : 1394,
		"skillName" : "Brakeman"
	},
	{
		"skillId" : 1708,
		"skillName" : "Buffalo"
	},
	{
		"skillId" : 1395,
		"skillName" : "Bundler"
	},
	{
		"skillId" : 1430,
		"skillName" : "Burp Suite"
	},
	{
		"skillId" : 1333,
		"skillName" : "Oracle JET"
	},
	{
		"skillId" : 1334,
		"skillName" : "Restify"
	},
	{
		"skillId" : 3521,
		"skillName" : "SAP-MM"
	},
	{
		"skillId" : 1413,
		"skillName" : "Capistrano"
	},
	{
		"skillId" : 1396,
		"skillName" : "Capybara"
	},
	{
		"skillId" : 1338,
		"skillName" : "PHP CodeSniffer"
	},
	{
		"skillId" : 1687,
		"skillName" : "Cats"
	},
	{
		"skillId" : 1729,
		"skillName" : "CCL"
	},
	{
		"skillId" : 1433,
		"skillName" : "CDI"
	},
	{
		"skillId" : 1688,
		"skillName" : "Chaos"
	},
	{
		"skillId" : 1560,
		"skillName" : "Chart FX"
	},
	{
		"skillId" : 1608,
		"skillName" : "CherryPy"
	},
	{
		"skillId" : 1651,
		"skillName" : "Clang"
	},
	{
		"skillId" : 1348,
		"skillName" : "Guzzle"
	},
	{
		"skillId" : 1349,
		"skillName" : "HHVM"
	},
	{
		"skillId" : 1432,
		"skillName" : "ClearTK"
	},
	{
		"skillId" : 1652,
		"skillName" : "CLion"
	},
	{
		"skillId" : 1718,
		"skillName" : "Clojure"
	},
	{
		"skillId" : 1561,
		"skillName" : "CLR"
	},
	{
		"skillId" : 1343,
		"skillName" : "CMS"
	},
	{
		"skillId" : 1730,
		"skillName" : "COBOL"
	},
	{
		"skillId" : 1344,
		"skillName" : "Codeception"
	},
	{
		"skillId" : 1366,
		"skillName" : "CodeIgniter"
	},
	{
		"skillId" : 1731,
		"skillName" : "CoffeeScript"
	},
	{
		"skillId" : 1689,
		"skillName" : "Colossus"
	},
	{
		"skillId" : 1372,
		"skillName" : "Composer"
	},
	{
		"skillId" : 1363,
		"skillName" : "PHP frameworks"
	},
	{
		"skillId" : 3522,
		"skillName" : "SAP-SD"
	},
	{
		"skillId" : 1653,
		"skillName" : "Cppcheck"
	},
	{
		"skillId" : 1367,
		"skillName" : "PHP keywords"
	},
	{
		"skillId" : 1368,
		"skillName" : "Twig (templating)"
	},
	{
		"skillId" : 1369,
		"skillName" : "PHPUnit (testing)"
	},
	{
		"skillId" : 1371,
		"skillName" : "PHPStorm (IDE)"
	},
	{
		"skillId" : 1654,
		"skillName" : "CppDB"
	},
	{
		"skillId" : 1373,
		"skillName" : "PHP-FIG"
	},
	{
		"skillId" : 1374,
		"skillName" : "PHP-FPM"
	},
	{
		"skillId" : 1375,
		"skillName" : "phpDocumentor"
	},
	{
		"skillId" : 1376,
		"skillName" : "PHPSpec"
	},
	{
		"skillId" : 1377,
		"skillName" : "PhpStorm"
	},
	{
		"skillId" : 1609,
		"skillName" : "CPython"
	},
	{
		"skillId" : 1397,
		"skillName" : "Crystal"
	},
	{
		"skillId" : 1473,
		"skillName" : "Cucumber"
	},
	{
		"skillId" : 1679,
		"skillName" : "CUDA"
	},
	{
		"skillId" : 1322,
		"skillName" : "Cycle.js"
	},
	{
		"skillId" : 1732,
		"skillName" : "Cypher"
	},
	{
		"skillId" : 1733,
		"skillName" : "Dart"
	},
	{
		"skillId" : 1610,
		"skillName" : "Dask"
	},
	{
		"skillId" : 1734,
		"skillName" : "Delphi"
	},
	{
		"skillId" : 1320,
		"skillName" : "Deno"
	},
	{
		"skillId" : 1323,
		"skillName" : "Derby"
	},
	{
		"skillId" : 1345,
		"skillName" : "Doctrine"
	},
	{
		"skillId" : 1613,
		"skillName" : "Docutils"
	},
	{
		"skillId" : 1393,
		"skillName" : "Active Record"
	},
	{
		"skillId" : 1434,
		"skillName" : "Dropwizard"
	},
	{
		"skillId" : 1346,
		"skillName" : "Drupal"
	},
	{
		"skillId" : 1339,
		"skillName" : "Drush"
	},
	{
		"skillId" : 1435,
		"skillName" : "DWR"
	},
	{
		"skillId" : 1471,
		"skillName" : "EasyMock"
	},
	{
		"skillId" : 1709,
		"skillName" : "Echo"
	},
	{
		"skillId" : 1436,
		"skillName" : "EclipseLink"
	},
	{
		"skillId" : 1437,
		"skillName" : "Ehcache"
	},
	{
		"skillId" : 1262,
		"skillName" : "LESS"
	},
	{
		"skillId" : 1419,
		"skillName" : "Core Java"
	},
	{
		"skillId" : 1315,
		"skillName" : "Functional Programming (FP)"
	},
	{
		"skillId" : 1611,
		"skillName" : "Django"
	},
	{
		"skillId" : 1409,
		"skillName" : "RubyGems"
	},
	{
		"skillId" : 1410,
		"skillName" : "Ruby Arrays"
	},
	{
		"skillId" : 1411,
		"skillName" : "Ruby deployment"
	},
	{
		"skillId" : 1370,
		"skillName" : "Doctrine (ORM)"
	},
	{
		"skillId" : 1250,
		"skillName" : "Sencha"
	},
	{
		"skillId" : 1414,
		"skillName" : "Ruby frameworks"
	},
	{
		"skillId" : 1747,
		"skillName" : "Accelerate framework"
	},
	{
		"skillId" : 1748,
		"skillName" : "AFNetworking"
	},
	{
		"skillId" : 1749,
		"skillName" : "Alamofire"
	},
	{
		"skillId" : 1750,
		"skillName" : "APNs"
	},
	{
		"skillId" : 1425,
		"skillName" : "ADF"
	},
	{
		"skillId" : 1454,
		"skillName" : "Ant"
	},
	{
		"skillId" : 1429,
		"skillName" : "Apollo"
	},
	{
		"skillId" : 1553,
		"skillName" : "Autofac"
	},
	{
		"skillId" : 1554,
		"skillName" : "AutoMapper"
	},
	{
		"skillId" : 1465,
		"skillName" : "EJB"
	},
	{
		"skillId" : 1422,
		"skillName" : "JBDC"
	},
	{
		"skillId" : 1423,
		"skillName" : "Java Profiler"
	},
	{
		"skillId" : 1424,
		"skillName" : "ActiveMQ"
	},
	{
		"skillId" : 1426,
		"skillName" : "Apache Ant"
	},
	{
		"skillId" : 1427,
		"skillName" : "Apache Camel"
	},
	{
		"skillId" : 1428,
		"skillName" : "Apache MINA"
	},
	{
		"skillId" : 1719,
		"skillName" : "Elixir"
	},
	{
		"skillId" : 1431,
		"skillName" : "Cactus "
	},
	{
		"skillId" : 1720,
		"skillName" : "Elm"
	},
	{
		"skillId" : 1562,
		"skillName" : "F#"
	},
	{
		"skillId" : 1438,
		"skillName" : "Facelets"
	},
	{
		"skillId" : 1400,
		"skillName" : "FactoryBot"
	},
	{
		"skillId" : 1337,
		"skillName" : "FeathersJS"
	},
	{
		"skillId" : 1690,
		"skillName" : "Finatra"
	},
	{
		"skillId" : 1691,
		"skillName" : "Finch"
	},
	{
		"skillId" : 1325,
		"skillName" : "Flow"
	},
	{
		"skillId" : 1439,
		"skillName" : "FreeMarker"
	},
	{
		"skillId" : 1347,
		"skillName" : "Gearman"
	},
	{
		"skillId" : 1440,
		"skillName" : "GemFire"
	},
	{
		"skillId" : 1710,
		"skillName" : "Gin"
	},
	{
		"skillId" : 1444,
		"skillName" : "Guava"
	},
	{
		"skillId" : 1445,
		"skillName" : "GWT"
	},
	{
		"skillId" : 1457,
		"skillName" : "GlassFish"
	},
	{
		"skillId" : 1655,
		"skillName" : "GLSL"
	},
	{
		"skillId" : 1712,
		"skillName" : "GoLand"
	},
	{
		"skillId" : 1441,
		"skillName" : "Google Guice"
	},
	{
		"skillId" : 1713,
		"skillName" : "Gorilla"
	},
	{
		"skillId" : 1656,
		"skillName" : "gperf"
	},
	{
		"skillId" : 1453,
		"skillName" : "Java build tools"
	},
	{
		"skillId" : 1455,
		"skillName" : "Gradle"
	},
	{
		"skillId" : 1456,
		"skillName" : "Java deployment"
	},
	{
		"skillId" : 1442,
		"skillName" : "Grails"
	},
	{
		"skillId" : 1458,
		"skillName" : "Java EE"
	},
	{
		"skillId" : 1459,
		"skillName" : "Java EE frameworks"
	},
	{
		"skillId" : 1401,
		"skillName" : "Grape"
	},
	{
		"skillId" : 1443,
		"skillName" : "Groovy"
	},
	{
		"skillId" : 1446,
		"skillName" : "Hybris"
	},
	{
		"skillId" : 1545,
		"skillName" : "IdentityServer"
	},
	{
		"skillId" : 1723,
		"skillName" : "Idris"
	},
	{
		"skillId" : 4081,
		"skillName" : "IIS Server"
	},
	{
		"skillId" : 1460,
		"skillName" : "Servlets"
	},
	{
		"skillId" : 1447,
		"skillName" : "IntelliJ IDEA"
	},
	{
		"skillId" : 1462,
		"skillName" : "Java ME"
	},
	{
		"skillId" : 1463,
		"skillName" : "Java ORM frameworks"
	},
	{
		"skillId" : 1714,
		"skillName" : "Iris"
	},
	{
		"skillId" : 1466,
		"skillName" : "Java SE"
	},
	{
		"skillId" : 1467,
		"skillName" : "Java SE frameworks"
	},
	{
		"skillId" : 1468,
		"skillName" : "Java testing tools"
	},
	{
		"skillId" : 1474,
		"skillName" : "JavaCC"
	},
	{
		"skillId" : 1475,
		"skillName" : "JavaFX"
	},
	{
		"skillId" : 1476,
		"skillName" : "JAXB"
	},
	{
		"skillId" : 1477,
		"skillName" : "JAX-RS"
	},
	{
		"skillId" : 1478,
		"skillName" : "JAX-WS"
	},
	{
		"skillId" : 1479,
		"skillName" : "JBoss"
	},
	{
		"skillId" : 1482,
		"skillName" : "JDeferred"
	},
	{
		"skillId" : 1483,
		"skillName" : "JDeveloper"
	},
	{
		"skillId" : 1448,
		"skillName" : "JAAS"
	},
	{
		"skillId" : 1449,
		"skillName" : "Jackson"
	},
	{
		"skillId" : 1450,
		"skillName" : "JADE"
	},
	{
		"skillId" : 1461,
		"skillName" : "JAF"
	},
	{
		"skillId" : 1451,
		"skillName" : "JasperReports"
	},
	{
		"skillId" : 1489,
		"skillName" : "JMC"
	},
	{
		"skillId" : 1490,
		"skillName" : "JMM"
	},
	{
		"skillId" : 1491,
		"skillName" : "JMock"
	},
	{
		"skillId" : 1492,
		"skillName" : "JMS"
	},
	{
		"skillId" : 1493,
		"skillName" : "JMX"
	},
	{
		"skillId" : 1494,
		"skillName" : "JNI"
	},
	{
		"skillId" : 3611,
		"skillName" : "Java8"
	},
	{
		"skillId" : 1484,
		"skillName" : "JDK"
	},
	{
		"skillId" : 1402,
		"skillName" : "Jekyll"
	},
	{
		"skillId" : 1485,
		"skillName" : "Jersey"
	},
	{
		"skillId" : 1486,
		"skillName" : "Jetty"
	},
	{
		"skillId" : 1487,
		"skillName" : "JFlex"
	},
	{
		"skillId" : 1488,
		"skillName" : "JFR"
	},
	{
		"skillId" : 1614,
		"skillName" : "Jinja2"
	},
	{
		"skillId" : 1350,
		"skillName" : "Joomla"
	},
	{
		"skillId" : 1496,
		"skillName" : "JPQL"
	},
	{
		"skillId" : 1497,
		"skillName" : "JRE"
	},
	{
		"skillId" : 1418,
		"skillName" : "JRuby"
	},
	{
		"skillId" : 4083,
		"skillName" : "JSOM"
	},
	{
		"skillId" : 1499,
		"skillName" : "JSoup"
	},
	{
		"skillId" : 1502,
		"skillName" : "JUnit"
	},
	{
		"skillId" : 1503,
		"skillName" : "JVM"
	},
	{
		"skillId" : 1563,
		"skillName" : "Kentico"
	},
	{
		"skillId" : 1504,
		"skillName" : "KeyStore"
	},
	{
		"skillId" : 1626,
		"skillName" : "Kivy"
	},
	{
		"skillId" : 1327,
		"skillName" : "Koa"
	},
	{
		"skillId" : 1351,
		"skillName" : "Kohana"
	},
	{
		"skillId" : 1681,
		"skillName" : "Kore"
	},
	{
		"skillId" : 1519,
		"skillName" : "RESTEasy"
	},
	{
		"skillId" : 1506,
		"skillName" : "Lambda"
	},
	{
		"skillId" : 1352,
		"skillName" : "LAMP"
	},
	{
		"skillId" : 1507,
		"skillName" : "Launch4j"
	},
	{
		"skillId" : 1481,
		"skillName" : "JDBC"
	},
	{
		"skillId" : 1356,
		"skillName" : "Memcached"
	},
	{
		"skillId" : 1526,
		"skillName" : "Spring Boot"
	},
	{
		"skillId" : 1527,
		"skillName" : "Spring Integration"
	},
	{
		"skillId" : 3577,
		"skillName" : "GIT"
	},
	{
		"skillId" : 1529,
		"skillName" : "Spring WebFlux"
	},
	{
		"skillId" : 1525,
		"skillName" : "Spring"
	},
	{
		"skillId" : 1505,
		"skillName" : "Kotlin"
	},
	{
		"skillId" : 1532,
		"skillName" : "Struts 2"
	},
	{
		"skillId" : 1498,
		"skillName" : "JSF"
	},
	{
		"skillId" : 1548,
		"skillName" : ".NET"
	},
	{
		"skillId" : 4518,
		"skillName" : "UiPath"
	},
	{
		"skillId" : 1642,
		"skillName" : "ACE"
	},
	{
		"skillId" : 3620,
		"skillName" : "Apache"
	},
	{
		"skillId" : 1555,
		"skillName" : "C#"
	},
	{
		"skillId" : 3584,
		"skillName" : "Kafka"
	},
	{
		"skillId" : 4142,
		"skillName" : "Neural Networks"
	},
	{
		"skillId" : 3523,
		"skillName" : "SAP-HR"
	},
	{
		"skillId" : 3524,
		"skillName" : "SAP-CRM"
	},
	{
		"skillId" : 1544,
		"skillName" : "ASP.NET Web Forms"
	},
	{
		"skillId" : 3525,
		"skillName" : "SAP-ABAP"
	},
	{
		"skillId" : 1546,
		"skillName" : "ASP.NET Web API"
	},
	{
		"skillId" : 1547,
		"skillName" : "ASP.NET AJAX\/Atlas"
	},
	{
		"skillId" : 3526,
		"skillName" : "SAP-XI"
	},
	{
		"skillId" : 3527,
		"skillName" : "SAP-Net Viewer"
	},
	{
		"skillId" : 1551,
		"skillName" : "ASP.NET Core"
	},
	{
		"skillId" : 1552,
		"skillName" : "ASP.NET MVC"
	},
	{
		"skillId" : 3528,
		"skillName" : "SAP-BASIS"
	},
	{
		"skillId" : 3529,
		"skillName" : "SAP-BIW"
	},
	{
		"skillId" : 3530,
		"skillName" : "SAP-GRC Consultant"
	},
	{
		"skillId" : 1557,
		"skillName" : ".NET 1.0"
	},
	{
		"skillId" : 1558,
		"skillName" : ".NET 4.5"
	},
	{
		"skillId" : 1559,
		"skillName" : "C# testing tools"
	},
	{
		"skillId" : 3531,
		"skillName" : "Business Objects Report Designer"
	},
	{
		"skillId" : 3532,
		"skillName" : "SAP-HANA"
	},
	{
		"skillId" : 3533,
		"skillName" : "SAP-Security Administrator"
	},
	{
		"skillId" : 4519,
		"skillName" : "UI Automation"
	},
	{
		"skillId" : 1993,
		"skillName" : "Linux"
	},
	{
		"skillId" : 3565,
		"skillName" : "Networking"
	},
	{
		"skillId" : 3616,
		"skillName" : "Web Architecture"
	},
	{
		"skillId" : 3618,
		"skillName" : "NPM"
	},
	{
		"skillId" : 3619,
		"skillName" : "Varnish"
	},
	{
		"skillId" : 3622,
		"skillName" : "Scrum"
	},
	{
		"skillId" : 3623,
		"skillName" : "Hibernate and JPA"
	},
	{
		"skillId" : 1572,
		"skillName" : ".NET Core"
	},
	{
		"skillId" : 3632,
		"skillName" : "RoR Stack"
	},
	{
		"skillId" : 3634,
		"skillName" : "WEBrick Server"
	},
	{
		"skillId" : 3635,
		"skillName" : "MS VB Script"
	},
	{
		"skillId" : 3636,
		"skillName" : "J2EE"
	},
	{
		"skillId" : 3638,
		"skillName" : "Vue.js"
	},
	{
		"skillId" : 1549,
		"skillName" : "Accord.NET Framework"
	},
	{
		"skillId" : 1586,
		"skillName" : "Roslyn (.NET Compiler Platform)"
	},
	{
		"skillId" : 1580,
		"skillName" : "Linq2SQL"
	},
	{
		"skillId" : 1615,
		"skillName" : "Jupyter (IPython)"
	},
	{
		"skillId" : 1751,
		"skillName" : "AppCode"
	},
	{
		"skillId" : 1752,
		"skillName" : "Auto Layout"
	},
	{
		"skillId" : 1753,
		"skillName" : "ARC"
	},
	{
		"skillId" : 1754,
		"skillName" : "ARKit"
	},
	{
		"skillId" : 1755,
		"skillName" : "AVFoundation"
	},
	{
		"skillId" : 1756,
		"skillName" : "Bond"
	},
	{
		"skillId" : 1757,
		"skillName" : "Carthage"
	},
	{
		"skillId" : 1758,
		"skillName" : "Clean Architecture (VIPER)"
	},
	{
		"skillId" : 1759,
		"skillName" : "Cocoa"
	},
	{
		"skillId" : 1760,
		"skillName" : "Cocoa Touch"
	},
	{
		"skillId" : 1761,
		"skillName" : "CocoaPods"
	},
	{
		"skillId" : 1763,
		"skillName" : "Core Bluetooth"
	},
	{
		"skillId" : 1764,
		"skillName" : "Core Data"
	},
	{
		"skillId" : 1765,
		"skillName" : "Core Graphics"
	},
	{
		"skillId" : 3547,
		"skillName" : "Cryptography"
	},
	{
		"skillId" : 3550,
		"skillName" : "Ethereum"
	},
	{
		"skillId" : 1602,
		"skillName" : "Django REST framework"
	},
	{
		"skillId" : 3551,
		"skillName" : "Blockchain Architecture"
	},
	{
		"skillId" : 1480,
		"skillName" : "jBPM"
	},
	{
		"skillId" : 1766,
		"skillName" : "Core Location"
	},
	{
		"skillId" : 1767,
		"skillName" : "CoreFoundation"
	},
	{
		"skillId" : 1768,
		"skillName" : "CoreImage"
	},
	{
		"skillId" : 1612,
		"skillName" : "Django Channels"
	},
	{
		"skillId" : 1625,
		"skillName" : "Python frameworks"
	},
	{
		"skillId" : 1769,
		"skillName" : "EventKit"
	},
	{
		"skillId" : 1780,
		"skillName" : "iOS SDK"
	},
	{
		"skillId" : 1781,
		"skillName" : "iOS tools"
	},
	{
		"skillId" : 1782,
		"skillName" : "MapKit"
	},
	{
		"skillId" : 1783,
		"skillName" : "Memory Graph Debugger"
	},
	{
		"skillId" : 4179,
		"skillName" : "Keras Framework"
	},
	{
		"skillId" : 1638,
		"skillName" : "Web2py"
	},
	{
		"skillId" : 4180,
		"skillName" : "Wamp"
	},
	{
		"skillId" : 4182,
		"skillName" : "Tensorflow Framework"
	},
	{
		"skillId" : 4185,
		"skillName" : "Computer Vision"
	},
	{
		"skillId" : 1784,
		"skillName" : "MessageUI"
	},
	{
		"skillId" : 1785,
		"skillName" : "Metal"
	},
	{
		"skillId" : 1645,
		"skillName" : "C++ 11"
	},
	{
		"skillId" : 1647,
		"skillName" : "C++ 14"
	},
	{
		"skillId" : 1648,
		"skillName" : "C++ 17"
	},
	{
		"skillId" : 1649,
		"skillName" : "C++ frameworks"
	},
	{
		"skillId" : 1786,
		"skillName" : "Moya framework"
	},
	{
		"skillId" : 1787,
		"skillName" : "Multitasking"
	},
	{
		"skillId" : 3671,
		"skillName" : "LWC"
	},
	{
		"skillId" : 1788,
		"skillName" : "Nimble"
	},
	{
		"skillId" : 1789,
		"skillName" : "NSOperation"
	},
	{
		"skillId" : 1791,
		"skillName" : "POP"
	},
	{
		"skillId" : 1792,
		"skillName" : "Property Lists"
	},
	{
		"skillId" : 1793,
		"skillName" : "Quick"
	},
	{
		"skillId" : 1794,
		"skillName" : "QuickBlox"
	},
	{
		"skillId" : 1795,
		"skillName" : "Reactive code"
	},
	{
		"skillId" : 1796,
		"skillName" : "ReactiveCocoa"
	},
	{
		"skillId" : 1798,
		"skillName" : "Realm"
	},
	{
		"skillId" : 1799,
		"skillName" : "RxSwift"
	},
	{
		"skillId" : 1800,
		"skillName" : "Stack Views"
	},
	{
		"skillId" : 1801,
		"skillName" : "StoreKit"
	},
	{
		"skillId" : 1727,
		"skillName" : "Ada"
	},
	{
		"skillId" : 1683,
		"skillName" : "Akka"
	},
	{
		"skillId" : 1677,
		"skillName" : "ANSI C"
	},
	{
		"skillId" : 1680,
		"skillName" : "Libmicrohttpd"
	},
	{
		"skillId" : 1657,
		"skillName" : "GStreamer"
	},
	{
		"skillId" : 1693,
		"skillName" : "Lift"
	},
	{
		"skillId" : 1564,
		"skillName" : "LINQ"
	},
	{
		"skillId" : 1508,
		"skillName" : "Log4j"
	},
	{
		"skillId" : 1565,
		"skillName" : "Log4net"
	},
	{
		"skillId" : 1658,
		"skillName" : "Loki"
	},
	{
		"skillId" : 1737,
		"skillName" : "Lua"
	},
	{
		"skillId" : 1664,
		"skillName" : "PwC (contract programming)"
	},
	{
		"skillId" : 1509,
		"skillName" : "Lucene"
	},
	{
		"skillId" : 1353,
		"skillName" : "Lumen"
	},
	{
		"skillId" : 1354,
		"skillName" : "Magento"
	},
	{
		"skillId" : 1355,
		"skillName" : "MAMP"
	},
	{
		"skillId" : 1738,
		"skillName" : "Maple"
	},
	{
		"skillId" : 1328,
		"skillName" : "MEAN"
	},
	{
		"skillId" : 1744,
		"skillName" : "Swinject"
	},
	{
		"skillId" : 1511,
		"skillName" : "MeshCMS"
	},
	{
		"skillId" : 1329,
		"skillName" : "Meteor"
	},
	{
		"skillId" : 1659,
		"skillName" : "MFC"
	},
	{
		"skillId" : 1421,
		"skillName" : "Micronaut"
	},
	{
		"skillId" : 3612,
		"skillName" : "Microservices"
	},
	{
		"skillId" : 1403,
		"skillName" : "Minitest"
	},
	{
		"skillId" : 1357,
		"skillName" : "Mockery"
	},
	{
		"skillId" : 1472,
		"skillName" : "Mockito"
	},
	{
		"skillId" : 1684,
		"skillName" : "Akka HTTP"
	},
	{
		"skillId" : 1685,
		"skillName" : "Apache Kafka"
	},
	{
		"skillId" : 1358,
		"skillName" : "MODX"
	},
	{
		"skillId" : 1682,
		"skillName" : "Monix"
	},
	{
		"skillId" : 1566,
		"skillName" : "Mono"
	},
	{
		"skillId" : 1567,
		"skillName" : "Moq"
	},
	{
		"skillId" : 1568,
		"skillName" : "MsBuild"
	},
	{
		"skillId" : 1569,
		"skillName" : "MS Dynamics 365"
	},
	{
		"skillId" : 1692,
		"skillName" : "http4s"
	},
	{
		"skillId" : 4085,
		"skillName" : "MS Office 365"
	},
	{
		"skillId" : 1694,
		"skillName" : "Lift 3.0-RC1"
	},
	{
		"skillId" : 1570,
		"skillName" : "MStest"
	},
	{
		"skillId" : 1696,
		"skillName" : "Play 2.5.0"
	},
	{
		"skillId" : 1697,
		"skillName" : "sbt"
	},
	{
		"skillId" : 1698,
		"skillName" : "SBT 0.13.12"
	},
	{
		"skillId" : 1359,
		"skillName" : "MySQLi"
	},
	{
		"skillId" : 1700,
		"skillName" : "Scala frameworks"
	},
	{
		"skillId" : 1701,
		"skillName" : "Scalatra"
	},
	{
		"skillId" : 1702,
		"skillName" : "Scalaz"
	},
	{
		"skillId" : 1571,
		"skillName" : "Nancy"
	},
	{
		"skillId" : 1317,
		"skillName" : "NestJS"
	},
	{
		"skillId" : 1745,
		"skillName" : "GHUnit"
	},
	{
		"skillId" : 1512,
		"skillName" : "Netty"
	},
	{
		"skillId" : 1330,
		"skillName" : "Next"
	},
	{
		"skillId" : 1573,
		"skillName" : "Ninject"
	},
	{
		"skillId" : 4087,
		"skillName" : "Nintex Forms"
	},
	{
		"skillId" : 1574,
		"skillName" : "NuGet"
	},
	{
		"skillId" : 1319,
		"skillName" : "NW.js"
	},
	{
		"skillId" : 1513,
		"skillName" : "OC4J"
	},
	{
		"skillId" : 1724,
		"skillName" : "OCaml"
	},
	{
		"skillId" : 1716,
		"skillName" : "Absinthe"
	},
	{
		"skillId" : 1360,
		"skillName" : "OpenCart"
	},
	{
		"skillId" : 1660,
		"skillName" : "OpenCL"
	},
	{
		"skillId" : 1661,
		"skillName" : "OpenGL Mathematics"
	},
	{
		"skillId" : 1662,
		"skillName" : "OpenInventor"
	},
	{
		"skillId" : 1722,
		"skillName" : "Haskell"
	},
	{
		"skillId" : 1332,
		"skillName" : "OpenLayers"
	},
	{
		"skillId" : 1510,
		"skillName" : "Maven"
	},
	{
		"skillId" : 1577,
		"skillName" : "ORM frameworks"
	},
	{
		"skillId" : 1726,
		"skillName" : "ActionScript"
	},
	{
		"skillId" : 1514,
		"skillName" : "OSGi"
	},
	{
		"skillId" : 1582,
		"skillName" : "OWIN"
	},
	{
		"skillId" : 1417,
		"skillName" : "Padrino"
	},
	{
		"skillId" : 1412,
		"skillName" : "Passenger"
	},
	{
		"skillId" : 1361,
		"skillName" : "Phalcon"
	},
	{
		"skillId" : 1746,
		"skillName" : "3D Touch"
	},
	{
		"skillId" : 1735,
		"skillName" : "Hack"
	},
	{
		"skillId" : 1736,
		"skillName" : "Haxe"
	},
	{
		"skillId" : 2094,
		"skillName" : "Sanity testing"
	},
	{
		"skillId" : 2095,
		"skillName" : "Security testing"
	},
	{
		"skillId" : 2100,
		"skillName" : "Smoke Testing"
	},
	{
		"skillId" : 1578,
		"skillName" : "NHibernate"
	},
	{
		"skillId" : 1575,
		"skillName" : "NUnit"
	},
	{
		"skillId" : 1616,
		"skillName" : "matplotlib"
	},
	{
		"skillId" : 1576,
		"skillName" : "Octopus"
	},
	{
		"skillId" : 1739,
		"skillName" : "Perl"
	},
	{
		"skillId" : 4464,
		"skillName" : "DevSecOps"
	},
	{
		"skillId" : 4465,
		"skillName" : "OAuth"
	},
	{
		"skillId" : 4466,
		"skillName" : "OIDC"
	},
	{
		"skillId" : 4467,
		"skillName" : "MFA"
	},
	{
		"skillId" : 4468,
		"skillName" : "JIT"
	},
	{
		"skillId" : 4469,
		"skillName" : "RBAC"
	},
	{
		"skillId" : 4470,
		"skillName" : "Ping"
	},
	{
		"skillId" : 4471,
		"skillName" : "SIEM"
	},
	{
		"skillId" : 4156,
		"skillName" : "R"
	},
	{
		"skillId" : 4479,
		"skillName" : "SQL Analytics"
	},
	{
		"skillId" : 4480,
		"skillName" : "Data Lake Analytics"
	},
	{
		"skillId" : 4483,
		"skillName" : "Waterfall"
	},
	{
		"skillId" : 4484,
		"skillName" : "Iterative"
	},
	{
		"skillId" : 4485,
		"skillName" : "TOGAF"
	},
	{
		"skillId" : 4486,
		"skillName" : "Pivotal"
	},
	{
		"skillId" : 1762,
		"skillName" : "Core Animation"
	},
	{
		"skillId" : 4487,
		"skillName" : "CISSIP"
	},
	{
		"skillId" : 4488,
		"skillName" : "Zachman"
	},
	{
		"skillId" : 4489,
		"skillName" : "ITIL"
	},
	{
		"skillId" : 4490,
		"skillName" : "Cisco"
	},
	{
		"skillId" : 4491,
		"skillName" : "(ISC)2"
	},
	{
		"skillId" : 4520,
		"skillName" : "Machine Learning"
	},
	{
		"skillId" : 4521,
		"skillName" : "Artificial Intelligence"
	},
	{
		"skillId" : 1775,
		"skillName" : "In APP purchase"
	},
	{
		"skillId" : 1404,
		"skillName" : "Phoenix"
	},
	{
		"skillId" : 4492,
		"skillName" : "CEH"
	},
	{
		"skillId" : 4493,
		"skillName" : "SAFe"
	},
	{
		"skillId" : 4494,
		"skillName" : "PMI"
	},
	{
		"skillId" : 4495,
		"skillName" : "Activity Diagram"
	},
	{
		"skillId" : 4496,
		"skillName" : "Class Diagram"
	},
	{
		"skillId" : 4497,
		"skillName" : "Solutions Architecture Consultation"
	},
	{
		"skillId" : 4498,
		"skillName" : "Sequence Diagram"
	},
	{
		"skillId" : 4499,
		"skillName" : "Apache Tomcat"
	},
	{
		"skillId" : 4500,
		"skillName" : "Cloud Computing"
	},
	{
		"skillId" : 4501,
		"skillName" : "Elasticsearch"
	},
	{
		"skillId" : 4502,
		"skillName" : "Microsoft IIS"
	},
	{
		"skillId" : 4503,
		"skillName" : "Online Transaction Processing (OLTP)"
	},
	{
		"skillId" : 4504,
		"skillName" : "RESTful"
	},
	{
		"skillId" : 4505,
		"skillName" : "UML"
	},
	{
		"skillId" : 4506,
		"skillName" : "Web Servers"
	},
	{
		"skillId" : 4507,
		"skillName" : "State Diagram"
	},
	{
		"skillId" : 1797,
		"skillName" : "ReactiveKit"
	},
	{
		"skillId" : 4513,
		"skillName" : "Power Apps"
	},
	{
		"skillId" : 4514,
		"skillName" : "Power Virtual Agents"
	},
	{
		"skillId" : 4515,
		"skillName" : "Power Automate"
	},
	{
		"skillId" : 1929,
		"skillName" : "Neo4j"
	},
	{
		"skillId" : 1170,
		"skillName" : "JavaScript"
	},
	{
		"skillId" : 1960,
		"skillName" : "SQL Server"
	},
	{
		"skillId" : 3585,
		"skillName" : "Cosmos"
	},
	{
		"skillId" : 3647,
		"skillName" : "SAP"
	},
	{
		"skillId" : 1836,
		"skillName" : "greenDAO"
	},
	{
		"skillId" : 4522,
		"skillName" : "Azure Data Factory (ADF)"
	},
	{
		"skillId" : 4523,
		"skillName" : "Sitecore Framework"
	},
	{
		"skillId" : 1815,
		"skillName" : "Android keywords"
	},
	{
		"skillId" : 1843,
		"skillName" : "Reactive pattern"
	},
	{
		"skillId" : 1860,
		"skillName" : "Cross-platform Mobile (mostly JavaScript)"
	},
	{
		"skillId" : 1867,
		"skillName" : "Ionic"
	},
	{
		"skillId" : 1878,
		"skillName" : "Xamarin Studio"
	},
	{
		"skillId" : 1879,
		"skillName" : "Xamarin.Forms"
	},
	{
		"skillId" : 1880,
		"skillName" : "Mobile applications"
	},
	{
		"skillId" : 1770,
		"skillName" : "Fabric"
	},
	{
		"skillId" : 1771,
		"skillName" : "FastLane"
	},
	{
		"skillId" : 1772,
		"skillName" : "Flurry"
	},
	{
		"skillId" : 1774,
		"skillName" : "HockeyApp"
	},
	{
		"skillId" : 1777,
		"skillName" : "iOS 10 Speech Recognition API"
	},
	{
		"skillId" : 1779,
		"skillName" : "iOS programming languages"
	},
	{
		"skillId" : 1883,
		"skillName" : "ClickHouse"
	},
	{
		"skillId" : 1884,
		"skillName" : "ScyllaDB"
	},
	{
		"skillId" : 1969,
		"skillName" : "SaaS"
	},
	{
		"skillId" : 1970,
		"skillName" : "IaaS"
	},
	{
		"skillId" : 1971,
		"skillName" : "PaaS"
	},
	{
		"skillId" : 1995,
		"skillName" : "Hadoop"
	},
	{
		"skillId" : 1968,
		"skillName" : "Cloud Database Engineer"
	},
	{
		"skillId" : 1974,
		"skillName" : "Data Analysis"
	},
	{
		"skillId" : 1980,
		"skillName" : "Authorizations"
	},
	{
		"skillId" : 1981,
		"skillName" : "Protocols"
	},
	{
		"skillId" : 1983,
		"skillName" : "Google Cloud Associate"
	},
	{
		"skillId" : 1984,
		"skillName" : "Solution Architect"
	},
	{
		"skillId" : 1985,
		"skillName" : "HP Expert One Cloud"
	},
	{
		"skillId" : 1986,
		"skillName" : "EMC Cloud Architect"
	},
	{
		"skillId" : 1987,
		"skillName" : "VMware Cloud "
	},
	{
		"skillId" : 1583,
		"skillName" : "P\/Invoke"
	},
	{
		"skillId" : 1997,
		"skillName" : "GCP"
	},
	{
		"skillId" : 2007,
		"skillName" : "Containers"
	},
	{
		"skillId" : 1601,
		"skillName" : "Pipenv"
	},
	{
		"skillId" : 1695,
		"skillName" : "Play"
	},
	{
		"skillId" : 2010,
		"skillName" : "Virtualization"
	},
	{
		"skillId" : 2013,
		"skillName" : "Cloud Security"
	},
	{
		"skillId" : 2014,
		"skillName" : "Cloud Recovery"
	},
	{
		"skillId" : 4524,
		"skillName" : "dynaCache"
	},
	{
		"skillId" : 1907,
		"skillName" : "Database"
	},
	{
		"skillId" : 1996,
		"skillName" : "Microsoft Azure"
	},
	{
		"skillId" : 1940,
		"skillName" : "PostGIS"
	},
	{
		"skillId" : 4525,
		"skillName" : "IBM Websphere Commerce"
	},
	{
		"skillId" : 1802,
		"skillName" : "Storyboard"
	},
	{
		"skillId" : 1804,
		"skillName" : "SwiftyJSON"
	},
	{
		"skillId" : 1805,
		"skillName" : "TestFlight"
	},
	{
		"skillId" : 1806,
		"skillName" : "tvOS"
	},
	{
		"skillId" : 1807,
		"skillName" : "Typhoon"
	},
	{
		"skillId" : 1808,
		"skillName" : "UIKit"
	},
	{
		"skillId" : 1810,
		"skillName" : "XCTest"
	},
	{
		"skillId" : 1811,
		"skillName" : "WatchKit"
	},
	{
		"skillId" : 1812,
		"skillName" : "watchOS"
	},
	{
		"skillId" : 4526,
		"skillName" : "Websphere Commerce"
	},
	{
		"skillId" : 4527,
		"skillName" : "HCL Commerce"
	},
	{
		"skillId" : 1663,
		"skillName" : "POCO"
	},
	{
		"skillId" : 1515,
		"skillName" : "PowerMock"
	},
	{
		"skillId" : 1813,
		"skillName" : "Android Jetpack"
	},
	{
		"skillId" : 1816,
		"skillName" : "ActionBarSherlock"
	},
	{
		"skillId" : 1817,
		"skillName" : "adb"
	},
	{
		"skillId" : 1516,
		"skillName" : "PrimeFaces"
	},
	{
		"skillId" : 1818,
		"skillName" : "ADT"
	},
	{
		"skillId" : 1819,
		"skillName" : "AndEngine"
	},
	{
		"skillId" : 1517,
		"skillName" : "ProGuard"
	},
	{
		"skillId" : 1820,
		"skillName" : "Android Auto"
	},
	{
		"skillId" : 1821,
		"skillName" : "Android IDE"
	},
	{
		"skillId" : 1822,
		"skillName" : "Android N"
	},
	{
		"skillId" : 1823,
		"skillName" : "Android NDK"
	},
	{
		"skillId" : 1824,
		"skillName" : "Android SDK"
	},
	{
		"skillId" : 1378,
		"skillName" : "PSR"
	},
	{
		"skillId" : 1825,
		"skillName" : "Android Studio"
	},
	{
		"skillId" : 1826,
		"skillName" : "Android TV"
	},
	{
		"skillId" : 1827,
		"skillName" : "Android Wear"
	},
	{
		"skillId" : 1828,
		"skillName" : "AppCompat"
	},
	{
		"skillId" : 1829,
		"skillName" : "ButterKnife"
	},
	{
		"skillId" : 1830,
		"skillName" : "Conductor"
	},
	{
		"skillId" : 1976,
		"skillName" : "ERP"
	},
	{
		"skillId" : 1831,
		"skillName" : "Dagger"
	},
	{
		"skillId" : 1316,
		"skillName" : "Puppeteer"
	},
	{
		"skillId" : 1832,
		"skillName" : "DBFlow"
	},
	{
		"skillId" : 2004,
		"skillName" : "Web Services"
	},
	{
		"skillId" : 4178,
		"skillName" : "Speech Recognition"
	},
	{
		"skillId" : 1617,
		"skillName" : "PyBrain"
	},
	{
		"skillId" : 1833,
		"skillName" : "Espresso"
	},
	{
		"skillId" : 4181,
		"skillName" : "Calculus"
	},
	{
		"skillId" : 1834,
		"skillName" : "Evernote"
	},
	{
		"skillId" : 2019,
		"skillName" : "Ab Initio"
	},
	{
		"skillId" : 2021,
		"skillName" : "Appium"
	},
	{
		"skillId" : 2022,
		"skillName" : "Arquillian"
	},
	{
		"skillId" : 2023,
		"skillName" : "AutoIt"
	},
	{
		"skillId" : 2025,
		"skillName" : "Baseline testing"
	},
	{
		"skillId" : 1835,
		"skillName" : "Fresco"
	},
	{
		"skillId" : 1556,
		"skillName" : "C# frameworks"
	},
	{
		"skillId" : 2003,
		"skillName" : "API"
	},
	{
		"skillId" : 1905,
		"skillName" : "Data Architecture"
	},
	{
		"skillId" : 1920,
		"skillName" : "Google Compute Engine"
	},
	{
		"skillId" : 1776,
		"skillName" : "iOS"
	},
	{
		"skillId" : 1814,
		"skillName" : "Android"
	},
	{
		"skillId" : 2017,
		"skillName" : "Scenario testing"
	},
	{
		"skillId" : 2018,
		"skillName" : "A\/B testing"
	},
	{
		"skillId" : 1837,
		"skillName" : "gtest"
	},
	{
		"skillId" : 1973,
		"skillName" : "ROI"
	},
	{
		"skillId" : 1975,
		"skillName" : "Data Mining"
	},
	{
		"skillId" : 1977,
		"skillName" : "Risk Analytics"
	},
	{
		"skillId" : 1979,
		"skillName" : "Encryptions"
	},
	{
		"skillId" : 1998,
		"skillName" : "Open Stack"
	},
	{
		"skillId" : 2002,
		"skillName" : "UDDI"
	},
	{
		"skillId" : 2006,
		"skillName" : "AWS DevOps"
	},
	{
		"skillId" : 2011,
		"skillName" : "EC2"
	},
	{
		"skillId" : 2012,
		"skillName" : "Lambdas"
	},
	{
		"skillId" : 1838,
		"skillName" : "LeakCanary"
	},
	{
		"skillId" : 1839,
		"skillName" : "Logcat"
	},
	{
		"skillId" : 1946,
		"skillName" : "Redis"
	},
	{
		"skillId" : 2026,
		"skillName" : "Bazel"
	},
	{
		"skillId" : 2027,
		"skillName" : "Behat"
	},
	{
		"skillId" : 2028,
		"skillName" : "Black-box testing"
	},
	{
		"skillId" : 2029,
		"skillName" : "BlazeMete"
	},
	{
		"skillId" : 2030,
		"skillName" : "Calabash"
	},
	{
		"skillId" : 2031,
		"skillName" : "CasperJS"
	},
	{
		"skillId" : 2032,
		"skillName" : "Chai"
	},
	{
		"skillId" : 2033,
		"skillName" : "Charles"
	},
	{
		"skillId" : 2034,
		"skillName" : "Codacy"
	},
	{
		"skillId" : 2035,
		"skillName" : "Controller"
	},
	{
		"skillId" : 2036,
		"skillName" : "Cross-browser testing"
	},
	{
		"skillId" : 1607,
		"skillName" : "Buildbot"
	},
	{
		"skillId" : 2015,
		"skillName" : "Gherkin"
	},
	{
		"skillId" : 2016,
		"skillName" : "BlazeMeter"
	},
	{
		"skillId" : 1978,
		"skillName" : "Network Security skills"
	},
	{
		"skillId" : 3930,
		"skillName" : "Spark"
	},
	{
		"skillId" : 4528,
		"skillName" : "Product Management"
	},
	{
		"skillId" : 1618,
		"skillName" : "PyCharm"
	},
	{
		"skillId" : 4529,
		"skillName" : "Product Owner"
	},
	{
		"skillId" : 1619,
		"skillName" : "PyGTK"
	},
	{
		"skillId" : 2048,
		"skillName" : "Gatling"
	},
	{
		"skillId" : 2050,
		"skillName" : "HP Performance Center"
	},
	{
		"skillId" : 2051,
		"skillName" : "HP Quality Center"
	},
	{
		"skillId" : 2067,
		"skillName" : "Microsoft Test Manager"
	},
	{
		"skillId" : 2088,
		"skillName" : "QuickCheck"
	},
	{
		"skillId" : 2089,
		"skillName" : "QUnit"
	},
	{
		"skillId" : 2092,
		"skillName" : "ReportNG"
	},
	{
		"skillId" : 2093,
		"skillName" : "Robolectric"
	},
	{
		"skillId" : 4530,
		"skillName" : "Product Manager"
	},
	{
		"skillId" : 2114,
		"skillName" : "UFT (Unified Functional Testing)"
	},
	{
		"skillId" : 2097,
		"skillName" : "Siege"
	},
	{
		"skillId" : 1840,
		"skillName" : "Mortar"
	},
	{
		"skillId" : 1841,
		"skillName" : "Mosby"
	},
	{
		"skillId" : 1959,
		"skillName" : "SQL Server AlwaysOn"
	},
	{
		"skillId" : 2072,
		"skillName" : "NeoLoad"
	},
	{
		"skillId" : 2098,
		"skillName" : "Sinon"
	},
	{
		"skillId" : 2099,
		"skillName" : "SoapUI"
	},
	{
		"skillId" : 1842,
		"skillName" : "Picasso"
	},
	{
		"skillId" : 2101,
		"skillName" : "SpiraTest"
	},
	{
		"skillId" : 2102,
		"skillName" : "Spock"
	},
	{
		"skillId" : 2103,
		"skillName" : "Static analysis"
	},
	{
		"skillId" : 2104,
		"skillName" : "STLC"
	},
	{
		"skillId" : 2105,
		"skillName" : "Stress testing"
	},
	{
		"skillId" : 2106,
		"skillName" : "Sumo Logic"
	},
	{
		"skillId" : 2107,
		"skillName" : "Surefire"
	},
	{
		"skillId" : 2108,
		"skillName" : "Telerik Test Studio"
	},
	{
		"skillId" : 2109,
		"skillName" : "Test case"
	},
	{
		"skillId" : 2110,
		"skillName" : "TestLink"
	},
	{
		"skillId" : 1844,
		"skillName" : "RecyclerView"
	},
	{
		"skillId" : 1845,
		"skillName" : "RoboSpice"
	},
	{
		"skillId" : 1846,
		"skillName" : "Robotium"
	},
	{
		"skillId" : 2116,
		"skillName" : "WAPT"
	},
	{
		"skillId" : 2117,
		"skillName" : "WatiN"
	},
	{
		"skillId" : 2118,
		"skillName" : "WebDriver"
	},
	{
		"skillId" : 1847,
		"skillName" : "Room library"
	},
	{
		"skillId" : 1848,
		"skillName" : "RxAndroid"
	},
	{
		"skillId" : 1849,
		"skillName" : "RxJava"
	},
	{
		"skillId" : 1850,
		"skillName" : "SpongyCastle"
	},
	{
		"skillId" : 2124,
		"skillName" : "System Testing"
	},
	{
		"skillId" : 2125,
		"skillName" : "Test strategy"
	},
	{
		"skillId" : 1851,
		"skillName" : "Support Library"
	},
	{
		"skillId" : 2127,
		"skillName" : "QA engineering"
	},
	{
		"skillId" : 2128,
		"skillName" : "Bug tracking"
	},
	{
		"skillId" : 2129,
		"skillName" : "Test Planning"
	},
	{
		"skillId" : 1852,
		"skillName" : "Volley"
	},
	{
		"skillId" : 2090,
		"skillName" : "Ranorex"
	},
	{
		"skillId" : 1291,
		"skillName" : "Stylus"
	},
	{
		"skillId" : 2068,
		"skillName" : "Mocha"
	},
	{
		"skillId" : 2055,
		"skillName" : "Jasmine"
	},
	{
		"skillId" : 1853,
		"skillName" : "UI Automator"
	},
	{
		"skillId" : 1854,
		"skillName" : "BLoC Pattern"
	},
	{
		"skillId" : 2020,
		"skillName" : "Ad-Hoc Distribution (Mobile)"
	},
	{
		"skillId" : 2024,
		"skillName" : "Automation Testing"
	},
	{
		"skillId" : 2038,
		"skillName" : "DbUnit"
	},
	{
		"skillId" : 2039,
		"skillName" : "Defect tracking"
	},
	{
		"skillId" : 2040,
		"skillName" : "Dynamic analysis"
	},
	{
		"skillId" : 2041,
		"skillName" : "E2E Testing"
	},
	{
		"skillId" : 2043,
		"skillName" : "Endurance Testing"
	},
	{
		"skillId" : 2044,
		"skillName" : "Enzyme"
	},
	{
		"skillId" : 2045,
		"skillName" : "FitNesse"
	},
	{
		"skillId" : 1855,
		"skillName" : "Native Mobile App"
	},
	{
		"skillId" : 2047,
		"skillName" : "Galen Framework"
	},
	{
		"skillId" : 2052,
		"skillName" : "IBM RPT"
	},
	{
		"skillId" : 2054,
		"skillName" : "Iperf"
	},
	{
		"skillId" : 2056,
		"skillName" : "JavaScript testing tools"
	},
	{
		"skillId" : 2057,
		"skillName" : "JBehave"
	},
	{
		"skillId" : 2058,
		"skillName" : "Jest"
	},
	{
		"skillId" : 2059,
		"skillName" : "JMeter"
	},
	{
		"skillId" : 2060,
		"skillName" : "Jtest"
	},
	{
		"skillId" : 2061,
		"skillName" : "Kali Linux"
	},
	{
		"skillId" : 2062,
		"skillName" : "Karma"
	},
	{
		"skillId" : 2063,
		"skillName" : "Load testing"
	},
	{
		"skillId" : 2064,
		"skillName" : "LoadRunner"
	},
	{
		"skillId" : 2065,
		"skillName" : "LoadUI"
	},
	{
		"skillId" : 2066,
		"skillName" : "Manual testing"
	},
	{
		"skillId" : 2073,
		"skillName" : "Nightwatch.js"
	},
	{
		"skillId" : 2074,
		"skillName" : "Nodeunit"
	},
	{
		"skillId" : 2075,
		"skillName" : "Nose"
	},
	{
		"skillId" : 2076,
		"skillName" : "Okapi Framework"
	},
	{
		"skillId" : 2049,
		"skillName" : "Gray-box testing"
	},
	{
		"skillId" : 2070,
		"skillName" : "Monkey testing"
	},
	{
		"skillId" : 2071,
		"skillName" : "Negative testing"
	},
	{
		"skillId" : 2091,
		"skillName" : "Regression testing"
	},
	{
		"skillId" : 1856,
		"skillName" : "Mobile Application Development"
	},
	{
		"skillId" : 2079,
		"skillName" : "Testing"
	},
	{
		"skillId" : 2080,
		"skillName" : "PhantomJS"
	},
	{
		"skillId" : 2081,
		"skillName" : "PHPUnit"
	},
	{
		"skillId" : 2082,
		"skillName" : "Protractor"
	},
	{
		"skillId" : 2083,
		"skillName" : "Pytest"
	},
	{
		"skillId" : 2084,
		"skillName" : "QC"
	},
	{
		"skillId" : 2085,
		"skillName" : "qTest"
	},
	{
		"skillId" : 2086,
		"skillName" : "QTP"
	},
	{
		"skillId" : 2087,
		"skillName" : "Quality Assurance (QA)"
	},
	{
		"skillId" : 3534,
		"skillName" : "Retrofit"
	},
	{
		"skillId" : 3535,
		"skillName" : "WebEngage"
	},
	{
		"skillId" : 3536,
		"skillName" : "Angular4"
	},
	{
		"skillId" : 3537,
		"skillName" : "Mule ESB"
	},
	{
		"skillId" : 3538,
		"skillName" : "RAML"
	},
	{
		"skillId" : 3539,
		"skillName" : "DWL"
	},
	{
		"skillId" : 3540,
		"skillName" : "REST API"
	},
	{
		"skillId" : 3541,
		"skillName" : "POSTMAN"
	},
	{
		"skillId" : 3542,
		"skillName" : "Anypoint studio V4"
	},
	{
		"skillId" : 3543,
		"skillName" : "Angular 6.0"
	},
	{
		"skillId" : 3544,
		"skillName" : "Angular material"
	},
	{
		"skillId" : 3545,
		"skillName" : "Silverlight 4\/5"
	},
	{
		"skillId" : 3546,
		"skillName" : "Reactive Extensions"
	},
	{
		"skillId" : 1857,
		"skillName" : "Apache Flex"
	},
	{
		"skillId" : 1650,
		"skillName" : "CAFFE"
	},
	{
		"skillId" : 1364,
		"skillName" : "CakePHP"
	},
	{
		"skillId" : 1620,
		"skillName" : "Pylons"
	},
	{
		"skillId" : 1621,
		"skillName" : "Pyparsing"
	},
	{
		"skillId" : 3554,
		"skillName" : "Qt Widgets module"
	},
	{
		"skillId" : 1622,
		"skillName" : "Pyramid"
	},
	{
		"skillId" : 1623,
		"skillName" : "Pyston"
	},
	{
		"skillId" : 1665,
		"skillName" : "QtQtCreator"
	},
	{
		"skillId" : 1405,
		"skillName" : "Rake"
	},
	{
		"skillId" : 1666,
		"skillName" : "RapidJSON"
	},
	{
		"skillId" : 1584,
		"skillName" : "Razor"
	},
	{
		"skillId" : 1420,
		"skillName" : "Reactor"
	},
	{
		"skillId" : 1585,
		"skillName" : "ReSharper"
	},
	{
		"skillId" : 1518,
		"skillName" : "Resin"
	},
	{
		"skillId" : 1392,
		"skillName" : "Resque"
	},
	{
		"skillId" : 3566,
		"skillName" : "Research"
	},
	{
		"skillId" : 3519,
		"skillName" : "SAP-FICO"
	},
	{
		"skillId" : 1715,
		"skillName" : "Revel"
	},
	{
		"skillId" : 1520,
		"skillName" : "RichFaces"
	},
	{
		"skillId" : 1521,
		"skillName" : "RoboGuice"
	},
	{
		"skillId" : 1740,
		"skillName" : "RPG"
	},
	{
		"skillId" : 1406,
		"skillName" : "RSpec"
	},
	{
		"skillId" : 1335,
		"skillName" : "Sails"
	},
	{
		"skillId" : 3575,
		"skillName" : "Restful Web Services"
	},
	{
		"skillId" : 3576,
		"skillName" : "Springboot"
	},
	{
		"skillId" : 1858,
		"skillName" : "Bitrise"
	},
	{
		"skillId" : 1703,
		"skillName" : "Scalding"
	},
	{
		"skillId" : 1627,
		"skillName" : "Scapy"
	},
	{
		"skillId" : 1634,
		"skillName" : "SciPy"
	},
	{
		"skillId" : 1628,
		"skillName" : "Scrapy"
	},
	{
		"skillId" : 1629,
		"skillName" : "Seaborn"
	},
	{
		"skillId" : 1522,
		"skillName" : "Seam"
	},
	{
		"skillId" : 1336,
		"skillName" : "Seneca"
	},
	{
		"skillId" : 1587,
		"skillName" : "ServiceStack"
	},
	{
		"skillId" : 1523,
		"skillName" : "Servlet"
	},
	{
		"skillId" : 4454,
		"skillName" : "SFCC"
	},
	{
		"skillId" : 4455,
		"skillName" : "SFRA"
	},
	{
		"skillId" : 1704,
		"skillName" : "Shapeless"
	},
	{
		"skillId" : 3945,
		"skillName" : "SharePoint"
	},
	{
		"skillId" : 1588,
		"skillName" : "SignalR"
	},
	{
		"skillId" : 3593,
		"skillName" : "Blockchain Protocols"
	},
	{
		"skillId" : 1379,
		"skillName" : "Silex"
	},
	{
		"skillId" : 1380,
		"skillName" : "SilverStripe"
	},
	{
		"skillId" : 1416,
		"skillName" : "Sinatra"
	},
	{
		"skillId" : 1589,
		"skillName" : "Sitecore CMS"
	},
	{
		"skillId" : 4456,
		"skillName" : "Slack"
	},
	{
		"skillId" : 1524,
		"skillName" : "SLF4J"
	},
	{
		"skillId" : 1705,
		"skillName" : "Slick"
	},
	{
		"skillId" : 1381,
		"skillName" : "Slim"
	},
	{
		"skillId" : 1382,
		"skillName" : "Smarty"
	},
	{
		"skillId" : 1668,
		"skillName" : "Socket programming"
	},
	{
		"skillId" : 3604,
		"skillName" : "Blockchain Implementation"
	},
	{
		"skillId" : 1590,
		"skillName" : "SpecFlow"
	},
	{
		"skillId" : 1706,
		"skillName" : "Spray"
	},
	{
		"skillId" : 1859,
		"skillName" : "Cordova"
	},
	{
		"skillId" : 3591,
		"skillName" : "DeFi"
	},
	{
		"skillId" : 3609,
		"skillName" : "Spring Planning"
	},
	{
		"skillId" : 2112,
		"skillName" : "Tosca"
	},
	{
		"skillId" : 1861,
		"skillName" : "Cross-Platform Mobile Development"
	},
	{
		"skillId" : 2078,
		"skillName" : "Performance testing"
	},
	{
		"skillId" : 3613,
		"skillName" : "Magento 2"
	},
	{
		"skillId" : 1862,
		"skillName" : "Dojo Mobile"
	},
	{
		"skillId" : 3615,
		"skillName" : "HTTP"
	},
	{
		"skillId" : 1863,
		"skillName" : "Firebase"
	},
	{
		"skillId" : 1865,
		"skillName" : "Glide"
	},
	{
		"skillId" : 3621,
		"skillName" : "Java Servlets"
	},
	{
		"skillId" : 1699,
		"skillName" : "Scala"
	},
	{
		"skillId" : 3614,
		"skillName" : "Github"
	},
	{
		"skillId" : 1632,
		"skillName" : "SQLAlchemy"
	},
	{
		"skillId" : 1866,
		"skillName" : "Hybrid app"
	},
	{
		"skillId" : 3633,
		"skillName" : "Ruby On Rails"
	},
	{
		"skillId" : 1868,
		"skillName" : "Ionic Creator"
	},
	{
		"skillId" : 1869,
		"skillName" : "jQuery Mobile"
	},
	{
		"skillId" : 1870,
		"skillName" : "Lottie"
	},
	{
		"skillId" : 3637,
		"skillName" : "CSS3"
	},
	{
		"skillId" : 1871,
		"skillName" : "Marmalade"
	},
	{
		"skillId" : 3624,
		"skillName" : "VCS"
	},
	{
		"skillId" : 3639,
		"skillName" : "Apex"
	},
	{
		"skillId" : 3685,
		"skillName" : "Chef"
	},
	{
		"skillId" : 3686,
		"skillName" : "Puppet"
	},
	{
		"skillId" : 3626,
		"skillName" : "JUnit5"
	},
	{
		"skillId" : 3688,
		"skillName" : "Terraform"
	},
	{
		"skillId" : 3627,
		"skillName" : "S3 Server"
	},
	{
		"skillId" : 3628,
		"skillName" : "NGINX Server"
	},
	{
		"skillId" : 3689,
		"skillName" : "Ansible"
	},
	{
		"skillId" : 3629,
		"skillName" : "LAMP Stack"
	},
	{
		"skillId" : 3708,
		"skillName" : "Bash"
	},
	{
		"skillId" : 3656,
		"skillName" : "Force.com Migration Tool"
	},
	{
		"skillId" : 3661,
		"skillName" : "Apex Data Loader"
	},
	{
		"skillId" : 3630,
		"skillName" : "MEAN Stack"
	},
	{
		"skillId" : 3631,
		"skillName" : "Express"
	},
	{
		"skillId" : 1872,
		"skillName" : "MLKit"
	},
	{
		"skillId" : 3676,
		"skillName" : "SwiftUI"
	},
	{
		"skillId" : 3680,
		"skillName" : "Autolayout"
	},
	{
		"skillId" : 1873,
		"skillName" : "PhoneGap"
	},
	{
		"skillId" : 3683,
		"skillName" : "CI\/CD"
	},
	{
		"skillId" : 3684,
		"skillName" : "Containerization"
	},
	{
		"skillId" : 3687,
		"skillName" : "Cloudformation"
	},
	{
		"skillId" : 3690,
		"skillName" : "S3"
	},
	{
		"skillId" : 3691,
		"skillName" : "EB"
	},
	{
		"skillId" : 3692,
		"skillName" : "Elastic Container Services"
	},
	{
		"skillId" : 3693,
		"skillName" : "Elastic Container Registry"
	},
	{
		"skillId" : 3694,
		"skillName" : "Apache Cloud"
	},
	{
		"skillId" : 3695,
		"skillName" : "Confluence"
	},
	{
		"skillId" : 3696,
		"skillName" : "Gitlab"
	},
	{
		"skillId" : 3697,
		"skillName" : "TestComplete"
	},
	{
		"skillId" : 3698,
		"skillName" : "TestingWhiz"
	},
	{
		"skillId" : 3699,
		"skillName" : "Nagios"
	},
	{
		"skillId" : 3700,
		"skillName" : "Zabbix"
	},
	{
		"skillId" : 3701,
		"skillName" : "Splunk"
	},
	{
		"skillId" : 3702,
		"skillName" : "Vagrant"
	},
	{
		"skillId" : 3703,
		"skillName" : "Cloud tools"
	},
	{
		"skillId" : 3704,
		"skillName" : "IAAS tools"
	},
	{
		"skillId" : 3705,
		"skillName" : "PAAS tools"
	},
	{
		"skillId" : 3706,
		"skillName" : "Serverless Tools"
	},
	{
		"skillId" : 3707,
		"skillName" : "Scripting"
	},
	{
		"skillId" : 3709,
		"skillName" : "BitBucket"
	},
	{
		"skillId" : 3710,
		"skillName" : "VSTS"
	},
	{
		"skillId" : 3711,
		"skillName" : "Mesos"
	},
	{
		"skillId" : 3712,
		"skillName" : "Swarm"
	},
	{
		"skillId" : 3713,
		"skillName" : "Octopus Deploy"
	},
	{
		"skillId" : 3714,
		"skillName" : "TeamCity"
	},
	{
		"skillId" : 3715,
		"skillName" : "Shell"
	},
	{
		"skillId" : 3716,
		"skillName" : "IBM CLoud"
	},
	{
		"skillId" : 3717,
		"skillName" : "APM"
	},
	{
		"skillId" : 3718,
		"skillName" : "New Relic"
	},
	{
		"skillId" : 3719,
		"skillName" : "AppDynamics"
	},
	{
		"skillId" : 3720,
		"skillName" : "Dynatrace"
	},
	{
		"skillId" : 3721,
		"skillName" : "Amazon CloudWatch"
	},
	{
		"skillId" : 3722,
		"skillName" : "AWS X-Ray"
	},
	{
		"skillId" : 3723,
		"skillName" : "Amazon SNS"
	},
	{
		"skillId" : 3724,
		"skillName" : "Amazon Elasticsearch Service"
	},
	{
		"skillId" : 3725,
		"skillName" : "Kibana"
	},
	{
		"skillId" : 3726,
		"skillName" : "syslog"
	},
	{
		"skillId" : 3727,
		"skillName" : "Logrotate"
	},
	{
		"skillId" : 3728,
		"skillName" : "Logstash"
	},
	{
		"skillId" : 3729,
		"skillName" : "Filebeat"
	},
	{
		"skillId" : 3730,
		"skillName" : "Prometheus"
	},
	{
		"skillId" : 3731,
		"skillName" : "Grafana"
	},
	{
		"skillId" : 3732,
		"skillName" : "IaC Tools"
	},
	{
		"skillId" : 3733,
		"skillName" : "Cloud Formation"
	},
	{
		"skillId" : 3734,
		"skillName" : "Pulumi"
	},
	{
		"skillId" : 3735,
		"skillName" : "AWS CDK"
	},
	{
		"skillId" : 3736,
		"skillName" : "SaltStack"
	},
	{
		"skillId" : 3737,
		"skillName" : "Powershell DSC"
	},
	{
		"skillId" : 3738,
		"skillName" : "Docker Engine"
	},
	{
		"skillId" : 3739,
		"skillName" : "Docker Swarm"
	},
	{
		"skillId" : 1874,
		"skillName" : "React Native"
	},
	{
		"skillId" : 1876,
		"skillName" : "Titanium"
	},
	{
		"skillId" : 1877,
		"skillName" : "Xamarin"
	},
	{
		"skillId" : 3641,
		"skillName" : "Lightning Component Framework"
	},
	{
		"skillId" : 3642,
		"skillName" : "CRM Software Package"
	},
	{
		"skillId" : 3644,
		"skillName" : "InterAction"
	},
	{
		"skillId" : 4342,
		"skillName" : "SWOT"
	},
	{
		"skillId" : 3740,
		"skillName" : "Systemd-nspawn"
	},
	{
		"skillId" : 3741,
		"skillName" : "LXC"
	},
	{
		"skillId" : 3742,
		"skillName" : "Ubuntu"
	},
	{
		"skillId" : 3743,
		"skillName" : "CentOS"
	},
	{
		"skillId" : 3744,
		"skillName" : "Amazon Linux"
	},
	{
		"skillId" : 3745,
		"skillName" : "ReHat Enterprise linux"
	},
	{
		"skillId" : 3746,
		"skillName" : "Windows"
	},
	{
		"skillId" : 3747,
		"skillName" : "Nginx"
	},
	{
		"skillId" : 3748,
		"skillName" : "AWS DynamoDB"
	},
	{
		"skillId" : 3749,
		"skillName" : "GNU utilities"
	},
	{
		"skillId" : 3750,
		"skillName" : "Cron"
	},
	{
		"skillId" : 3751,
		"skillName" : "AWS Lambda"
	},
	{
		"skillId" : 3752,
		"skillName" : "CVS"
	},
	{
		"skillId" : 3753,
		"skillName" : "Travis Circle CI"
	},
	{
		"skillId" : 3754,
		"skillName" : "Stash"
	},
	{
		"skillId" : 3755,
		"skillName" : "ELK Stack"
	},
	{
		"skillId" : 3756,
		"skillName" : "ITCAM"
	},
	{
		"skillId" : 4077,
		"skillName" : "Client Side Object Model"
	},
	{
		"skillId" : 4078,
		"skillName" : "CSOM"
	},
	{
		"skillId" : 1579,
		"skillName" : "Entity Framework"
	},
	{
		"skillId" : 1398,
		"skillName" : "ERB"
	},
	{
		"skillId" : 1721,
		"skillName" : "Erlang"
	},
	{
		"skillId" : 1399,
		"skillName" : "EventMachine"
	},
	{
		"skillId" : 1717,
		"skillName" : "ExUnit"
	},
	{
		"skillId" : 1591,
		"skillName" : "SSRS"
	},
	{
		"skillId" : 1630,
		"skillName" : "StatsModels"
	},
	{
		"skillId" : 1318,
		"skillName" : "Stencil.js"
	},
	{
		"skillId" : 1669,
		"skillName" : "STL"
	},
	{
		"skillId" : 1531,
		"skillName" : "Struts"
	},
	{
		"skillId" : 1530,
		"skillName" : "STS"
	},
	{
		"skillId" : 1592,
		"skillName" : "StyleCop"
	},
	{
		"skillId" : 4136,
		"skillName" : "SVN"
	},
	{
		"skillId" : 1533,
		"skillName" : "Swing"
	},
	{
		"skillId" : 1383,
		"skillName" : "Symfony"
	},
	{
		"skillId" : 1631,
		"skillName" : "SymPy"
	},
	{
		"skillId" : 1593,
		"skillName" : "Telerik DevCraft"
	},
	{
		"skillId" : 1670,
		"skillName" : "Template metaprogramming"
	},
	{
		"skillId" : 1469,
		"skillName" : "TestNG"
	},
	{
		"skillId" : 1633,
		"skillName" : "Theano"
	},
	{
		"skillId" : 1534,
		"skillName" : "Thymeleaf"
	},
	{
		"skillId" : 1384,
		"skillName" : "Tideways"
	},
	{
		"skillId" : 1535,
		"skillName" : "Tomcat"
	},
	{
		"skillId" : 1536,
		"skillName" : "TomEE"
	},
	{
		"skillId" : 1635,
		"skillName" : "Tornado"
	},
	{
		"skillId" : 1641,
		"skillName" : "TortoiseSVN"
	},
	{
		"skillId" : 1385,
		"skillName" : "Twig"
	},
	{
		"skillId" : 1636,
		"skillName" : "Twisted"
	},
	{
		"skillId" : 1386,
		"skillName" : "TYPO3"
	},
	{
		"skillId" : 1537,
		"skillName" : "UIMA"
	},
	{
		"skillId" : 1594,
		"skillName" : "Unsafe Code"
	},
	{
		"skillId" : 1538,
		"skillName" : "Vaadin"
	},
	{
		"skillId" : 1671,
		"skillName" : "Valgrind"
	},
	{
		"skillId" : 1672,
		"skillName" : "VBA"
	},
	{
		"skillId" : 1595,
		"skillName" : "VB.Net"
	},
	{
		"skillId" : 1741,
		"skillName" : "VBScript"
	},
	{
		"skillId" : 1742,
		"skillName" : "Verilog"
	},
	{
		"skillId" : 1637,
		"skillName" : "Virtualenv"
	},
	{
		"skillId" : 1596,
		"skillName" : "Visual C#"
	},
	{
		"skillId" : 1673,
		"skillName" : "Visual C++"
	},
	{
		"skillId" : 4109,
		"skillName" : "Tableau"
	},
	{
		"skillId" : 4097,
		"skillName" : "Visual Web part"
	},
	{
		"skillId" : 1725,
		"skillName" : "WADL"
	},
	{
		"skillId" : 1598,
		"skillName" : "WCF"
	},
	{
		"skillId" : 1539,
		"skillName" : "WebLogic"
	},
	{
		"skillId" : 1597,
		"skillName" : "WebMatrix"
	},
	{
		"skillId" : 1639,
		"skillName" : "web.py"
	},
	{
		"skillId" : 1540,
		"skillName" : "Wicket"
	},
	{
		"skillId" : 4072,
		"skillName" : "Administration"
	},
	{
		"skillId" : 4073,
		"skillName" : "Ado DotNet"
	},
	{
		"skillId" : 4074,
		"skillName" : "APPS"
	},
	{
		"skillId" : 4075,
		"skillName" : "ASP DotNet"
	},
	{
		"skillId" : 4076,
		"skillName" : "C Sharp"
	},
	{
		"skillId" : 4079,
		"skillName" : "Designer workflow"
	},
	{
		"skillId" : 4080,
		"skillName" : "ECMA Scripts"
	},
	{
		"skillId" : 1541,
		"skillName" : "WildFly"
	},
	{
		"skillId" : 4082,
		"skillName" : "Java Script"
	},
	{
		"skillId" : 1387,
		"skillName" : "WooCommerce"
	},
	{
		"skillId" : 4084,
		"skillName" : "MS Azure"
	},
	{
		"skillId" : 1388,
		"skillName" : "WordPress"
	},
	{
		"skillId" : 4086,
		"skillName" : "MS Visual Studio"
	},
	{
		"skillId" : 1599,
		"skillName" : "WPF"
	},
	{
		"skillId" : 4088,
		"skillName" : "PowerShell Script"
	},
	{
		"skillId" : 4089,
		"skillName" : "SharePoint 2013"
	},
	{
		"skillId" : 4090,
		"skillName" : "SharePoint Designer 2013"
	},
	{
		"skillId" : 4091,
		"skillName" : "SharePoint Framework"
	},
	{
		"skillId" : 4092,
		"skillName" : "SharePoint Online"
	},
	{
		"skillId" : 4093,
		"skillName" : "SharePoint Out of Box"
	},
	{
		"skillId" : 4094,
		"skillName" : "SPFx"
	},
	{
		"skillId" : 4095,
		"skillName" : "Timer Jobs"
	},
	{
		"skillId" : 4096,
		"skillName" : "Visual Studio Code"
	},
	{
		"skillId" : 4098,
		"skillName" : "Windows Server 2008 R2"
	},
	{
		"skillId" : 4099,
		"skillName" : "Windows XP"
	},
	{
		"skillId" : 4100,
		"skillName" : "Windows7"
	},
	{
		"skillId" : 4108,
		"skillName" : "ETL Talend"
	},
	{
		"skillId" : 4110,
		"skillName" : "VC++"
	},
	{
		"skillId" : 4111,
		"skillName" : "Net beans"
	},
	{
		"skillId" : 4112,
		"skillName" : "Network Simulator 2"
	},
	{
		"skillId" : 4130,
		"skillName" : "Java 8"
	},
	{
		"skillId" : 4131,
		"skillName" : "Java2ee"
	},
	{
		"skillId" : 4134,
		"skillName" : "Oracle ATG Commerce framework"
	},
	{
		"skillId" : 1809,
		"skillName" : "Xcode"
	},
	{
		"skillId" : 1790,
		"skillName" : "Objective-C"
	},
	{
		"skillId" : 1803,
		"skillName" : "Swift"
	},
	{
		"skillId" : 1773,
		"skillName" : "GCD"
	},
	{
		"skillId" : 4177,
		"skillName" : "MATLAB"
	},
	{
		"skillId" : 4135,
		"skillName" : "Hudson"
	},
	{
		"skillId" : 1500,
		"skillName" : "JSP"
	},
	{
		"skillId" : 1501,
		"skillName" : "JSTL"
	},
	{
		"skillId" : 4409,
		"skillName" : "VMWare"
	},
	{
		"skillId" : 3924,
		"skillName" : "DNS"
	},
	{
		"skillId" : 3925,
		"skillName" : "IoT"
	},
	{
		"skillId" : 3675,
		"skillName" : "Interface Builder"
	},
	{
		"skillId" : 3677,
		"skillName" : "Intunes"
	},
	{
		"skillId" : 3678,
		"skillName" : "CI Tools"
	},
	{
		"skillId" : 3679,
		"skillName" : "Bamboo"
	},
	{
		"skillId" : 3681,
		"skillName" : "MVVM"
	},
	{
		"skillId" : 4107,
		"skillName" : "Excel"
	},
	{
		"skillId" : 4113,
		"skillName" : "PMP Certification"
	},
	{
		"skillId" : 3926,
		"skillName" : "Firewalls and Security"
	},
	{
		"skillId" : 2113,
		"skillName" : "UAT"
	},
	{
		"skillId" : 2119,
		"skillName" : "White-box testing"
	},
	{
		"skillId" : 2120,
		"skillName" : "Xamarin.UITest"
	},
	{
		"skillId" : 2121,
		"skillName" : "XCUITest"
	},
	{
		"skillId" : 2122,
		"skillName" : "Zombie"
	},
	{
		"skillId" : 2123,
		"skillName" : "Website testing"
	},
	{
		"skillId" : 2126,
		"skillName" : "Mobile application testing"
	},
	{
		"skillId" : 2096,
		"skillName" : "Selenium"
	},
	{
		"skillId" : 2046,
		"skillName" : "Functional testing"
	},
	{
		"skillId" : 2053,
		"skillName" : "Integration testing"
	},
	{
		"skillId" : 2077,
		"skillName" : "Penetration testing"
	},
	{
		"skillId" : 3927,
		"skillName" : "Customer Relations"
	},
	{
		"skillId" : 4399,
		"skillName" : "OSPF"
	},
	{
		"skillId" : 4400,
		"skillName" : "Redhat"
	},
	{
		"skillId" : 4401,
		"skillName" : "RHEL"
	},
	{
		"skillId" : 4403,
		"skillName" : "Serverless Computing"
	},
	{
		"skillId" : 4404,
		"skillName" : "SolarWinds"
	},
	{
		"skillId" : 4405,
		"skillName" : "SUSE"
	},
	{
		"skillId" : 4407,
		"skillName" : "VDI"
	},
	{
		"skillId" : 4412,
		"skillName" : "VPC"
	},
	{
		"skillId" : 4413,
		"skillName" : "VSphere"
	},
	{
		"skillId" : 4414,
		"skillName" : "WAF"
	},
	{
		"skillId" : 4458,
		"skillName" : "Collibra"
	},
	{
		"skillId" : 4101,
		"skillName" : "MSSQL"
	},
	{
		"skillId" : 4102,
		"skillName" : "Power BI Desktop"
	},
	{
		"skillId" : 4103,
		"skillName" : "Power BI Service"
	},
	{
		"skillId" : 4104,
		"skillName" : "Postman API"
	},
	{
		"skillId" : 4105,
		"skillName" : "Python Scripts"
	},
	{
		"skillId" : 4106,
		"skillName" : "Share point"
	},
	{
		"skillId" : 3943,
		"skillName" : "MVP"
	},
	{
		"skillId" : 4114,
		"skillName" : "Salesforce"
	},
	{
		"skillId" : 3931,
		"skillName" : "ML Flow"
	},
	{
		"skillId" : 3928,
		"skillName" : "SD-branch Architecture"
	},
	{
		"skillId" : 4138,
		"skillName" : "Natural Language Processing"
	},
	{
		"skillId" : 3934,
		"skillName" : "Object Storage"
	},
	{
		"skillId" : 4139,
		"skillName" : "Clustering Algorithm"
	},
	{
		"skillId" : 3942,
		"skillName" : "Statistical Analysis"
	},
	{
		"skillId" : 4115,
		"skillName" : "Microsoft Office"
	},
	{
		"skillId" : 4132,
		"skillName" : "Spring Batch"
	},
	{
		"skillId" : 4133,
		"skillName" : "Spring Data"
	},
	{
		"skillId" : 4137,
		"skillName" : "Oracle Endeca"
	},
	{
		"skillId" : 4116,
		"skillName" : "Microsoft Project"
	},
	{
		"skillId" : 4117,
		"skillName" : "Project Scheduling"
	},
	{
		"skillId" : 4118,
		"skillName" : "Strategic Planning"
	},
	{
		"skillId" : 4119,
		"skillName" : "Subject Matter Expertise"
	},
	{
		"skillId" : 4120,
		"skillName" : "Project Lifecycle Management"
	},
	{
		"skillId" : 1948,
		"skillName" : "Relational DB"
	},
	{
		"skillId" : 4121,
		"skillName" : "Agile Software"
	},
	{
		"skillId" : 1888,
		"skillName" : "Database administration"
	},
	{
		"skillId" : 1889,
		"skillName" : "Apache Druid"
	},
	{
		"skillId" : 2001,
		"skillName" : "SOAP"
	},
	{
		"skillId" : 2115,
		"skillName" : "Unit testing"
	},
	{
		"skillId" : 1255,
		"skillName" : "jQuery"
	},
	{
		"skillId" : 3625,
		"skillName" : "Oracle"
	},
	{
		"skillId" : 3640,
		"skillName" : "Visualforce"
	},
	{
		"skillId" : 3648,
		"skillName" : "SOQL"
	},
	{
		"skillId" : 3649,
		"skillName" : "SOSL"
	},
	{
		"skillId" : 3664,
		"skillName" : "SoupUI"
	},
	{
		"skillId" : 3668,
		"skillName" : "Ember"
	},
	{
		"skillId" : 3672,
		"skillName" : "Aura"
	},
	{
		"skillId" : 1890,
		"skillName" : "Aerospike"
	},
	{
		"skillId" : 1891,
		"skillName" : "AllegroGraph"
	},
	{
		"skillId" : 1892,
		"skillName" : "CrateDB"
	},
	{
		"skillId" : 1906,
		"skillName" : "Data Pipeline"
	},
	{
		"skillId" : 4122,
		"skillName" : "Scrum Management"
	},
	{
		"skillId" : 4123,
		"skillName" : "Meeting Facilitation"
	},
	{
		"skillId" : 4124,
		"skillName" : "Financial Modelling"
	},
	{
		"skillId" : 4125,
		"skillName" : "Kanban"
	},
	{
		"skillId" : 4126,
		"skillName" : "Forecasting"
	},
	{
		"skillId" : 4127,
		"skillName" : "Lean Thinking"
	},
	{
		"skillId" : 4128,
		"skillName" : "Performance Tracking"
	},
	{
		"skillId" : 4129,
		"skillName" : "Budgeting"
	},
	{
		"skillId" : 4196,
		"skillName" : "Microcontrollers"
	},
	{
		"skillId" : 4197,
		"skillName" : "MCUs"
	},
	{
		"skillId" : 4198,
		"skillName" : "Microprocessors"
	},
	{
		"skillId" : 4187,
		"skillName" : "Artificial Neural Networks"
	},
	{
		"skillId" : 4199,
		"skillName" : "Linux Operating System"
	},
	{
		"skillId" : 4200,
		"skillName" : "Software Optimizations Skills"
	},
	{
		"skillId" : 4201,
		"skillName" : "Real-time Operating Systems or RTOS"
	},
	{
		"skillId" : 4202,
		"skillName" : "Device Drivers"
	},
	{
		"skillId" : 4203,
		"skillName" : "Assembly Programming Language"
	},
	{
		"skillId" : 4140,
		"skillName" : "Regression Algorithm"
	},
	{
		"skillId" : 4141,
		"skillName" : "Classification Algorithm"
	},
	{
		"skillId" : 4143,
		"skillName" : "Data Modeling"
	},
	{
		"skillId" : 4144,
		"skillName" : "Data Evaluation"
	},
	{
		"skillId" : 4145,
		"skillName" : "Naïve Bayes Classifier"
	},
	{
		"skillId" : 4146,
		"skillName" : "K Means Clustering"
	},
	{
		"skillId" : 4147,
		"skillName" : "Support Vector Machine"
	},
	{
		"skillId" : 4148,
		"skillName" : "Apriori Algorithm"
	},
	{
		"skillId" : 4149,
		"skillName" : "Linear Regression"
	},
	{
		"skillId" : 4150,
		"skillName" : "Logistic Regression"
	},
	{
		"skillId" : 4151,
		"skillName" : "Decision Trees"
	},
	{
		"skillId" : 4152,
		"skillName" : "Random Forests"
	},
	{
		"skillId" : 4153,
		"skillName" : "Supervised Machine Learning Algorithm"
	},
	{
		"skillId" : 4154,
		"skillName" : "Unsupervised Machine Learning Algorithm"
	},
	{
		"skillId" : 4217,
		"skillName" : "Microprocessor Technology"
	},
	{
		"skillId" : 4155,
		"skillName" : "Reinforcement Machine Learning Algorithm"
	},
	{
		"skillId" : 4157,
		"skillName" : "Scikit-learn"
	},
	{
		"skillId" : 4158,
		"skillName" : "TensorFlow"
	},
	{
		"skillId" : 4159,
		"skillName" : "Applied Mathematics"
	},
	{
		"skillId" : 4160,
		"skillName" : "Linear Algebra"
	},
	{
		"skillId" : 4161,
		"skillName" : "Probability"
	},
	{
		"skillId" : 4162,
		"skillName" : "Statistics"
	},
	{
		"skillId" : 4163,
		"skillName" : "Multivariate Calculus"
	},
	{
		"skillId" : 4164,
		"skillName" : "Poisson Distribution"
	},
	{
		"skillId" : 4165,
		"skillName" : "Normal Distribution"
	},
	{
		"skillId" : 4166,
		"skillName" : "Binomial Distribution"
	},
	{
		"skillId" : 4167,
		"skillName" : "Physics Concepts"
	},
	{
		"skillId" : 4230,
		"skillName" : "C Debugger"
	},
	{
		"skillId" : 4168,
		"skillName" : "Feedforward NN"
	},
	{
		"skillId" : 4169,
		"skillName" : "Recurrent NN"
	},
	{
		"skillId" : 4170,
		"skillName" : "Convolutional NN"
	},
	{
		"skillId" : 4171,
		"skillName" : "Modular NN"
	},
	{
		"skillId" : 4172,
		"skillName" : "Radial Basis Function NN"
	},
	{
		"skillId" : 4173,
		"skillName" : "Software Development Life Cycle"
	},
	{
		"skillId" : 4174,
		"skillName" : "Optimisation Algorithm"
	},
	{
		"skillId" : 4175,
		"skillName" : "Sorting Algorithm"
	},
	{
		"skillId" : 4176,
		"skillName" : "Searching Algorithm"
	},
	{
		"skillId" : 4193,
		"skillName" : "Restricted Boltzmann Machines(RBM)"
	},
	{
		"skillId" : 3939,
		"skillName" : "Numpy"
	},
	{
		"skillId" : 3940,
		"skillName" : "Pandas"
	},
	{
		"skillId" : 3944,
		"skillName" : "Power BI"
	},
	{
		"skillId" : 4204,
		"skillName" : "Hardware Test Equipments"
	},
	{
		"skillId" : 4205,
		"skillName" : "Oscilloscope"
	},
	{
		"skillId" : 4206,
		"skillName" : "Logic Analyzer"
	},
	{
		"skillId" : 4207,
		"skillName" : "I2C"
	},
	{
		"skillId" : 4208,
		"skillName" : "Serial Peripheral Interface or SPI"
	},
	{
		"skillId" : 4209,
		"skillName" : "USB"
	},
	{
		"skillId" : 3929,
		"skillName" : "ETL"
	},
	{
		"skillId" : 4210,
		"skillName" : "General-Purpose Input-Output or GPIOs"
	},
	{
		"skillId" : 3932,
		"skillName" : "Seldon"
	},
	{
		"skillId" : 3933,
		"skillName" : "Kubeflow"
	},
	{
		"skillId" : 4211,
		"skillName" : "Controller Area Network or CAN bus"
	},
	{
		"skillId" : 3936,
		"skillName" : "Tornodo"
	},
	{
		"skillId" : 3937,
		"skillName" : "Datawarehousing"
	},
	{
		"skillId" : 3938,
		"skillName" : "Hive"
	},
	{
		"skillId" : 3941,
		"skillName" : "Matplotilib"
	},
	{
		"skillId" : 4212,
		"skillName" : "Recommended Standard 232 - RS232"
	},
	{
		"skillId" : 4213,
		"skillName" : "One-Wire"
	},
	{
		"skillId" : 4214,
		"skillName" : "Recommended Standard 485 - RS485"
	},
	{
		"skillId" : 4216,
		"skillName" : "RISC-V Instruction Set Architecture"
	},
	{
		"skillId" : 4218,
		"skillName" : "GNU Project Debugger"
	},
	{
		"skillId" : 4219,
		"skillName" : "Multiprocessor Design"
	},
	{
		"skillId" : 4220,
		"skillName" : "Multi-Subsystem Issues"
	},
	{
		"skillId" : 4221,
		"skillName" : "Open-Source Software"
	},
	{
		"skillId" : 4222,
		"skillName" : "Unified Modeling Language"
	},
	{
		"skillId" : 4223,
		"skillName" : "Wireless Connectivity"
	},
	{
		"skillId" : 4224,
		"skillName" : "Wi-Fi"
	},
	{
		"skillId" : 4225,
		"skillName" : "Bluetooth Low Energy or BLE"
	},
	{
		"skillId" : 4294,
		"skillName" : "Point of Sale"
	},
	{
		"skillId" : 4295,
		"skillName" : "Mobile POS"
	},
	{
		"skillId" : 4296,
		"skillName" : "Warehouse Management System"
	},
	{
		"skillId" : 4297,
		"skillName" : "Order Management System"
	},
	{
		"skillId" : 4298,
		"skillName" : "Stock Management SCO"
	},
	{
		"skillId" : 4299,
		"skillName" : "APTOS ONE"
	},
	{
		"skillId" : 4300,
		"skillName" : "APTOS CRM Systems"
	},
	{
		"skillId" : 4301,
		"skillName" : "Handheld Systems"
	},
	{
		"skillId" : 4302,
		"skillName" : "Retail"
	},
	{
		"skillId" : 4303,
		"skillName" : "Payment System"
	},
	{
		"skillId" : 4304,
		"skillName" : "Email Receipt"
	},
	{
		"skillId" : 4305,
		"skillName" : "Tax"
	},
	{
		"skillId" : 4306,
		"skillName" : "SIM"
	},
	{
		"skillId" : 4307,
		"skillName" : "STOCK"
	},
	{
		"skillId" : 4308,
		"skillName" : "Peripheral Devices"
	},
	{
		"skillId" : 4309,
		"skillName" : "Sales Audit Servers"
	},
	{
		"skillId" : 4310,
		"skillName" : "Interface Files"
	},
	{
		"skillId" : 4311,
		"skillName" : "EOD"
	},
	{
		"skillId" : 4312,
		"skillName" : "Till Operations"
	},
	{
		"skillId" : 4313,
		"skillName" : "Manager Operations"
	},
	{
		"skillId" : 4314,
		"skillName" : "HHT"
	},
	{
		"skillId" : 4315,
		"skillName" : "Unity 3D"
	},
	{
		"skillId" : 4316,
		"skillName" : "Unreal Engine"
	},
	{
		"skillId" : 4317,
		"skillName" : "Blender"
	},
	{
		"skillId" : 4318,
		"skillName" : "Maya"
	},
	{
		"skillId" : 4319,
		"skillName" : "3DsMax"
	},
	{
		"skillId" : 4320,
		"skillName" : "3D Modeling Software"
	},
	{
		"skillId" : 4321,
		"skillName" : "Image Editing"
	},
	{
		"skillId" : 4322,
		"skillName" : "Photoshop"
	},
	{
		"skillId" : 4323,
		"skillName" : "GIMP"
	},
	{
		"skillId" : 4324,
		"skillName" : "App Store"
	},
	{
		"skillId" : 4325,
		"skillName" : "Play Store"
	},
	{
		"skillId" : 4226,
		"skillName" : "AI"
	},
	{
		"skillId" : 4227,
		"skillName" : "3D Design"
	},
	{
		"skillId" : 4228,
		"skillName" : "Graphical User Interfaces or GUI"
	},
	{
		"skillId" : 4229,
		"skillName" : "Embedded C"
	},
	{
		"skillId" : 4231,
		"skillName" : "Kernel Programming"
	},
	{
		"skillId" : 4232,
		"skillName" : "Electronic Circuit Board Design"
	},
	{
		"skillId" : 4233,
		"skillName" : "Arduino"
	},
	{
		"skillId" : 4234,
		"skillName" : "Raspberry PI"
	},
	{
		"skillId" : 4235,
		"skillName" : "AVR Microcontrolllers"
	},
	{
		"skillId" : 4236,
		"skillName" : "ARM Microcontrolllers"
	},
	{
		"skillId" : 4237,
		"skillName" : "UART"
	},
	{
		"skillId" : 4238,
		"skillName" : "Zigbee"
	},
	{
		"skillId" : 4239,
		"skillName" : "Eagle CAD"
	},
	{
		"skillId" : 4240,
		"skillName" : "Simulators"
	},
	{
		"skillId" : 4241,
		"skillName" : "Proteus"
	},
	{
		"skillId" : 4242,
		"skillName" : "Baremetal Coding"
	},
	{
		"skillId" : 1952,
		"skillName" : "RocksDB"
	},
	{
		"skillId" : 1953,
		"skillName" : "SAP MaxDB"
	},
	{
		"skillId" : 1954,
		"skillName" : "Snowflake"
	},
	{
		"skillId" : 1955,
		"skillName" : "Solr"
	},
	{
		"skillId" : 1956,
		"skillName" : "Spanner"
	},
	{
		"skillId" : 1957,
		"skillName" : "Sphinx"
	},
	{
		"skillId" : 1964,
		"skillName" : "T-SQL"
	},
	{
		"skillId" : 1965,
		"skillName" : "Teradata"
	},
	{
		"skillId" : 1966,
		"skillName" : "Toad"
	},
	{
		"skillId" : 4459,
		"skillName" : "Linux BSP"
	},
	{
		"skillId" : 1407,
		"skillName" : "RuboCop"
	},
	{
		"skillId" : 1667,
		"skillName" : "Rust"
	},
	{
		"skillId" : 4374,
		"skillName" : "AirFlow"
	},
	{
		"skillId" : 4378,
		"skillName" : "BigQuery"
	},
	{
		"skillId" : 4380,
		"skillName" : "CISCO Nexus"
	},
	{
		"skillId" : 4382,
		"skillName" : "Citrix"
	},
	{
		"skillId" : 4387,
		"skillName" : "CloudSQL"
	},
	{
		"skillId" : 4388,
		"skillName" : "CosmoDB"
	},
	{
		"skillId" : 4389,
		"skillName" : "Data Lakes"
	},
	{
		"skillId" : 4391,
		"skillName" : "Digital Ocean"
	},
	{
		"skillId" : 4392,
		"skillName" : "EIGRP"
	},
	{
		"skillId" : 4393,
		"skillName" : "EMC"
	},
	{
		"skillId" : 4394,
		"skillName" : "Glacier"
	},
	{
		"skillId" : 4395,
		"skillName" : "Hybrid Cloud"
	},
	{
		"skillId" : 4375,
		"skillName" : "Azure Blob"
	},
	{
		"skillId" : 4376,
		"skillName" : "Azure Queue"
	},
	{
		"skillId" : 4377,
		"skillName" : "Azure VM"
	},
	{
		"skillId" : 4379,
		"skillName" : "CGI"
	},
	{
		"skillId" : 4381,
		"skillName" : "CISSP "
	},
	{
		"skillId" : 4383,
		"skillName" : "CLI"
	},
	{
		"skillId" : 4384,
		"skillName" : "Cloud Composer"
	},
	{
		"skillId" : 4385,
		"skillName" : "Cloud Dataproc"
	},
	{
		"skillId" : 4386,
		"skillName" : "Cloud Scheduler"
	},
	{
		"skillId" : 4390,
		"skillName" : "DataFlow"
	},
	{
		"skillId" : 4398,
		"skillName" : "Network Security"
	},
	{
		"skillId" : 1184,
		"skillName" : "AJAX"
	},
	{
		"skillId" : 1235,
		"skillName" : "HTML5"
	},
	{
		"skillId" : 1886,
		"skillName" : "PipelineDB"
	},
	{
		"skillId" : 1911,
		"skillName" : "Dbf"
	},
	{
		"skillId" : 1912,
		"skillName" : "DynamoDB"
	},
	{
		"skillId" : 4457,
		"skillName" : "Cognos"
	},
	{
		"skillId" : 4406,
		"skillName" : "TCP-IP"
	},
	{
		"skillId" : 4461,
		"skillName" : "Business analysis"
	},
	{
		"skillId" : 4408,
		"skillName" : "Virtual Networks "
	},
	{
		"skillId" : 4462,
		"skillName" : "Google Cloud Rackspace"
	},
	{
		"skillId" : 4410,
		"skillName" : "VMware Cloud"
	},
	{
		"skillId" : 4411,
		"skillName" : "VMWare Horizon"
	},
	{
		"skillId" : 4463,
		"skillName" : "OpenStack"
	},
	{
		"skillId" : 4183,
		"skillName" : "PyTorch"
	},
	{
		"skillId" : 4184,
		"skillName" : "MXNet"
	},
	{
		"skillId" : 4415,
		"skillName" : "OLAP"
	},
	{
		"skillId" : 4416,
		"skillName" : "Power Pivot"
	},
	{
		"skillId" : 4417,
		"skillName" : "SSIS"
	},
	{
		"skillId" : 4418,
		"skillName" : "SSAS"
	},
	{
		"skillId" : 4419,
		"skillName" : "IIS"
	},
	{
		"skillId" : 4420,
		"skillName" : "Active Directory(AD)"
	},
	{
		"skillId" : 4421,
		"skillName" : "RDS"
	},
	{
		"skillId" : 4422,
		"skillName" : "Exchange Mail Server"
	},
	{
		"skillId" : 4423,
		"skillName" : "UX Research"
	},
	{
		"skillId" : 4424,
		"skillName" : "Visual Design"
	},
	{
		"skillId" : 4425,
		"skillName" : "User empathy"
	},
	{
		"skillId" : 4426,
		"skillName" : "Interaction Design"
	},
	{
		"skillId" : 4427,
		"skillName" : "Collaboration"
	},
	{
		"skillId" : 4428,
		"skillName" : "Information Architecture"
	},
	{
		"skillId" : 4429,
		"skillName" : "Wireframing"
	},
	{
		"skillId" : 4430,
		"skillName" : "UI Prototyping"
	},
	{
		"skillId" : 4431,
		"skillName" : "Branding"
	},
	{
		"skillId" : 4432,
		"skillName" : "Sketching"
	},
	{
		"skillId" : 4433,
		"skillName" : "Typography"
	},
	{
		"skillId" : 4434,
		"skillName" : "Responsive Designs"
	},
	{
		"skillId" : 4435,
		"skillName" : "Figma"
	},
	{
		"skillId" : 4436,
		"skillName" : "Sketch App"
	},
	{
		"skillId" : 4437,
		"skillName" : "Adobe XD"
	},
	{
		"skillId" : 4438,
		"skillName" : "Adobe Photoshop"
	},
	{
		"skillId" : 4439,
		"skillName" : "Adobe Illustrator"
	},
	{
		"skillId" : 4440,
		"skillName" : "Adobe Indesign"
	},
	{
		"skillId" : 4441,
		"skillName" : "Adobe AfterEffect"
	},
	{
		"skillId" : 4442,
		"skillName" : "InVision"
	},
	{
		"skillId" : 4443,
		"skillName" : "Marvel App"
	},
	{
		"skillId" : 4444,
		"skillName" : "Flinto"
	},
	{
		"skillId" : 4445,
		"skillName" : "Zeplin"
	},
	{
		"skillId" : 4446,
		"skillName" : "Sigma"
	},
	{
		"skillId" : 4447,
		"skillName" : "THEOplayer"
	},
	{
		"skillId" : 4448,
		"skillName" : "Azure Media Services"
	},
	{
		"skillId" : 4449,
		"skillName" : "Azure CDN"
	},
	{
		"skillId" : 4450,
		"skillName" : "DRM"
	},
	{
		"skillId" : 4451,
		"skillName" : "Software Testing"
	},
	{
		"skillId" : 1914,
		"skillName" : "Event Store"
	},
	{
		"skillId" : 1915,
		"skillName" : "Firebird"
	},
	{
		"skillId" : 4396,
		"skillName" : "Informatica"
	},
	{
		"skillId" : 4397,
		"skillName" : "LDAP"
	},
	{
		"skillId" : 4402,
		"skillName" : "SDK"
	},
	{
		"skillId" : 4186,
		"skillName" : "Deep Neural Networks"
	},
	{
		"skillId" : 4188,
		"skillName" : "Recurrent Neural Networks"
	},
	{
		"skillId" : 4189,
		"skillName" : "Convolutional Networks"
	},
	{
		"skillId" : 4190,
		"skillName" : "Autoencoders"
	},
	{
		"skillId" : 4191,
		"skillName" : "Robotic Process Automation"
	},
	{
		"skillId" : 4192,
		"skillName" : "Big Data Analytics"
	},
	{
		"skillId" : 4194,
		"skillName" : "ADAM Adagrad"
	},
	{
		"skillId" : 4195,
		"skillName" : "Momentum"
	},
	{
		"skillId" : 4354,
		"skillName" : "TargetProcess"
	},
	{
		"skillId" : 4355,
		"skillName" : "Planbox"
	},
	{
		"skillId" : 4356,
		"skillName" : "VersionOne"
	},
	{
		"skillId" : 4351,
		"skillName" : "Business Model Analysis"
	},
	{
		"skillId" : 4482,
		"skillName" : "SAFe Agile"
	},
	{
		"skillId" : 4508,
		"skillName" : "Avaya products"
	},
	{
		"skillId" : 4472,
		"skillName" : "Azure DevOps"
	},
	{
		"skillId" : 4473,
		"skillName" : "Salt"
	},
	{
		"skillId" : 4474,
		"skillName" : "PowerShell"
	},
	{
		"skillId" : 4475,
		"skillName" : "Azure SQL"
	},
	{
		"skillId" : 4476,
		"skillName" : "Azure Data Lake"
	},
	{
		"skillId" : 3935,
		"skillName" : "Flask"
	},
	{
		"skillId" : 4326,
		"skillName" : "Time Management"
	},
	{
		"skillId" : 4327,
		"skillName" : "Facilitation"
	},
	{
		"skillId" : 4328,
		"skillName" : "Problem Solving"
	},
	{
		"skillId" : 4329,
		"skillName" : "Analytical Thinking"
	},
	{
		"skillId" : 4330,
		"skillName" : "Stakeholder Analysis"
	},
	{
		"skillId" : 4331,
		"skillName" : "Leadership"
	},
	{
		"skillId" : 4332,
		"skillName" : "Management"
	},
	{
		"skillId" : 4333,
		"skillName" : "Requirements Engineering"
	},
	{
		"skillId" : 4334,
		"skillName" : "Costs Benefit Analysis"
	},
	{
		"skillId" : 4335,
		"skillName" : "Processes Modeling"
	},
	{
		"skillId" : 4336,
		"skillName" : "SAS"
	},
	{
		"skillId" : 4337,
		"skillName" : "SPSS"
	},
	{
		"skillId" : 4338,
		"skillName" : "STATA"
	},
	{
		"skillId" : 4339,
		"skillName" : "Data Visualization"
	},
	{
		"skillId" : 4340,
		"skillName" : "Blueprint"
	},
	{
		"skillId" : 4341,
		"skillName" : "MS Visio"
	},
	{
		"skillId" : 3682,
		"skillName" : "Google Cloud"
	},
	{
		"skillId" : 4343,
		"skillName" : "Trello"
	},
	{
		"skillId" : 4344,
		"skillName" : "BPM"
	},
	{
		"skillId" : 4345,
		"skillName" : "Data Munging"
	},
	{
		"skillId" : 4346,
		"skillName" : "Sage"
	},
	{
		"skillId" : 4347,
		"skillName" : "Mathematica"
	},
	{
		"skillId" : 4348,
		"skillName" : "MOST Analysis"
	},
	{
		"skillId" : 4349,
		"skillName" : "System Analysis"
	},
	{
		"skillId" : 4350,
		"skillName" : "PESTLE Analysis"
	},
	{
		"skillId" : 4352,
		"skillName" : "FogBugz"
	},
	{
		"skillId" : 4353,
		"skillName" : "Rally"
	},
	{
		"skillId" : 4509,
		"skillName" : "Avaya Aura"
	},
	{
		"skillId" : 4510,
		"skillName" : "SIP\/H.323 protocols"
	},
	{
		"skillId" : 4511,
		"skillName" : "ERS"
	},
	{
		"skillId" : 4512,
		"skillName" : "SR"
	},
	{
		"skillId" : 1916,
		"skillName" : "GraphDB"
	},
	{
		"skillId" : 1917,
		"skillName" : "HANA"
	},
	{
		"skillId" : 1918,
		"skillName" : "InfluxDB"
	},
	{
		"skillId" : 1919,
		"skillName" : "InterBase"
	},
	{
		"skillId" : 1921,
		"skillName" : "Liquibase"
	},
	{
		"skillId" : 1923,
		"skillName" : "MemSQL"
	},
	{
		"skillId" : 1925,
		"skillName" : "MS Access"
	},
	{
		"skillId" : 1928,
		"skillName" : "Navicat"
	},
	{
		"skillId" : 1935,
		"skillName" : "OTBI"
	},
	{
		"skillId" : 1936,
		"skillName" : "OrientDB"
	},
	{
		"skillId" : 3558,
		"skillName" : "Unix"
	},
	{
		"skillId" : 1947,
		"skillName" : "Redshift"
	},
	{
		"skillId" : 1949,
		"skillName" : "RethinkDB"
	},
	{
		"skillId" : 1950,
		"skillName" : "Riak"
	},
	{
		"skillId" : 1932,
		"skillName" : "Object-related mapping (ORM)"
	},
	{
		"skillId" : 1934,
		"skillName" : "ORD"
	},
	{
		"skillId" : 1943,
		"skillName" : "Primary Key"
	},
	{
		"skillId" : 1962,
		"skillName" : "Sqlmap"
	},
	{
		"skillId" : 1893,
		"skillName" : "DBMS"
	},
	{
		"skillId" : 1939,
		"skillName" : "PL\/SQL"
	},
	{
		"skillId" : 1999,
		"skillName" : "XML"
	},
	{
		"skillId" : 1903,
		"skillName" : "CRUD"
	},
	{
		"skillId" : 1904,
		"skillName" : "CSV"
	},
	{
		"skillId" : 1913,
		"skillName" : "EnterpriseDB"
	},
	{
		"skillId" : 4477,
		"skillName" : "HD Insights"
	},
	{
		"skillId" : 4478,
		"skillName" : "Azure Stream Analytics"
	},
	{
		"skillId" : 4481,
		"skillName" : "Azure ML"
	},
	{
		"skillId" : 1219,
		"skillName" : "Electron"
	},
	{
		"skillId" : 1222,
		"skillName" : "ExtJS"
	},
	{
		"skillId" : 1408,
		"skillName" : "Ruby"
	},
	{
		"skillId" : 1646,
		"skillName" : "C++"
	},
	{
		"skillId" : 3603,
		"skillName" : "MERN Stack"
	},
	{
		"skillId" : 3610,
		"skillName" : "Jenkins"
	},
	{
		"skillId" : 1296,
		"skillName" : "TypeScript"
	},
	{
		"skillId" : 3548,
		"skillName" : "Web Development"
	},
	{
		"skillId" : 3549,
		"skillName" : "Smart Contracts"
	},
	{
		"skillId" : 1168,
		"skillName" : "CSS"
	},
	{
		"skillId" : 3594,
		"skillName" : "Json"
	},
	{
		"skillId" : 3553,
		"skillName" : "P2P networks"
	},
	{
		"skillId" : 3555,
		"skillName" : "Hyperledger"
	},
	{
		"skillId" : 3556,
		"skillName" : "EOS"
	},
	{
		"skillId" : 3557,
		"skillName" : "SE\/SSE\/TL"
	},
	{
		"skillId" : 1169,
		"skillName" : "HTML"
	},
	{
		"skillId" : 3559,
		"skillName" : "Openshift"
	},
	{
		"skillId" : 3560,
		"skillName" : "Swaps"
	},
	{
		"skillId" : 3561,
		"skillName" : "Memory Management"
	},
	{
		"skillId" : 3562,
		"skillName" : "Transaction Management"
	},
	{
		"skillId" : 3563,
		"skillName" : "SIDE"
	},
	{
		"skillId" : 3564,
		"skillName" : "PDF"
	},
	{
		"skillId" : 3567,
		"skillName" : "Network Testing"
	},
	{
		"skillId" : 3568,
		"skillName" : "Mining"
	},
	{
		"skillId" : 3569,
		"skillName" : "Concept Design"
	},
	{
		"skillId" : 3570,
		"skillName" : "Usage"
	},
	{
		"skillId" : 3571,
		"skillName" : "Application Support"
	},
	{
		"skillId" : 3572,
		"skillName" : "Deployment"
	},
	{
		"skillId" : 3573,
		"skillName" : "Solidity"
	},
	{
		"skillId" : 3574,
		"skillName" : "Web3.js"
	},
	{
		"skillId" : 3578,
		"skillName" : "Advanced Java"
	},
	{
		"skillId" : 3580,
		"skillName" : "Manager Technology"
	},
	{
		"skillId" : 3581,
		"skillName" : "Sawtooth"
	},
	{
		"skillId" : 3582,
		"skillName" : "Cloud"
	},
	{
		"skillId" : 1365,
		"skillName" : "Laravel"
	},
	{
		"skillId" : 3586,
		"skillName" : "Codebases"
	},
	{
		"skillId" : 3587,
		"skillName" : "Tron"
	},
	{
		"skillId" : 3588,
		"skillName" : "Scalability"
	},
	{
		"skillId" : 3589,
		"skillName" : "Corda"
	},
	{
		"skillId" : 3595,
		"skillName" : "Design Patterns"
	},
	{
		"skillId" : 3592,
		"skillName" : "Decentralized Finance"
	},
	{
		"skillId" : 3590,
		"skillName" : "Truffle"
	},
	{
		"skillId" : 3605,
		"skillName" : "JIRA"
	},
	{
		"skillId" : 3596,
		"skillName" : "Fullstack"
	},
	{
		"skillId" : 1313,
		"skillName" : "C"
	},
	{
		"skillId" : 3598,
		"skillName" : "Front End"
	},
	{
		"skillId" : 3599,
		"skillName" : "Cryptocurrency"
	},
	{
		"skillId" : 3600,
		"skillName" : "SDLC"
	},
	{
		"skillId" : 3601,
		"skillName" : "Maintenance"
	},
	{
		"skillId" : 3602,
		"skillName" : "ZooKeeper"
	},
	{
		"skillId" : 3607,
		"skillName" : "QT"
	},
	{
		"skillId" : 3608,
		"skillName" : "Chain Code Lifecycle"
	},
	{
		"skillId" : 1881,
		"skillName" : "Spark SQL"
	},
	{
		"skillId" : 1711,
		"skillName" : "Go"
	},
	{
		"skillId" : 1885,
		"skillName" : "Key-Value Database"
	},
	{
		"skillId" : 1898,
		"skillName" : "Big Table"
	},
	{
		"skillId" : 1931,
		"skillName" : "NoSQL databases"
	},
	{
		"skillId" : 3617,
		"skillName" : "Rest"
	},
	{
		"skillId" : 3643,
		"skillName" : "Microsoft CRM"
	},
	{
		"skillId" : 3645,
		"skillName" : "SalesLogix"
	},
	{
		"skillId" : 3650,
		"skillName" : "Force.com IDE"
	},
	{
		"skillId" : 3652,
		"skillName" : "XP\/SCRUM"
	},
	{
		"skillId" : 1390,
		"skillName" : "Yii"
	},
	{
		"skillId" : 3597,
		"skillName" : "Bitcoin"
	},
	{
		"skillId" : 3653,
		"skillName" : "Eclipse IDE"
	},
	{
		"skillId" : 3654,
		"skillName" : "Talend Open Studio"
	},
	{
		"skillId" : 2008,
		"skillName" : "Docker"
	},
	{
		"skillId" : 3655,
		"skillName" : "O\/R Mapping"
	},
	{
		"skillId" : 3657,
		"skillName" : "SOA"
	},
	{
		"skillId" : 3658,
		"skillName" : "Metadata APIs"
	},
	{
		"skillId" : 1324,
		"skillName" : "Express.js"
	},
	{
		"skillId" : 1982,
		"skillName" : "AWS"
	},
	{
		"skillId" : 3659,
		"skillName" : "Data Migration"
	},
	{
		"skillId" : 1464,
		"skillName" : "Hibernate"
	},
	{
		"skillId" : 1528,
		"skillName" : "Spring MVC"
	},
	{
		"skillId" : 3660,
		"skillName" : "Marketo & Zuora"
	},
	{
		"skillId" : 2009,
		"skillName" : "Kubernetes"
	},
	{
		"skillId" : 3579,
		"skillName" : "Agile"
	},
	{
		"skillId" : 1930,
		"skillName" : "NoSQL"
	},
	{
		"skillId" : 3552,
		"skillName" : "Data Structures"
	},
	{
		"skillId" : 1899,
		"skillName" : "Cassandra"
	},
	{
		"skillId" : 3583,
		"skillName" : "Azure"
	},
	{
		"skillId" : 3662,
		"skillName" : "Workbench"
	},
	{
		"skillId" : 3663,
		"skillName" : "Mavensmate"
	},
	{
		"skillId" : 3665,
		"skillName" : "App Builder"
	},
	{
		"skillId" : 3666,
		"skillName" : "Platform Developer I"
	},
	{
		"skillId" : 3667,
		"skillName" : "Platform Developer II"
	},
	{
		"skillId" : 1581,
		"skillName" : "ADO.NET"
	},
	{
		"skillId" : 1643,
		"skillName" : "ASIO"
	},
	{
		"skillId" : 1707,
		"skillName" : "Beego"
	},
	{
		"skillId" : 3669,
		"skillName" : "Native"
	},
	{
		"skillId" : 3670,
		"skillName" : "SFDC"
	},
	{
		"skillId" : 3673,
		"skillName" : "Triggers"
	},
	{
		"skillId" : 3674,
		"skillName" : "QA"
	},
	{
		"skillId" : 1674,
		"skillName" : "Visual Studio"
	},
	{
		"skillId" : 1882,
		"skillName" : "JSONB"
	},
	{
		"skillId" : 1926,
		"skillName" : "MS SQL Server"
	},
	{
		"skillId" : 1944,
		"skillName" : "RDBMS"
	},
	{
		"skillId" : 1908,
		"skillName" : "Database Design"
	},
	{
		"skillId" : 1909,
		"skillName" : "Database development"
	},
	{
		"skillId" : 1910,
		"skillName" : "DB2"
	},
	{
		"skillId" : 1937,
		"skillName" : "Percona DB"
	},
	{
		"skillId" : 1967,
		"skillName" : "Voldemort"
	},
	{
		"skillId" : 1894,
		"skillName" : "Azure Cosmos DB"
	},
	{
		"skillId" : 1895,
		"skillName" : "ArangoDB"
	},
	{
		"skillId" : 1896,
		"skillName" : "AWR"
	},
	{
		"skillId" : 1897,
		"skillName" : "Berkeley DB"
	},
	{
		"skillId" : 1900,
		"skillName" : "CockroachDB"
	},
	{
		"skillId" : 1887,
		"skillName" : "RDMS"
	},
	{
		"skillId" : 1938,
		"skillName" : "PervasiveSQL"
	},
	{
		"skillId" : 1933,
		"skillName" : "Oracle Database"
	},
	{
		"skillId" : 1942,
		"skillName" : "Presto"
	},
	{
		"skillId" : 1945,
		"skillName" : "Database migration"
	},
	{
		"skillId" : 1941,
		"skillName" : "PostgreSQL"
	},
	{
		"skillId" : 1961,
		"skillName" : "SQLite"
	},
	{
		"skillId" : 1922,
		"skillName" : "MariaDB"
	},
	{
		"skillId" : 1901,
		"skillName" : "CouchBase"
	},
	{
		"skillId" : 1902,
		"skillName" : "CouchDB"
	},
	{
		"skillId" : 1924,
		"skillName" : "MongoDB"
	},
	{
		"skillId" : 1927,
		"skillName" : "MySQL"
	},
	{
		"skillId" : 1958,
		"skillName" : "SQL"
	},
	{
		"skillId" : 1640,
		"skillName" : "wxPython"
	},
	{
		"skillId" : 1675,
		"skillName" : "wxWidgets"
	},
	{
		"skillId" : 1389,
		"skillName" : "XDebug"
	},
	{
		"skillId" : 1743,
		"skillName" : "Xtend"
	},
	{
		"skillId" : 1600,
		"skillName" : "xUnit.net"
	},
	{
		"skillId" : 1391,
		"skillName" : "Zend Framework"
	},
	{
		"skillId" : 1676,
		"skillName" : "ZeroMQ"
	},
	{
		"skillId" : 1542,
		"skillName" : "ZK"
	},
	{
		"skillId" : 1543,
		"skillName" : "ZXing"
	},
	{
		"skillId" : 1331,
		"skillName" : "Node.js"
	},
	{
		"skillId" : 1278,
		"skillName" : "ReactJS"
	},
	{
		"skillId" : 3606,
		"skillName" : "AngularJS"
	},
	{
		"skillId" : 4531,
		"skillName" : "Other"
	},
	{
		"skillId" : 2501,
		"skillName" : "TSQL development"
	},
	{
		"skillId" : 1678,
		"skillName" : "C language"
	},
	{
		"skillId" : 1778,
		"skillName" : "iOS frameworks"
	},
	{
		"skillId" : 1951,
		"skillName" : "ETL (Extract, Transform and Load)"
	},
	{
		"skillId" : 2174,
		"skillName" : "Mongo DB"
	},
	{
		"skillId" : 2177,
		"skillName" : "Unix Command Line"
	},
	{
		"skillId" : 2178,
		"skillName" : "Agile Development"
	},
	{
		"skillId" : 2179,
		"skillName" : "Research Skills"
	},
	{
		"skillId" : 2404,
		"skillName" : "Oracle On-Demand"
	},
	{
		"skillId" : 2515,
		"skillName" : "Heroku"
	},
	{
		"skillId" : 2596,
		"skillName" : "goodd"
	},
	{
		"skillId" : 2622,
		"skillName" : "datagrip"
	},
	{
		"skillId" : 2000,
		"skillName" : "TM1"
	},
	{
		"skillId" : 2700,
		"skillName" : "Data Extraction"
	},
	{
		"skillId" : 2710,
		"skillName" : "ATG"
	},
	{
		"skillId" : 2711,
		"skillName" : "Oracle Commerce tech stack"
	},
	{
		"skillId" : 2712,
		"skillName" : "unity"
	},
	{
		"skillId" : 2409,
		"skillName" : "ETL Tools"
	},
	{
		"skillId" : 2159,
		"skillName" : "win32"
	},
	{
		"skillId" : 2715,
		"skillName" : "java 11"
	},
	{
		"skillId" : 2716,
		"skillName" : "HAL"
	},
	{
		"skillId" : 2717,
		"skillName" : "ROR"
	},
	{
		"skillId" : 2718,
		"skillName" : "Spring Cloud"
	},
	{
		"skillId": 4543,
		"skillName": "Project Management"
	},
	{
		"skillId": 4544,
		"skillName": "Delivery"
	},
	{
		"skillId": 4544,
		"skillName": "ITL"
	},
	{
		"skillId": 4546 ,
		"skillName": "Unity Developer"
	}
]
